// This file is generated by
// services/coaches/cmd/school_picker/generate_typescript.
// Do not edit directly.

// Map of ISO-3166-2 codes to the names of admin level one entities.
export const ADMIN_LEVEL_ONE_CODES_TO_NAMES: Record<string, string> = {
    AN: "ANDAMAN \u0026 NICOBAR ISLANDS",
    AP: "ANDHRA PRADESH",
    AR: "ARUNACHAL PRADESH",
    AS: "ASSAM",
    BR: "BIHAR",
    CH: "CHANDIGARH",
    CT: "CHHATTISGARH",
    DH: "DADRA \u0026 NAGAR HAVELI AND DAMAN \u0026 DIU",
    DL: "DELHI",
    GA: "GOA",
    GJ: "GUJARAT",
    HP: "HIMACHAL PRADESH",
    HR: "HARYANA",
    JH: "JHARKHAND",
    JK: "JAMMU \u0026 KASHMIR",
    KA: "KARNATAKA",
    KL: "KERALA",
    LA: "LADAKH",
    LD: "LAKSHADWEEP",
    MH: "MAHARASHTRA",
    ML: "MEGHALAYA",
    MN: "MANIPUR",
    MP: "MADHYA PRADESH",
    MZ: "MIZORAM",
    NL: "NAGALAND",
    OR: "ODISHA",
    PB: "PUNJAB",
    PY: "PUDUCHERRY",
    RJ: "RAJASTHAN",
    SK: "SIKKIM",
    TG: "TELANGANA",
    TN: "TAMILNADU",
    TR: "TRIPURA",
    UP: "UTTAR PRADESH",
    UT: "UTTARAKHAND",
    WB: "WEST BENGAL",
};

// Map of the administrative levels used in country.
//
// Level 1 is keyed by ISO-3166-2 code.
// Level 2 is keyed by the names of admin-level-two entities.
// Level 3 contains the names of localities.
export const ADMIN_LEVELS: Record<string, Record<string, string[]>> = {
    AN: {
        ANDAMANS: [
            "BRC- SOUTH ANDAMAN",
            "BRC- WIMBERLYGUNJ",
            "BRC-LITTLE ANDAMAN",
        ],
        "MIDDLE AND NORTH ANDAMANS": [
            "BRC- DIGLIPUR",
            "BRC- MAYABUNDER",
            "BRC- RANGAT",
        ],
        NICOBARS: ["CAMPBELL BAY", "CAR NICOBAR", "NANCOWRY"],
    },
    AP: {
        ANAKAPALLI: [
            "ANAKAPALLI",
            "ATCHUTAPURAM",
            "BUTCHIAHPETA",
            "CHEEDIKADA",
            "CHODAVARAM",
            "DEVARAPALLI",
            "GOLUGONDA",
            "K.KOTAPADU",
            "KASIMKOTA",
            "KOTAURATLA",
            "MAKAVARAPALEM",
            "MUNAGAPAKA",
            "NAKKAPALLI",
            "NARASIPATNAM",
            "NATHAVARAM",
            "PARAWADA",
            "PAYAKARAOPETA",
            "RAMBILLI",
            "RAVIKAMATHAM",
            "ROLUGUNTA",
            "S.RAYAVARAM",
            "SABBAVARAM",
            "V.MADUGULA",
            "YELLAMANCHILI",
        ],
        ANANTAPUR: [
            "ANANTAPUR",
            "ATMAKUR",
            "BELUGUPPA",
            "BOMMANAHAL",
            "BRAHMASAMUDRAM",
            "BUKKARAYASAMUDRAM",
            "D.HIREHAL",
            "GARLADINNE",
            "GOOTY",
            "GUMMAGATA",
            "GUNTAKAL",
            "KALYANDRUG",
            "KAMBADUR",
            "KANEKAL",
            "KUDAIR",
            "KUNDURPI",
            "NARPALA",
            "PAMIDI",
            "PEDDAPAPPUR",
            "PEDDAVADUGUR",
            "PUTLUR",
            "RAPTADU",
            "RAYADURG",
            "SETTUR",
            "SINGANAMALA",
            "TADPATRI",
            "URAVAKONDA",
            "VAJRAKARUR",
            "VIDAPANAKAL",
            "YADIKI",
            "YELLANUR",
        ],
        ANNAMAYYA: [
            "B.KOTHAKOTA",
            "CHINNAMANDEM",
            "CHITVEL",
            "GALIVEEDU",
            "GURRAMKONDA",
            "K.V.PALLE",
            "KALAKADA",
            "KALIKIRI",
            "KODUR",
            "KURABALAKOTA",
            "L.R.PALLI",
            "MADANAPALLE",
            "MULAKALACHERUVU",
            "NANDALUR",
            "NIMMANAPALLE",
            "OBULAVARIPALLI",
            "PEDDAMANDYAM",
            "PEDDATHIPPA SAMUDRAM",
            "PENAGALUR",
            "PILER",
            "PULLAMPET",
            "RAJAMPET",
            "RAMAPURAM",
            "RAMASAMUDRAM",
            "RAYACHOTY",
            "SAMBEPALLI",
            "T SUNDUPALLI",
            "THAMBALLAPALLE",
            "VAYALPAD",
            "VEERABALLI",
        ],
        ASR: [
            "ADDATEEGALA",
            "ANANTHAGIRI",
            "ARAKUVALLEY",
            "CHINTAPALLI",
            "CHINTUR",
            "DEVIPATNAM",
            "DUMBRIGUDA",
            "G.K.VEEDHI",
            "G.MADUGULA",
            "GANGAVARAM",
            "HUKUMPETA",
            "KOYYURU",
            "KUNAVARAM",
            "MAREDUMILLI",
            "MUNCHINGPUT",
            "NELLIPAKA",
            "PADERU",
            "PEDABAYALU",
            "RAJAVOMMANGI",
            "RAMPACHODAVARAM",
            "V.R.PURAM",
            "Y.RAMAVARAM",
        ],
        BAPATLA: [
            "ADDANKI",
            "AMRUTHALURU",
            "BALLIKURAVA",
            "BAPATLA",
            "BATTIPROLU",
            "CHERUKUPALLE",
            "CHINAGANGAM",
            "CHIRALA",
            "INKOLLU",
            "J.PANGULURU",
            "KARAMCHEDU",
            "KARLAPALEM",
            "KOLLURU",
            "KORISAPADU",
            "MARTURU",
            "NAGARAM",
            "NIZAMPATNAM",
            "PARCHURU",
            "PITTALAVANIPALEM",
            "REPALLE",
            "SANTHAMAGULURU",
            "TSUNDUR",
            "VEMURU",
            "VETAPALEM",
            "YEDDANAPUDI",
        ],
        CHITTOOR: [
            "BAIREDDIPALLE",
            "BANGARUPALEM",
            "CHITTOOR",
            "CHOWDEPALLE",
            "GANGADHARANELLORE",
            "GANGAVARAM",
            "GUDIPALA",
            "GUDUPALLE",
            "IRALA",
            "KARVETINAGAR",
            "KUPPAM",
            "NAGARI",
            "NINDRA",
            "PALAMANER",
            "PALASAMUDRAM",
            "PEDDAPANJANI",
            "PENUMUR",
            "PULICHERLA",
            "PUNGANUR",
            "PUTHALAPATTU",
            "RAMAKUPPAM",
            "ROMPICHERLA",
            "S.R.PURAM",
            "SANTHIPURAM",
            "SODAM",
            "SOMALA",
            "THAVANAMPALLE",
            "V.KOTA",
            "VEDURUKUPPAM",
            "VIJAYAPURAM",
            "YADAMARI",
        ],
        "EAST GODAVARI": [
            "ANAPARTHI",
            "BICCAVOLU",
            "CHAGALLU",
            "DEVARAPALLI",
            "GOKAVARAM",
            "GOPALAPURAM",
            "KADIAM",
            "KORUKONDA",
            "KOVVUR",
            "NALLAJERLA",
            "NIDADAVOLE",
            "PERAVALI",
            "RAJAMAHENDRAVARAM(RURAL)",
            "RAJAMAHENDRAVARAM(URBAN)",
            "RAJANAGARAM",
            "RANGAMPETA",
            "SEETHANAGARAM",
            "TALLAPUDI",
            "UNDRAJAVARAM",
        ],
        ELURU: [
            "AGIRIPALLI",
            "BHIMADOLE",
            "BUTTAIGUDEM",
            "CHATRAI",
            "CHINTALAPUDI",
            "DENDULURU",
            "DWARAKATIRUMALA",
            "ELURU",
            "GANAPAVARAM",
            "JANGAREDDYGUDEM",
            "JEELUGUMILLI",
            "KAIKALURU",
            "KALIDINDI",
            "KAMAVARAPUKOTA",
            "KOYYALAGUDEM",
            "KUKUNOOR",
            "LINGAPALEM",
            "MANDAVALLI",
            "MUDINEPALLI",
            "MUSUNURU",
            "NIDAMARRU",
            "NUZVID",
            "PEDAPADU",
            "PEDAVEGI",
            "POLAVARAM",
            "T.NARSAPURAM",
            "UNGUTURU",
            "VELAIRPADU",
        ],
        GUNTUR: [
            "CHEBROLU",
            "DUGGIRALA",
            "GUNTUR",
            "KAKUMANU",
            "KOLLIPARA",
            "MANGALAGIRI",
            "MEDIKONDURU",
            "PEDAKAKANI",
            "PEDANANDIPADU",
            "PHIRANGIPURAM",
            "PONNURU",
            "PRATHIPADU",
            "TADIKONDA",
            "TENALI",
            "THADEPALLE",
            "THULLUR",
            "VATTICHERUKURU",
        ],
        KADAPA: [
            "ATLUR",
            "B.KODUR",
            "B.MATTAM",
            "BADVEL",
            "C.K.DINNE",
            "CHAKRAYAPET",
            "CHAPADU",
            "CHENNUR",
            "CUDDAPAH",
            "DUVVUR",
            "GOPAVARAM",
            "JAMMALAMADUGU",
            "KALASAPADU",
            "KAMALAPURAM",
            "KHAJIPET",
            "KONDAPURAM",
            "LINGALA",
            "MUDDANUR",
            "MYDUKUR",
            "MYLAVARAM",
            "PEDDAMUDIUM",
            "PENDLIMARRY",
            "PORUMAMILLA",
            "PRODDUTUR",
            "PULIVENDLA",
            "RAJUPALEM",
            "S.V.KASINAYAN",
            "SIDHOUT",
            "SIMHADRIPURAM",
            "THONDUR",
            "V.N.PALLE",
            "VALLUR",
            "VEMPALLI",
            "VEMULA",
            "VONTIMITTA",
            "YERRAGUNTLA",
        ],
        KAKINADA: [
            "GANDEPALLI",
            "GOLLAPROLU",
            "JAGGAMPETA",
            "KAJULURU",
            "KAKINADA(RURAL)",
            "KAKINDA(URBAN)",
            "KARAPA",
            "KIRLAMPUDI",
            "KOTANANDURU",
            "PEDAPUDI",
            "PEDDAPURAM",
            "PITHAPURAM",
            "PRATIPADU",
            "ROWTULAPUDI",
            "SAMALKOTA",
            "SANKAVARAM",
            "THALLAREVU",
            "THONDANGI",
            "TUNI",
            "U.KOTHAPALLI",
            "YELESWARAM",
        ],
        KONASEEMA: [
            "AINAVILLI",
            "ALAMURU",
            "ALLAVARAM",
            "AMALAPURAM",
            "AMBAJIPETA",
            "ATREYAPURAM",
            "I.POLAVARAM",
            "K.GANGAVARAM",
            "KAPILESWARAPURAM",
            "KATRENIKONA",
            "KOTHAPETA",
            "MALIKIPURAM",
            "MAMIDIKUDURU",
            "MANDAPETA",
            "MUMMIDIVARAM",
            "P.GANNAVARAM",
            "RAMACHANDRAPURAM",
            "RAVULAPALEM",
            "RAYAVARAM",
            "RAZOLE",
            "SAKHINETIPALLI",
            "UPPALAGUPTAM",
        ],
        KRISHNA: [
            "AVANIGADDA",
            "BANTUMILLI",
            "BAPULAPADU",
            "CHALLAPALLI",
            "GANNAVARAM",
            "GHANTASALA",
            "GUDIVADA",
            "GUDLAVALLERU",
            "GUDURU",
            "KANKIPADU",
            "KODURU",
            "KRUTHIVENNU",
            "MACHILIPATNAM",
            "MOPIDEVI",
            "MOVVA",
            "NAGAYALANKA",
            "NANDIVADA",
            "PAMARRU",
            "PAMIDIMUKKALA",
            "PEDANA",
            "PEDAPARAPUDI",
            "PENAMALURU",
            "THOTLAVALLURU",
            "UNGUTURU",
            "VUYYURU",
        ],
        KURNOOL: [
            "ADONI",
            "ALUR",
            "ASPARI",
            "C.BELAGAL",
            "CHIPPAGIRI",
            "DEVANAKONDA",
            "GONEGANDLA",
            "GUDUR",
            "HALAHARVI",
            "HOLAGUNDA",
            "KALLUR",
            "KODUMUR",
            "KOSIGI",
            "KOWTHALAM",
            "KRISHNAGIRI",
            "KURNOOL",
            "MADDIKERA",
            "MANTRALAYAM",
            "NANDAVARAM",
            "ORVAKAL",
            "PATHIKONDA",
            "PEDDAKADUBUR",
            "TUGGALI",
            "VELDURTI",
            "YEMMIGANUR",
        ],
        MANYAM: [
            "BALIJIPETA",
            "BHAMINI",
            "G.L.PURAM",
            "GARUGUBILLI",
            "JIYYAMMAVALASA",
            "KOMARADA",
            "KURUPAM",
            "MAKKUVA",
            "PACHIPENTA",
            "PALAKONDA",
            "PARVATHIPURAM",
            "SALURU",
            "SEETHAMPETA",
            "SEETHANAGARAM",
            "VEERAGHATTAM",
        ],
        NANDYAL: [
            "ALLAGADDA",
            "ATMAKUR",
            "BANAGANAPALLI",
            "BANDIATMAKUR",
            "BETHAMCHERLA",
            "CHAGALAMARRI",
            "DHONE",
            "DORNIPADU",
            "GADIVEMULA",
            "GOSPADU",
            "J-BANGLAW",
            "KOILAKUNTLA",
            "KOLIMIGUNDLA",
            "KOTAPALLI",
            "MAHANANDI",
            "MIDTHUR",
            "NANDIKOTKUR",
            "NANDYAL",
            "OWK",
            "PAGIDALA",
            "PAMULAPADU",
            "PANYAM",
            "PEAPULLY",
            "RUDRAVARAM",
            "SANJAMALA",
            "SIRVEL",
            "SRISAILAM",
            "UYYALAWADA",
            "VELUGODU",
        ],
        NELLORE: [
            "ALLUR",
            "ANANTHASAGARAM",
            "ANUMASAMUDRAMPET",
            "ATMAKUR",
            "BOGOLE",
            "BUCHIREDDIPALEM",
            "CHEJERLA",
            "DAGADARTHI",
            "DUTTALUR",
            "GUDLURU",
            "INDUKURPET",
            "JALADANKI",
            "KALIGIRI",
            "KALUVOYA",
            "KANDUKURU",
            "KAVALI",
            "KODAVALUR",
            "KONDAPURAM",
            "KOVUR",
            "LINGASAMUDRAM",
            "MANUBOLU",
            "MARRIPADU",
            "MUTHUKUR",
            "NELLORE",
            "PODALAKUR",
            "RAPUR",
            "SAIDAPURAM",
            "SANGAM",
            "SEETHARAMAPURAM",
            "THOTAPALLIGUDUR",
            "UDAYAGIRI",
            "ULAVAPADU",
            "VALETIVARIPALEM",
            "VARIKUNTAPADU",
            "VENKATACHALAM",
            "VIDAVALUR",
            "VINJAMUR",
        ],
        NTR: [
            "A.KONDURU",
            "CHANDARLAPADU",
            "G.KONDURU",
            "GAMPALAGUDEM",
            "IBRAHIMPATNAM",
            "JAGGAYYAPET",
            "KANCHIKACHERLA",
            "MYLAVARAM",
            "NANDIGAMA",
            "PENUGANCHIPROLU",
            "REDDIGUDEM",
            "TIRUVURU",
            "VATSAVAI",
            "VERULLAPADU",
            "VIJAYAWADA RURAL",
            "VIJAYAWADA URBAN",
            "VISSANNAPET",
        ],
        PALNADU: [
            "ACHAMET",
            "AMARAVATHI",
            "BELLAMKONDA",
            "BOLLAPALLE",
            "CHILAKALURIPETA",
            "DACHEPALLE",
            "DURGI",
            "EDLAPADU",
            "EPURU",
            "GURAZALA",
            "KAREMPUDI",
            "KROSURU",
            "MACHAVARAM",
            "MACHERLA",
            "MUPPALLA",
            "NADENDLA",
            "NAKARIKALLU",
            "NARASARAOPETA",
            "NUZENDLA",
            "PEDAKURAPADU",
            "PIDUGURALLA",
            "RAJUPALEM",
            "RENTACHINTALA",
            "ROMPICHERLA",
            "SATTENAPALLE",
            "SAVALYAPURAM",
            "VELDURTHI",
            "VINUKONDA",
        ],
        PRAKASAM: [
            "ARDHAVEEDU",
            "BESTAVARIPETA",
            "C.S.PURAM",
            "CHIMAKURTHI",
            "CUMBUM",
            "DARSI",
            "DONAKONDA",
            "GIDDALURU",
            "HANUMANTHUNIPADU",
            "KANIGIRI",
            "KOMAROLU",
            "KONAKANAMITLA",
            "KONDAPI",
            "KOTHAPATNAM",
            "KURICHEDU",
            "MADDIPADU",
            "MARKAPUR",
            "MARRIPUDI",
            "MUNDLAMURU",
            "NAGULUPPALAPADU",
            "ONGOLE",
            "P.C.PALLI",
            "P.DORNALA",
            "PAMURU",
            "PEDARAVEEDU",
            "PODILI",
            "PONNALURU",
            "PULLALACHERUVU",
            "RACHARLA",
            "SANTHANUTHALAPADU",
            "SINGARAYAKONDA",
            "TALLURU",
            "TANGUTUR",
            "TARLUPADU",
            "TRIPURANTHAKAM",
            "VELIGANDLA",
            "YERRAGONDAPALEM",
            "ZARUGUMALLI",
        ],
        "SRI SATYASAI": [
            "AGALI",
            "AMADAGUR",
            "AMARAPURAM",
            "BATHALAPALLE",
            "BUKKAPATNAM",
            "CHENNEKOTHAPALLI",
            "CHILAMATHUR",
            "DHARMAVARAM",
            "GANDLAPENTA",
            "GORANTLA",
            "GUDIBANDA",
            "HINDUPUR",
            "KADIRI",
            "KANAGANAPALLE",
            "KOTHACHERUVU",
            "LEPAKSHI",
            "MADAKASIRA",
            "MUDIGUBBA",
            "NALLACHERUVU",
            "NALLAMADA",
            "NAMBULAPULIKUNTA",
            "OBULADEVARACHERUVU",
            "PARIGI",
            "PENUKONDA",
            "PUTTAPARTHI",
            "RAMAGIRI",
            "RODDAM",
            "ROLLA",
            "SOMANDEPALLE",
            "TADIMARRI",
            "TALUPULA",
            "TANAKAL",
        ],
        SRIKAKULAM: [
            "AMADALAVALASA",
            "BURJA",
            "ETCHERLA",
            "G.SIGADAM",
            "GARA",
            "HIRAMANDALAM",
            "ICHAPURAM",
            "JALUMURU",
            "KANCHILI",
            "KAVITI",
            "KOTABOMMALI",
            "KOTTURU",
            "LAVERU",
            "LAXMINARSU PETA",
            "MANDASA",
            "MELIAPUTTI",
            "NANDIGAM",
            "NARASANNAPETA",
            "PALASA",
            "PATHAPATNAM",
            "POLAKI",
            "PONDURU",
            "RANASTHALAM",
            "SANTHABOMMALI",
            "SARAVAKOTA",
            "SARUBUJJILI",
            "SOMPETA",
            "SRIKAKULAM",
            "TEKKALI",
            "VAJRAPUKOTTURU",
        ],
        TIRUPATI: [
            "B.N.KANDRIGA",
            "BALAYAPALLI",
            "CHANDRAGIRI",
            "CHILLAKUR",
            "CHINNAGOTTIGALLU",
            "CHITTAMUR",
            "DAKKILI",
            "DORAVARISATRAM",
            "GUDUR",
            "K.V.B.PURAM",
            "KOTA",
            "NAGALAPURAM",
            "NAIDUPET",
            "NARAYANAVARAM",
            "OZILI",
            "PAKALA",
            "PELLAKUR",
            "PITCHATUR",
            "PUTTUR",
            "R.C.PURAM",
            "RENIGUNTA",
            "SATHYAVEDU",
            "SRIKALAHASTI",
            "SULLURPET",
            "TADA",
            "THOTTAMBEDU",
            "TIRUPATHI(R)",
            "TIRUPATHI(U)",
            "VADAMALAPET",
            "VAKADU",
            "VARADAIAHPALEM",
            "VENKATAGIRI",
            "YERPEDU",
            "YERRAVARIPALEM",
        ],
        VISAKHAPATNAM: [
            "ANANDAPURAM",
            "BHEEMUNIPATNAM",
            "CHINAGADILA",
            "GAJUWAKA",
            "PADMANABHAM",
            "PEDAGANTAYADA",
            "PENDURTHY",
            "VISAKHAPATNAM URBAN",
        ],
        VIZIANAGARAM: [
            "BADANGI",
            "BHOGAPURAM",
            "BOBBILI",
            "BONDAPALLI",
            "CHEEPURUPALLI",
            "DATHIRAJERU",
            "DENKADA",
            "GAJAPATHINAGARAM",
            "GANTYADA",
            "GARIVIDI",
            "GURLA",
            "JAMI",
            "KOTHAVALASA",
            "LAKAVARAPUKOTA",
            "MENTADA",
            "MERAKAMUDIDAM",
            "NELLIMARLA",
            "PUSAPATIREGA",
            "R.AMADALAVALASA",
            "RAJAM",
            "RAMABHADRAPURAM",
            "SANTHAKAVITI",
            "SRUNGAVARAPUKOTA",
            "THERLAM",
            "VANGARA",
            "VEPADA",
            "VIZIANAGARAM",
        ],
        "WEST GODAVARI": [
            "ACHANTA",
            "AKIVEEDU",
            "ATTILI",
            "BHIMAVARAM",
            "ELAMANCHILI",
            "IRAGAVARAM",
            "KALLA",
            "MOGALTUR",
            "NARSAPURAM",
            "PALACOLE",
            "PALAKODERU",
            "PENTAPADU",
            "PENUGONDA",
            "PENUMANTRA",
            "PODURU",
            "TADEPALLI GUDEM",
            "TANUKU",
            "UNDI",
            "VEERAVASARAM",
        ],
    },
    AR: {
        ANJAW: ["CHAGLAGAM", "HAWAI-WALONG", "HAYULIANG", "MANCHAL"],
        "CAPITAL COMPLEX ITANAGAR": ["BORUM (URBAN)"],
        CHANGLANG: [
            "BORDUMSA",
            "CHANGLANG",
            "DIYUN",
            "KHIMYANG",
            "MANMAO",
            "MIAO",
            "NAMPONG",
        ],
        "DIBANG VALLEY": ["ANELIH-ARZU", "ANINI-MIPI", "ITALIN-MALINEY"],
        "EAST KAMENG": [
            "BAMENG",
            "BANA",
            "CHAYANG TAJO",
            "KHENEWA",
            "PIPU",
            "SEPPA",
        ],
        "EAST SIANG": ["MEBO", "PASIGHAT", "RAMLE-BANGGO", "RUKSIN"],
        KAMLE: ["PUCHIGEKO", "RAGA"],
        "KRA DADI": ["CHAMBANG-GANGTE", "PALIN-YANGTE", "PIPSORANG", "TALI"],
        "KURUNG KUMEY": [
            "DAMIN",
            "KOLORIANG",
            "NYAPIN-PHASSANG",
            "PARSIPARLO",
            "SANGRAM",
            "SARLI",
        ],
        "LEPA RADA": ["BASAR", "TIRBIN"],
        LOHIT: ["TEZU-SUNPURA", "WAKRO"],
        LONGDING: ["KANUBARI", "LONGDING-NIAUSA", "PONGCHAU", "WAKKA"],
        "LOWER DIBANG VALLEY": ["DAMBUK", "HUNLI", "ROING"],
        "LOWER SIANG": ["GENSI", "LIKABALI", "RAMLE-BANGGO"],
        "LOWER SUBANSIRI": ["ZIRO - I", "ZIRO - II"],
        NAMSAI: ["CHONGKHAM", "LEKANG", "NAMSAI"],
        "PAKKE KESSANG": ["PAKKE KESSANG", "SEIJOSA"],
        "PAPUM PARE": ["BALIJAN", "DOIMUKH", "KIMIN", "MENGIO", "SAGALEE"],
        "SHI YOMI": ["MECHUKHA", "MONIGOAN"],
        SIANG: ["KAYING-PAYUM", "PANGIN", "RIGA", "RUMGONG"],
        TAWANG: [
            "JANG-THINGBU",
            "KITPI",
            "LUMLA",
            "MUKTO-BONGKHAR",
            "TAWANG",
            "ZEMITHANG-DUDUNGHAR",
        ],
        TIRAP: ["DEOMALI", "KHONSA", "LAZU"],
        "UPPER SIANG": [
            "GEKU",
            "GELLING-SINGA",
            "JENGGING",
            "MARIYANG",
            "TUTING",
            "YINGKIONG",
        ],
        "UPPER SUBANSIRI": [
            "BARIRIJO",
            "DAPORIJO",
            "DUMPORIJO",
            "GIBA",
            "LIME KING",
            "NACHO",
            "SIYUM",
            "TALIHA",
        ],
        "WEST KAMENG": [
            "DIRANG",
            "KALAKTANG",
            "NAFRA",
            "SINGCHUNG-BHALUKPONG",
            "THRIZINO-BURAGAON",
        ],
        "WEST SIANG": ["ALONG EAST", "ALONG WEST", "DARAK", "YOMCHA/LIROMOBA"],
    },
    AS: {
        BAJALI: ["BAJALI"],
        BAKSA: ["BASKA", "JALAH", "TIHU BARAMA"],
        BARPETA: [
            "BARPETA",
            "BHAWANIPUR",
            "CHENGA",
            "GOBARDHANA",
            "MONDIA",
            "RUPSHI",
        ],
        BISWANATH: ["BEHALI", "BISWANATH", "CHAIDUAR"],
        BONGAIGAON: ["BOITAMARI", "BONGAIGAON", "MANIKPUR", "SRIJANGRAM"],
        CACHAR: [
            "KATIGORAH",
            "LAKHIPUR",
            "NARSINGPUR",
            "RAJA BAZAR",
            "SALCHAPRA",
            "SILCHAR",
            "SONAI",
            "UDHARBOND",
        ],
        CHARAIDEO: ["SAPEKHATI", "SONARI"],
        CHIRANG: ["BOROBAZAR", "SIDLI"],
        DARRANG: ["DALGAON", "KALAIGAON", "SIPAJHAR"],
        DHEMAJI: ["BORDOLONI", "DHEMAJI", "MURKONGSELEK"],
        DHUBRI: ["AGOMONI", "BILASIPARA", "CHAPOR", "GAURIPUR", "GOLAKGANJ"],
        DIBRUGARH: [
            "BARBARUAH",
            "JOYPUR",
            "KHOWANG",
            "LAHOAL",
            "PANITOLA",
            "TENGAKHAT",
        ],
        "DIMA HASAO": [
            "DIYUNGBRA",
            "HARANGAJAO",
            "MAHUR",
            "MAIBANG",
            "NEW SANGBAR",
        ],
        GOALPARA: ["BALIJANA", "DUDHNOI", "LAKHIPUR", "MATIA"],
        GOLAGHAT: ["CENTRAL", "EAST", "NORTH", "SOUTH", "WEST"],
        HAILAKANDI: ["HAILAKANDI", "KATLICHERRA", "LALA"],
        HOJAI: ["JUGIJAN", "LANKA"],
        JORHAT: [
            "CENTRAL JORHAT",
            "EAST JORHAT",
            "JORHAT",
            "NORTH WEST JORHAT",
            "TITABOR",
        ],
        "KAMRUP-METRO": ["DIMORIA", "GUWAHATI"],
        "KAMRUP-RURAL": [
            "BOKO",
            "CHAMARIA",
            "CHHAYGAON",
            "HAJO",
            "KAMALPUR",
            "KARARA",
            "RAMPUR",
            "RANGIA",
            "RANI",
        ],
        "KARBI ANGLONG": [
            "BOKAJAN",
            "HOWRAGHAT",
            "LANGSOMEPI",
            "LUMBAJONG",
            "NILIP",
            "RONGMONGVE",
            "SAMELANGSO",
        ],
        KARIMGANJ: [
            "BADARPUR",
            "NORTH KARIMGANJ",
            "PATHERKANDI",
            "R.K NAGAR",
            "SOUTH KARIMGANJ",
            "URBAN KARIMGANJ",
        ],
        KOKRAJHAR: [
            "DOTMA",
            "GOSSAIGAON",
            "KACHUGAON",
            "KOKRAJHAR",
            "PARBOTJHORA",
        ],
        LAKHIMPUR: [
            "BIHPURIA",
            "BORDOLONI",
            "DHAKUAKHANA",
            "LAKHIMPUR",
            "NARAYANPUR",
            "NOWBOICHA",
        ],
        MAJULI: ["MAJULI"],
        MORIGAON: ["BHURBANDHA", "KAPILI", "LAHARIGHAT", "MAYONG"],
        NAGAON: [
            "BATADRAVA",
            "JURIA",
            "KALIABOR",
            "KAPILI",
            "KATHIATOLI",
            "KHAGARIJAN",
            "LOWKHOWA",
            "RUPAHI",
            "URBAN",
        ],
        NALBARI: [
            "BARKHETRI",
            "BORIGOG BANBHAG",
            "PASCHIM NALBARI",
            "PUB NALBARI",
        ],
        SIBSAGAR: ["AMGURI", "DEMOW", "KHELUA", "NAZIRA"],
        SONITPUR: ["BALIPARA", "DHEKIAJULI", "GABHARU", "NADUAR"],
        "SOUTH SALMARA-MANKACHAR": ["MANKACHAR", "SOUTH SALMARA"],
        TAMULPUR: ["GORESWAR", "TAMULPUR"],
        TINSUKIA: [
            "HAPJAN",
            "KAKAPATHAR",
            "MARGHERITA",
            "SADIYA",
            "TINSUKIA URBAN",
        ],
        UDALGURI: ["KHOIRABARI", "MAZBAT", "UDALGURI"],
        "WEST KARBI ANGLONG": ["AMRI", "CHINTHONG", "RONGKHANG", "SOCHENG"],
    },
    BR: {
        ARARIA: [
            "ARARIA",
            "BHARGAMA",
            "FORBISGANJ",
            "JOKIHAT",
            "KURSAKANTA",
            "NARPATGANJ",
            "PALASI",
            "RANIGANJ",
            "SIKTI",
        ],
        ARWAL: [
            "ARWAL",
            "KALER",
            "KARPI",
            "KURTHA",
            "SONBHADRA BANSI SURAJPUR",
        ],
        "AURANGABAD (BIHAR)": [
            "AURANGABAD",
            "BARUN",
            "DEO",
            "DOUDNAGAR",
            "GOH",
            "HASPURA",
            "KUTUMBA",
            "MADANPUR",
            "NABINAGAR",
            "OBRA",
            "RAFIGANJ",
        ],
        BANKA: [
            "AMARPUR",
            "BANKA",
            "BARAHAT",
            "BELHAR",
            "BOUNSI",
            "CHANDAN",
            "DHORAIYA",
            "FULLI DUMAR",
            "KATORIYA",
            "RAJOUN",
            "SHAMBHUGANJ",
        ],
        BEGUSARAI: [
            "BACHHWARA",
            "BAKHRI",
            "BALIA",
            "BARAUNI",
            "BEGUSARAI",
            "BHAGWANPUR",
            "BIRPUR",
            "CHERIYA BARIYARPUR",
            "CHHAURAHI",
            "DANDARI",
            "GARHPURA",
            "KHODAWANDPUR",
            "MANSOORCHAK",
            "MATIHANI",
            "NAOKOTHI",
            "SAHEBPUR KAMAL",
            "SHAMHO AKHA KURHA",
            "TEGHRA",
        ],
        BHAGALPUR: [
            "BIHPUR",
            "GOPALPUR",
            "GORADIH",
            "ISMAILPUR",
            "JAGDISHPUR",
            "KAHALGOAN",
            "KHARIK",
            "NAGAR NIGAM",
            "NARAYANPUR",
            "NATH NAGAR",
            "NAUGACHHIA",
            "PIRPAINTI",
            "RANGRA CHOWK",
            "SABOUR",
            "SANHAULA",
            "SHAHKUND",
            "SULATANGANJ",
        ],
        BHOJPUR: [
            "AGIAON",
            "ARA",
            "BARAHARA",
            "BIHIYA",
            "CHARPOKHARI",
            "GARHANI",
            "JAGDISHPUR",
            "KOILWAR",
            "PIRO",
            "SAHAR",
            "SANDESH",
            "SHAHPUR",
            "TARARI",
            "UDWANTNAGAR",
        ],
        BUXAR: [
            "BRAHMPUR",
            "BUXAR",
            "CHAKKI",
            "CHAUGAI",
            "CHOUSA",
            "DUMRAON",
            "ITARHI",
            "KESATH",
            "NAWANAGAR",
            "RAJPUR",
            "SIMRI",
        ],
        DARBHANGA: [
            "ALINAGAR",
            "BAHADURPUR",
            "BAHERI",
            "BENIPUR",
            "BIRAUL",
            "DARBHANGA URBAN",
            "DARBHANGA-RURAL",
            "GAURA-BAURAM",
            "GHANSHYAMPUR",
            "HANUMAN NAGAR",
            "HAYAGHAT",
            "JALE",
            "KEOTI",
            "KIRATPUR",
            "KUSHESHWAR ASTHAN EAST",
            "KUSHESHWAR ASTHAN WEST",
            "MANIGACHHI",
            "SINGHWARA",
            "TARDIH",
        ],
        GAYA: [
            "AMAS",
            "ATRI",
            "BANKEY BAZAR",
            "BARACHATTI",
            "BELAGANJ",
            "BODH GAYA",
            "DOBHI",
            "DUMARIA",
            "FATEHPUR",
            "GAYA TOWN C.D.BLOCK",
            "GURARU",
            "GURUA",
            "IMAMGANJ",
            "KHIZERSARAI",
            "KONCH",
            "MANPUR",
            "MOHANPUR",
            "MOHARA",
            "NEEM CHAK BATHANI",
            "PARAIYA",
            "SHERGHATI",
            "TANKUPPA",
            "TIKARI",
            "WAZIRGANJ",
        ],
        GOPALGANJ: [
            "BAIKUNTHPUR",
            "BARAULI",
            "BHORE",
            "GOPALGANJ",
            "HATHUA",
            "KATEYA",
            "KUCHAIKOTE",
            "MANJHA",
            "PANCHDEORI",
            "PHULWARIYA",
            "SIDHWALIA",
            "THAWE",
            "UCHAKAGAON",
            "VIJAIPUR",
        ],
        JAMUI: [
            "ALIGANJ",
            "BARHAT",
            "CHAKAI",
            "GIDHAUR",
            "JAMUI",
            "JHAJHA",
            "KHAIRA",
            "LAXMIPUR",
            "SIKANDRA",
            "SONO",
        ],
        JEHANABAD: [
            "GHOSI",
            "HULASGANJ",
            "JEHANABAD",
            "KAKO",
            "MAKHDUMPUR",
            "MODANGANJ",
            "RATNI FARIDPUR",
        ],
        "KAIMUR (BHABUA)": [
            "ADHAURA",
            "BHABUA",
            "BHAGWANPUR",
            "CHAINPUR",
            "CHAND",
            "DURGAWATI",
            "KUDRA",
            "MOHANIA",
            "NUWAW",
            "RAMGARH",
            "RAMPUR",
        ],
        KATIHAR: [
            "AMDABAD",
            "AZAMNAGAR",
            "BALRAMPUR",
            "BARARI",
            "BARSOI",
            "DANDKHORA",
            "FALKA",
            "HASANGANJ",
            "KADWA",
            "KATIHAR",
            "KORHA",
            "KURSELA",
            "MANIHARI",
            "MANSAHI",
            "PRANPUR",
            "SAMELI",
        ],
        KHAGARIA: [
            "ALAULI",
            "BELDOUR",
            "CHAUTHAM",
            "GOGRI",
            "KHAGARIA",
            "MANSI",
            "PARBATTA",
        ],
        KISHANGANJ: [
            "BAHADURGANJ",
            "DIGHAL BANK",
            "KISHANGANJ",
            "KOCHADHAMAN",
            "POTHIA",
            "TERHA GACHH",
            "THAKURGANJ",
        ],
        LAKHISARAI: [
            "BARAHIYA",
            "CHANAN",
            "HALSI",
            "LAKHISARAI",
            "PIPARIYA",
            "RAMGARH CHOWK",
            "SURYAGARHA",
        ],
        MADHEPURA: [
            "ALAMNAGAR",
            "BIHARIGANJ",
            "CHOUSA",
            "GAMHARIYA",
            "GHAILADH",
            "GWALPARA",
            "KUMARKHAND",
            "MADHEPURA",
            "MURLIGANJ",
            "PURAINI",
            "SHANKARPUR",
            "SINGHESHWAR",
            "UDAKISHUNGANJ",
        ],
        MADHUBANI: [
            "ANDHARATHADHI",
            "BABUBARHI",
            "BASOPATTI",
            "BENIPATTI",
            "BISFI",
            "GHOGHARDIHA",
            "HARLAKHI",
            "JAYNAGAR",
            "JHANJHARPUR",
            "KALUAHI",
            "KHAJAULI",
            "KHUTAUNA",
            "LADANIA",
            "LAKHNAUR",
            "LAUKAHI",
            "MADHEPUR",
            "MADHWAPUR",
            "PANDAUL",
            "PHULPARAS",
            "RAHIKA",
            "RAJNAGAR",
        ],
        MUNGER: [
            "ASARGANJ",
            "BARIARPUR",
            "DHARHARA",
            "HAVELI   KHARAGPUR",
            "JAMALPUR",
            "MUNGER SADAR",
            "SANGRAMPUR",
            "TARAPUR",
            "TETIA BAMBER",
        ],
        MUZAFFARPUR: [
            "AURAI",
            "BANDRA",
            "BOCHAHA",
            "GAIGHAT",
            "KANTI",
            "KATRA",
            "KURHANI",
            "MARWAN",
            "MINAPUR",
            "MORAUL",
            "MOTIPUR",
            "MUSHARI",
            "PAROO",
            "SAHEBGANJ",
            "SAKRA",
            "SARAIYA",
        ],
        NALANDA: [
            "ASTHAWAN",
            "BEN",
            "BIHARSHARIF",
            "BIND",
            "CHANDI",
            "EKANGAR SARAI",
            "GIRIYAK",
            "HARNAUT",
            "HILSA",
            "ISLAMPUR",
            "KARAIPARSURAI",
            "KATRISARAI",
            "NAGARNAUSA",
            "NOORSARAI",
            "PARWALPUR",
            "RAHUI",
            "RAJGIR",
            "SARMERA",
            "SILAO",
            "THARTHARI",
        ],
        NAWADA: [
            "AKBARPUR",
            "GOVINDPUR",
            "HISUA",
            "KASHICHAK",
            "KAUAKOL",
            "MESKAUR",
            "NARDIGANJ",
            "NARHAT",
            "NAWADA",
            "PAKRIWARAN",
            "RAJAULI",
            "ROH",
            "SIRDALA",
            "WARISALIGANJ",
        ],
        "PASHCHIM CHAMPARAN": [
            "BAGAHA-I",
            "BAGAHA-II (SIDHAW)",
            "BAIRIA",
            "BETTIAH",
            "BHITAHA",
            "CHANPATIA",
            "GAUNAHA",
            "JOGAPATTI",
            "LAURIYA",
            "MADHUBANI",
            "MAINATAND",
            "MAJHAULIA",
            "NARKATIAGANJ",
            "NAUTAN",
            "PIPRASI",
            "RAMNAGAR",
            "SIKTA",
            "THAKARAHAN",
        ],
        PATNA: [
            "ATHMALGOLA",
            "BAKHTIYARPUR",
            "BARH",
            "BELCHHI",
            "BIHTA",
            "BIKRAM",
            "DANAPUR",
            "DANIYAWAN",
            "DHANARUA",
            "DULHINBAZAR",
            "FATUHA",
            "GHOSWARI",
            "KHUSRUPUR",
            "MANER",
            "MASAURHI",
            "MOKAMA",
            "NAUBATPUR",
            "PALIGANJ",
            "PANDARAK",
            "PATNASADAR RURAL",
            "PATNASADAR URBAN",
            "PHULWARISHARIF",
            "PUNPUN",
            "SAMPATCHAK",
        ],
        "PURBA CHAMPARAN": [
            "ADAPUR",
            "ARERAJ",
            "BANJARIA",
            "BANKATWA",
            "CHAKIA",
            "CHAURADANO",
            "CHIRAIYA",
            "DHAKA",
            "GHORASAHAN",
            "HARSIDDHI",
            "KALYANPUR",
            "KESARIA",
            "KOTWA",
            "MADHUBAN",
            "MEHSI",
            "MOTIHARI",
            "PAHARPUR",
            "PAKRIDAYAL",
            "PATAHI",
            "PHENHARA",
            "PIPRA KOTHI",
            "RAMGARHWA",
            "RAXAUL",
            "SANGRAMPUR",
            "SUGAULI",
            "TETARIA",
            "TURKAULIA",
        ],
        PURNIA: [
            "AMOUR",
            "BAISA",
            "BAISI",
            "BANMANKHI",
            "BARHARA KOTHI",
            "BHAWANIPUR",
            "DAGARUA",
            "DHAMDAHA",
            "JALALGARH",
            "KASBA",
            "KRITYANAND NAGAR",
            "PURNIA EAST",
            "RUPAULI",
            "SRI NAGAR",
        ],
        ROHTAS: [
            "AKODHIGOLA",
            "BIKRAMGANJ",
            "CHENARI",
            "DAWATH",
            "DEHRI",
            "DINARA",
            "KARAKAT",
            "KARGAHAR",
            "KOCHAS",
            "NASRIGANJ",
            "NAWHATTA",
            "NOKHA",
            "RAJPUR",
            "ROHTAS",
            "SANJHAULI",
            "SASARAM",
            "SHIVSAGAR",
            "SURYAPURA",
            "TILOUTHU",
        ],
        SAHARSA: [
            "BANMA ITAHARI",
            "KAHARA",
            "MAHISHI",
            "NAUHATTA",
            "PATARGHAT",
            "SALKHUA",
            "SATTAR KATTAIYA",
            "SAUR BAZAR",
            "SIMRI BAKHTIYARPUR",
            "SONBARSA",
        ],
        SAMASTIPUR: [
            "BIBHUTIPUR",
            "BITHAN",
            "DALSINGHSARAI",
            "HASANPUR",
            "KALYANPUR",
            "KHANPUR",
            "MOHANPUR",
            "MOHIUDDIN NAGAR",
            "MORWA",
            "PATORI",
            "PUSA",
            "ROSERA",
            "SAMASTIPUR",
            "SARAIRANJAN",
            "SHIVAJINAGAR",
            "SINGHIA",
            "TAJPUR",
            "UJIYARPUR",
            "VIDYAPATINAGAR",
            "WARISNAGAR",
        ],
        SARAN: [
            "AMNOUR",
            "BANIAPUR",
            "CHAPRA SADAR",
            "DARIAPUR",
            "DIGHWARA",
            "EKMA",
            "GARKHA",
            "ISHUAPUR",
            "JALALPUR",
            "LAHLADPUR",
            "MAKER",
            "MANJHI",
            "MARHOWRAH",
            "MASRAK",
            "NAGRA",
            "PANAPUR",
            "PARSA",
            "REVELGANJ",
            "SONEPUR",
            "TARAIYA",
        ],
        SHEIKHPURA: [
            "ARIYARI",
            "BARBIGHA",
            "CHEWARA",
            "GHAT KUSUMBHA",
            "SHEIKHPURA",
            "SHEKHOPUR SARAI",
        ],
        SHEOHAR: [
            "DUMRI KATSARI",
            "PIPRARHI",
            "PURNAHIYA",
            "SHEOHAR",
            "TARIYANI",
        ],
        SITAMARHI: [
            "BAIRGANIA",
            "BAJPATTI",
            "BATHNAHA",
            "BELSAND",
            "BOKHRA",
            "CHORAUT",
            "DUMRA",
            "MAJORGANJ",
            "NANPUR",
            "PARIHAR",
            "PARSAUNI",
            "PUPRI",
            "RIGA",
            "RUNNI SAIDPUR",
            "SONBARSA",
            "SUPPI",
            "SURSAND",
        ],
        SIWAN: [
            "ANDAR",
            "BARHARIA",
            "BASANTPUR",
            "BHAGWANPUR HATT",
            "DARAULI",
            "DARAUNDA",
            "GOREA KOTHI",
            "GUTHANI",
            "HASANPURA",
            "HUSSAINGANJ",
            "LAKARI NABIGANJ",
            "MAHARAJGANJ",
            "MAIRWA",
            "NAUTAN",
            "PACHRUKHI",
            "RAGHUNATHPUR",
            "SISWAN",
            "SIWAN SADAR",
            "ZIRADEI",
        ],
        SUPAUL: [
            "BASANTPUR",
            "CHHATAPUR",
            "KISHANPUR",
            "MARAUNA",
            "NIRMALI",
            "PIPRA",
            "PRATAPGANJ",
            "RAGHOPUR",
            "SARAIGARH BHAPTIAHI",
            "SUPAUL",
            "TRIVENIGANJ",
        ],
        VAISHALI: [
            "BHAGWANPUR",
            "BIDUPUR",
            "CHEHRAKALAN",
            "DESARI",
            "GORAUL",
            "HAJIPUR",
            "JANDAHA",
            "LALGANJ",
            "MAHNAR",
            "MAHUA",
            "PATEDHI BELSAR",
            "PATEPUR",
            "RAGHOPUR",
            "RAJAPAKAR",
            "SAHDEI BUZURG",
            "VAISHALI",
        ],
    },
    CH: {
        CHANDIGARH: ["BLOCK-1"],
    },
    CT: {
        BALOD: ["BALOD", "DAUNDI", "DAUNDI LOHARA", "GUNDERDEHI", "GURUR"],
        BALODABAZAR: ["BALODA BAZAR", "BHATAPARA", "KASDOL", "PALARI", "SIMGA"],
        BALRAMPUR: [
            "BALRAMPUR",
            "KUSMI",
            "RAJPUR",
            "RAMCHANDRAPUR",
            "SHANKARGARH",
            "WADRAFNAGAR",
        ],
        BASTER: [
            "BAKAWAND",
            "BASTANAR",
            "BASTAR",
            "DARBHA",
            "JAGDALPUR",
            "LOHANDIGUDA",
            "TOKAPAL",
        ],
        BEMETARA: ["BEMETARA", "BERLA", "NAWAGARH", "SAJA"],
        BIJAPUR: ["BHAIRAMGARH", "BHOPALPATNAM", "BIJAPUR", "USOOR"],
        BILASPUR: ["BILHA", "KOTA", "MASTURI", "TAKHATPUR"],
        DANTEWADA: ["DANTEWADA", "GEEDAM", "KATEKALYAN", "KUAKONDA"],
        DHAMTARI: ["DHAMTARI", "KURUD", "MAGARLOD", "NAGRI"],
        DURG: ["DHAMDHA", "DURG", "PATAN"],
        GARIABAND: ["CHHURA", "DEOBHOG", "FINGESHWAR", "GARIABAND", "MAINPUR"],
        "GOURELA PENDRA MARVAHI": ["GOURELA", "MARWAHI", "PENDRA"],
        "JANJGIR - CHAMPA": [
            "AKALTARA",
            "BALODA",
            "BAMHNINDIH",
            "NAWAGARH",
            "PAMGARH",
        ],
        JASHPUR: [
            "BAGICHA",
            "DULDULA",
            "FARSABAHAR",
            "JASHPUR",
            "KANSABEL",
            "KUNKURI",
            "MANORA",
            "PATHALGAON",
        ],
        KANKER: [
            "ANTAGARH",
            "BHANUPRATAPPUR",
            "CHARAMA",
            "DURGUKONDAL",
            "KANKER",
            "KOYALIBEDA",
            "NARHARPUR",
        ],
        KAWARDHA: ["BODLA", "KAWARDHA", "PANDARIYA", "SAHASPUR LOHARA"],
        "KHAIRAGARH-CHUIKHADAN-GANDAI": ["CHUIKHADAN", "KHAIRAGARH"],
        KONDAGAON: [
            "BADERAJPUR",
            "KESHKAL",
            "KONDAGAON",
            "MAKADI",
            "PHARASGAON",
        ],
        KORBA: ["KARTALA", "KATGHORA", "KORBA", "PALI", "PONDI-UPRODA"],
        KORIYA: ["BAIKUNTHPUR", "SONHAT"],
        MAHASAMUND: [
            "BAGBAHARA",
            "BASNA",
            "MAHASAMUND",
            "PITHORA",
            "SARAYPALI",
        ],
        "MANENDRAGARH-CHIRMIRI-BHARATPUR": [
            "BHARATPUR",
            "KHADGAVA",
            "MANENDRAGARH",
        ],
        "MOHLA-MANPUR-CHOWKI": ["CHOWKI", "MANPUR", "MOHLA"],
        MUNGELI: ["LORMI", "MUNGELI", "PATHARIA"],
        NARAYANPUR: ["ABUJHMAD (ORCHA)", "NARAYANPUR"],
        RAIGARH: [
            "DHARAMJAIGARH",
            "GHARGHODA",
            "KHARSIA",
            "LAILUNGA",
            "PUSSORE",
            "RAIGARH",
            "TAMNAR",
        ],
        RAIPUR: ["ABHANPUR", "ARANG", "DHARSHIWA", "TILDA"],
        RAJNANDGAON: ["CHURIA", "DONGARGAON", "DONGARGARH", "RAJNANDGAON"],
        SAKTI: ["DABHARA", "JAIJAIPUR", "MALKHARODA", "SAKTI"],
        "SARANGARH-BILAIGARH": ["BARAMKELA", "BILAIGARH", "SARANGARH"],
        SUKMA: ["CHHINDGARH", "KONTA", "SUKMA"],
        SURAJPUR: [
            "BHAIYATHAN",
            "ODGI",
            "PRATAPPUR",
            "PREMNAGAR",
            "RAMANUJNAGAR",
            "SURAJPUR",
        ],
        SURGUJA: [
            "AMBIKAPUR",
            "BATAOLI",
            "LAKHANPUR",
            "LUNDRA",
            "MAINPAT",
            "SITAPUR",
            "UDAIPUR",
        ],
    },
    DH: {
        "DADRA AND NAGAR HAVELI(DIST)": [
            "DADRA AND NAGAR HAVELI(BLOCK)",
            "KHANVEL",
            "SILVASSA",
        ],
        "DAMAN (DIST)": ["DAMAN (BLOCK)"],
        "DIU (DIST)": ["DIU (BLOCK)"],
    },
    DL: {
        CENTRAL: ["DOE ZONE-27", "DOE ZONE-28"],
        EAST: ["DOE ZONE-01", "DOE ZONE-02", "DOE ZONE-03"],
        "NEW DELHI": ["DOE ZONE-26"],
        NORTH: ["DOE ZONE-07", "DOE ZONE-08"],
        "NORTH EAST I": ["DOE ZONE-04"],
        "NORTH EAST II": ["DOE ZONE-05", "DOE ZONE-06"],
        "NORTH WEST A": ["DOE ZONE-09", "DOE ZONE-10"],
        "NORTH WEST B-I": ["DOE ZONE-11", "DOE ZONE-12", "DOE ZONE-13"],
        "NORTH WEST B-II": ["DOE ZONE-13"],
        SOUTH: ["DOE ZONE-23", "DOE ZONE-24"],
        "SOUTH EAST": ["DOE ZONE-25", "DOE ZONE-29"],
        "SOUTH WEST A": ["DOE ZONE-19", "DOE ZONE-20"],
        "SOUTH WEST B-I": ["DOE ZONE-21", "DOE ZONE-22"],
        "SOUTH WEST B-II": ["DOE ZONE-22"],
        "WEST A": ["DOE ZONE-14", "DOE ZONE-15", "DOE ZONE-16"],
        "WEST B": ["DOE ZONE-17", "DOE ZONE-18"],
    },
    GA: {
        "NORTH GOA": ["BARDEZ", "BICHOLIM", "PERNEM", "SATTARI", "TISWADI"],
        "SOUTH GOA": [
            "CANACONA",
            "DHARBANDORA",
            "MORMUGAO",
            "PONDA",
            "QUEPEM",
            "SALCETE",
            "SANGUEM",
        ],
    },
    GJ: {
        AHMEDABAD: [
            "AMC",
            "BAVLA",
            "CITY",
            "DASCROI",
            "DETROJ-RAMPURA",
            "DHANDHUKA",
            "DHOLERA",
            "DHOLKA",
            "MANDAL",
            "SANAND",
            "VIRAMGAM",
        ],
        AMRELI: [
            "AMRELI",
            "BABARA",
            "BAGASARA",
            "DHARI",
            "JAFRABAD",
            "KHAMBHA",
            "KUKAVAV",
            "LATHI",
            "LILIYA",
            "RAJULA",
            "SAVARKUNDLA",
        ],
        ANAND: [
            "ANAND",
            "ANKLAV",
            "BORSAD",
            "KHAMBHAT",
            "PETLAD",
            "SOJITRA",
            "TARAPUR",
            "UMRETH",
        ],
        ARAVALLI: [
            "BAYAD",
            "BHILODA",
            "DHANSURA",
            "MALPUR",
            "MEGHRAJ",
            "MODASA",
        ],
        "BANAS KANTHA": [
            "AMIRGADH",
            "BHABHAR",
            "DANTA",
            "DANTIWADA",
            "DEESA",
            "DEODAR",
            "DHANERA",
            "KANKAREJ",
            "LAKHANI",
            "PALANPUR",
            "SUIGAM",
            "THARAD",
            "VADGAM",
            "VAV",
        ],
        BHARUCH: [
            "AMOD",
            "ANKLESHWAR",
            "BHARUCH",
            "HANSOT",
            "JAMBUSAR",
            "NETRANG",
            "VAGRA",
            "VALIA",
            "ZAGHADIA",
        ],
        BHAVNAGAR: [
            "BHAVNAGAR",
            "GARIYADHAR",
            "GHOGHA",
            "JESAR",
            "MAHUVA",
            "PALITANA",
            "SHIHOR",
            "TALAJA",
            "UMRALA",
            "VALLBHIPUR",
        ],
        BOTAD: ["BARVALA", "BOTAD", "GADHADA", "RANPUR"],
        CHHOTAUDEPUR: [
            "BODELI",
            "CHHOTA-UDEPUR",
            "JETPUR-PAVI",
            "KAWANT",
            "NASWADI",
            "SANKHEDA",
        ],
        "DEVBHOOMI DWARKA": [
            "BHANVAD",
            "DWARKA",
            "JAMKALYANPUR",
            "JAMKHAMBHALIYA",
        ],
        DOHAD: [
            "DAHOD",
            "DEV.BARIA",
            "DHANPUR",
            "FATEPURA",
            "GARBADA",
            "LIMKHEDA",
            "SANJELI",
            "SINGVAD",
            "ZALOD",
        ],
        GANDHINAGAR: ["DEHGAM", "GANDHINAGAR", "KALOL", "MANSA"],
        "GIR SOMNATH": [
            "GIRGADHADA",
            "KODINAR",
            "SUTRAPADA",
            "TALALA",
            "UNA",
            "VERAVAL",
        ],
        JAMNAGAR: [
            "DHROL",
            "JAMJODHPUR",
            "JAMNAGAR",
            "JODIYA",
            "KALAVAD",
            "LALPUR",
        ],
        JUNAGADH: [
            "BHESAN",
            "JUNAGADH",
            "JUNAGADH CORPORATION",
            "KESHOD",
            "MALIYA HATINA",
            "MANAVADAR",
            "MANGROL",
            "MENDARDA",
            "VANTHALI",
            "VISAVADAR",
        ],
        KACHCHH: [
            "ABDASA",
            "ANJAR",
            "BHACHAU",
            "BHUJ",
            "GANDHIDHAM",
            "LAKHAPAT",
            "MANDVI",
            "MUNDRA",
            "NAKHATRANA",
            "RAPAR",
        ],
        KHEDA: [
            "GALTESHWAR",
            "KAPADVANJ",
            "KATHLAL",
            "KHEDA",
            "MAHEMDAVAD",
            "MAHUDHA",
            "MATAR",
            "NADIAD",
            "THASARA",
            "VASO",
        ],
        MAHESANA: [
            "BECHARAJI",
            "JOTANA",
            "KADI",
            "KHERALU",
            "MEHSANA",
            "SATLASANA",
            "UNJHA",
            "VADNAGAR",
            "VIJAPUR",
            "VISNAGAR",
        ],
        MAHISAGAR: [
            "BALASINOR",
            "KADANA",
            "KHANPUR",
            "LUNAWADA",
            "SANTRAMPUR",
            "VIRPUR",
        ],
        MORBI: ["HALVAD", "MALIYA", "MORBI", "TANKARA", "WANKANER"],
        NARMADA: [
            "DEDIYAPADA",
            "GARUDESHWAR",
            "NANDOD",
            "SAGBARA",
            "TILAKVADA",
        ],
        NAVSARI: [
            "CHIKHLI",
            "GANDEVI",
            "JALALPOR",
            "KHERGAM",
            "NAVSARI",
            "VANSDA",
        ],
        "PANCH MAHALS": [
            "GHOGHAMBA",
            "GODHRA",
            "HALOL",
            "JAMBUGHODA",
            "KALOL",
            "MORVA HADAF",
            "SHAHERA",
        ],
        PATAN: [
            "CHANASMA",
            "HARIJ",
            "PATAN",
            "RADHANPUR",
            "SAMI",
            "SANTALPUR",
            "SARASWATI",
            "SHANKHESHWAR",
            "SIDDHPUR",
        ],
        PORBANDAR: ["KUTIYANA", "PORBANDAR", "RANAVAV"],
        RAJKOT: [
            "DHORAJI",
            "GONDAL",
            "JAMKANDORNA",
            "JASDAN",
            "JETPUR",
            "KOTDA SANGANI",
            "LODHIKA",
            "PADDHARI",
            "RAJKOT",
            "RAJKOT CORPORATION",
            "UPLETA",
            "VINCHHIYA",
        ],
        "SABAR KANTHA": [
            "HIMMATNAGAR",
            "IDAR",
            "KHEDBRAHMA",
            "POSHINA",
            "PRANTIJ",
            "TALOD",
            "VADALI",
            "VIJAYNAGAR",
        ],
        SURAT: [
            "BARDOLI",
            "CHORYASI",
            "KAMREJ",
            "MAHUVA",
            "MANDAVI",
            "MANGROL",
            "OLPAD",
            "PALASANA",
            "SURAT CORPO.",
            "UMARPADA",
        ],
        SURENDRANAGAR: [
            "CHOTILA",
            "CHUDA",
            "DHRANGADHRA",
            "LAKHTAR",
            "LIMBDI",
            "MULI",
            "PATDI - DASADA",
            "SAYLA",
            "THANGADH",
            "WADHVAN",
        ],
        TAPI: [
            "DOLVAN",
            "KUKARMUNDA",
            "NIZAR",
            "SONGADH",
            "UCHCHHAL",
            "VALOD",
            "VYARA",
        ],
        "THE DANGS": ["AHWA", "SUBIR", "WAGHAI"],
        VADODARA: [
            "DABHOI",
            "DESAR",
            "KARJAN",
            "PADRA",
            "SAVLI",
            "SHINOR",
            "VADODARA",
            "VADODARA CORPORATION",
            "VAGHODIYA",
        ],
        VALSAD: [
            "DHARAMPUR",
            "KAPARADA",
            "PARDI",
            "UMBERGAON",
            "VALSAD",
            "VAPI",
        ],
    },
    HP: {
        "BILASPUR (H.P.)": [
            "GHUMARWIN-I",
            "GHUMARWIN-II",
            "JHANDUTTA",
            "SADAR",
            "SHRI NAINA DEVI JI",
            "SWARGHAT",
        ],
        CHAMBA: [
            "BANIKHET",
            "BHARMOUR",
            "CHAMBA",
            "CHOWARI",
            "GAROLA",
            "GEHRA",
            "HARDASPURA",
            "KALHEL",
            "KIANI",
            "MEHLA",
            "PANGI",
            "SALOONI",
            "SIHUNTA",
            "SUNDLA",
            "TISSA",
        ],
        "HAMIRPUR (H.P.)": [
            "BHORANJ",
            "BIJHARI",
            "GALORE",
            "HAMIRPUR",
            "NADAUN",
            "SUJANPUR",
        ],
        KANGRA: [
            "BAIJNATH",
            "BHAWARNA",
            "CHADHIAR",
            "DADASIBA",
            "DEHRA",
            "DHARAMSALA",
            "FATEHPUR",
            "INDORA",
            "JAWALI",
            "KANGRA",
            "KHUNDIAN",
            "KOTLA",
            "LAMBAGAON",
            "NAGROTA BAGWAN",
            "NAGROTA SURIAN",
            "NURPUR",
            "PALAMPUR",
            "PANCHRUKHI",
            "RAIT",
            "RAJA KA TALAB",
            "RAKKAR",
            "THURAL",
        ],
        KINNAUR: ["KALPA", "NICHAR", "POOH"],
        KULLU: [
            "ANNI",
            "BANJAR",
            "KULLU-1",
            "KULLU-2",
            "NAGGAR",
            "NIRMAND",
            "SAINJ",
        ],
        "LAHUL \u0026 SPITI": ["KAZA", "KEYLONG-I", "KEYLONG-II", "UDAIPUR"],
        MANDI: [
            "AUT",
            "BAGSAID",
            "BALH",
            "CHACHIOT-1",
            "CHACHIOT-2",
            "CHAUNTRA-1",
            "CHAUNTRA-2",
            "DHARAMPUR-1",
            "DHARAMPUR-2",
            "DRANG-1",
            "DRANG-2",
            "GOPALPUR-1",
            "GOPALPUR-2",
            "KARSOG-1",
            "KARSOG-2",
            "NIHRI",
            "REWALSAR",
            "SADAR-1",
            "SADAR-2",
            "SAIGALOO",
            "SALWAHAN",
            "SERAJ-1",
            "SERAJ-2",
            "SUNDER NAGAR-1",
            "SUNDER NAGAR-2",
        ],
        SHIMLA: [
            "CHAUHARA",
            "CHOPAL",
            "DEHA",
            "DODRAKAWAR",
            "JUBBAL",
            "KASUMPATI",
            "KOTKHAI",
            "KUMARSAIN",
            "KUPVI",
            "MASHOBRA",
            "MATIANA",
            "NANKHARI",
            "NERWA",
            "RAMPUR",
            "RAMPUR-II AT SARAHAN",
            "RANSAR (JANGLA)",
            "ROHRU",
            "SHIMLA-4",
            "SUNI",
            "THEOG",
            "TIKKAR",
        ],
        SIRMAUR: [
            "BAKRAS",
            "DADAHU",
            "KAFFOTTA",
            "KHORONWALA",
            "MAJRA",
            "NAHAN",
            "NARAG",
            "NOHRADHAR",
            "PAONTA SAHIB",
            "RAJGARH",
            "SANGRAH",
            "SARAHAN",
            "SATAUN",
            "SHILLAI",
            "SURLA",
        ],
        SOLAN: [
            "ARKI",
            "DHARAMPUR",
            "DHUNDAN",
            "KANDAGHAT",
            "KUTHAR",
            "NALAGARH",
            "PATTA MEHLOG",
            "RAMSHEHAR",
            "SOLAN",
        ],
        UNA: ["AMB", "BANGANA", "GAGRET-1", "GAGRET-2", "HAROLI", "JOL", "UNA"],
    },
    HR: {
        AMBALA: [
            "AMBALA-I (CITY)",
            "AMBALA-II (CANTT.)",
            "BARARA",
            "NARAINGARH",
            "SAHA",
            "SHEHZADPUR",
        ],
        BHIWANI: [
            "BAWANI KHERA",
            "BEHAL",
            "BHIWANI",
            "KAIRU",
            "LOHARU",
            "SIWANI",
            "TOSHAM",
        ],
        "CHARKHI DADRI": ["BADHRA", "BAUND KALAN", "DADRI"],
        FARIDABAD: ["BALLABGARH", "FARIDABAD"],
        FATEHABAD: [
            "BHATTU KALAN",
            "BHUNA",
            "FATEHABAD",
            "JAKHAL",
            "RATIA",
            "TOHANA",
        ],
        GURUGRAM: ["F.NAGAR", "GURGAON", "PATAUDI", "SOHNA"],
        HISAR: [
            "ADAMPUR",
            "AGROHA",
            "BARWALA",
            "HANSI-I",
            "HANSI-II",
            "HISAR-I",
            "HISAR-II",
            "NARNAUND",
            "UKLANA",
        ],
        JHAJJAR: ["BAHADURGARH", "BERI", "JHAJJAR", "MATANHAIL", "SALHAWAS"],
        JIND: [
            "ALEWA",
            "JIND",
            "JULANA",
            "NARWANA",
            "PILLUKHERA",
            "SAFIDON",
            "UCHANA",
        ],
        KAITHAL: ["GUHLA", "KAITHAL", "KALAYAT", "PUNDRI", "RAJOUND", "SIWAN"],
        KARNAL: [
            "ASSANDH",
            "GHARAUNDA",
            "INDRI",
            "KARNAL",
            "NILOKHERI",
            "NISSING",
        ],
        KURUKSHETRA: ["BABAIN", "LADWA", "PEHOWA", "SHAHBAD", "THANESAR"],
        MAHENDRAGARH: [
            "ATELI",
            "KANINA",
            "MAHENDERGARH",
            "NANGAL CHOUDHARY",
            "NARNAUL",
        ],
        NUH: ["F.P.JHIRKA", "NAGINA", "NUH", "PUNHANA", "TAORU"],
        PALWAL: ["HASSANPUR", "HATHIN", "HODAL", "PALWAL"],
        PANCHKULA: ["BARWALA", "MORNI", "PINJORE", "RAIPUR RANI"],
        PANIPAT: ["BAPOLI", "ISRANA", "MADLAUDA", "PANIPAT", "SAMALKHA"],
        REWARI: ["BAWAL", "JATUSANA", "KHOL", "NAHAR", "REWARI"],
        ROHTAK: ["KALANAUR", "LAKHAN MAJRA", "MEHAM", "ROHTAK", "SAMPLA"],
        SIRSA: [
            "BARAGUDHA",
            "DABWALI",
            "ELLENABAD",
            "NATHUSARI CHOPTA",
            "ODHAN",
            "RANIA",
            "SIRSA",
        ],
        SONIPAT: [
            "GANAUR",
            "GOHANA",
            "KATHURA",
            "KHARKHODA",
            "MUNDLANA",
            "RAI",
            "SONEPAT",
        ],
        YAMUNANAGAR: [
            "BILASPUR",
            "CHHACHHRAULI",
            "JAGADHRI",
            "MUSTAFABAD",
            "RADAUR",
            "SADHAURA",
        ],
    },
    JH: {
        BOKARO: [
            "BERMO",
            "CHANDANKIYARI",
            "CHANDRAPURA",
            "CHAS",
            "GOMIYA",
            "JARIDIH",
            "KASMAR",
            "NAWADIH",
            "PETARWAR",
        ],
        CHATRA: [
            "CHATRA",
            "GIDHOUR",
            "HUNTERGANJ",
            "ITKHORI",
            "KANHACHATTI",
            "KUNDA",
            "LAWALONG",
            "MAYURHAND",
            "PATHALGADA",
            "PRATAPPUR",
            "SIMARIA",
            "TANDWA",
        ],
        DEOGHAR: [
            "DEOGHAR",
            "DEVIPUR",
            "KAROWN",
            "MADHUPUR",
            "MARGOMUNDA",
            "MOHANPUR",
            "PALOJORI",
            "SARATH",
            "SARWAN",
            "SONARAITHARI",
        ],
        DHANBAD: [
            "BAGHMARA",
            "BALIAPUR",
            "DHANBAD",
            "EGARKUND",
            "GOVINDPUR",
            "JHARIA",
            "KELIASOLE",
            "NIRSA",
            "PURVI TUNDI",
            "TOPCHANCHI",
            "TUNDI",
        ],
        DUMKA: [
            "DUMKA",
            "GOPIKANDAR",
            "JAMA",
            "JARMUNDI",
            "KATHIKUND",
            "MASALIA",
            "RAMGARH",
            "RANISHWAR",
            "SARAIYAHAT",
            "SHIKARIPARA",
        ],
        GARHWA: [
            "BARDIHA",
            "BARGARH",
            "BHANDARIA",
            "BHAWANATHPUR",
            "BISHUNPURA",
            "CHINIA",
            "DANDA",
            "DANDEY",
            "DHURKI",
            "GARHWA",
            "KANDI",
            "KETAR",
            "KHARAUNDHI",
            "MANJHIAON",
            "MERAL",
            "NAGAR UNTARI",
            "RAMKANDA",
            "RAMNA",
            "RANKA",
            "SAGMA",
        ],
        GIRIDIH: [
            "BAGODAR",
            "BENGABAD",
            "BIRANI",
            "DEORI",
            "DHANWAR",
            "DUMRI",
            "GANDEY",
            "GAWAN",
            "GIRIDIH",
            "JAMUA",
            "PIRTAND",
            "SURIYA",
            "TISRI",
        ],
        GODDA: [
            "BASANTRAI",
            "BOARIJORE",
            "GODDA",
            "MAHAGAMA",
            "MEHARMA",
            "PATHARGAMA",
            "PORAIYAHAT",
            "SUNDERPAHARI",
            "THAKURGANGTI",
        ],
        GUMLA: [
            "ALBERT EKKA",
            "BASIA",
            "BHARNO",
            "BISHUNPUR",
            "CHAINPUR",
            "DUMRI",
            "GHAGHRA",
            "GUMLA",
            "KAMDARA",
            "PALKOT",
            "RAIDIH",
            "SISAI",
        ],
        HAZARIBAG: [
            "BARHI",
            "BARKAGAON",
            "BARKATHA",
            "BISHNUGARH",
            "CHALKUSHA",
            "CHOUPARAN",
            "CHURCHU",
            "DARI",
            "DARU",
            "HAZARIBAGH",
            "ICHAK",
            "KATKAMDAG",
            "KATKAMSANDI",
            "KEREDARI",
            "PADMA",
            "TATIJHARIYA",
        ],
        JAMTARA: [
            "FATEHPUR",
            "JAMTARA",
            "KARMATANR VIDYASAGAR",
            "KUNDAHIT",
            "NALA",
            "NARAYANPUR",
        ],
        KHUNTI: ["ARKI", "KARRA", "KHUNTI", "MURHU", "RANIA", "TORPA"],
        KODARMA: [
            "CHANDWARA",
            "DOMCHANCH",
            "JAINAGAR",
            "KODERMA",
            "MARKACHO",
            "SATGAWAN",
        ],
        LATEHAR: [
            "BALUMATH",
            "BARIYATU",
            "BARWADIH",
            "CHANDWA",
            "GARU",
            "HERHANJ",
            "LATEHAR",
            "MAHUADANR",
            "MANIKA",
        ],
        LOHARDAGA: [
            "BHANDRA",
            "KAIRO",
            "KISKO",
            "KURU",
            "LOHARDAGA",
            "PESHRAR",
            "SENHA",
        ],
        PAKAUR: [
            "AMRAPARA",
            "HIRANPUR",
            "LITTIPARA",
            "MAHESHPUR",
            "PAKUR",
            "PAKURIA",
        ],
        PALAMU: [
            "BISHRAMPUR",
            "CHAINPUR",
            "CHHATARPUR",
            "DALTONGANJ",
            "HAIDARNAGAR",
            "HARIHARGANJ",
            "HUSSAINABAD",
            "LESLIGANJ",
            "MANATU",
            "MOHAMMADGANJ",
            "NAWA BAZAR",
            "NAWDIHA BAZAR",
            "PANDU",
            "PANDWA",
            "PANKI",
            "PATAN",
            "PIPRA",
            "RAMGARH",
            "SATBARWA",
            "TARHASI",
            "UNTARI ROAD",
        ],
        "PASHCHIMI SINGHBHUM": [
            "ANANDPUR",
            "BANDGAON",
            "CHAKRADHARPUR",
            "GOELKERA",
            "GUDRI",
            "HATGAMAHARIA",
            "JAGANNATHPUR",
            "JHINKPANI",
            "KHUNTPANI",
            "KUMARDUNGI",
            "MAJHGAON",
            "MANJHARI",
            "MANOHARPUR",
            "NOAMUNDI",
            "SADAR CHAIBASA",
            "SONUA",
            "TANTNAGAR",
            "TONTO",
        ],
        "PURBI SINGHBHUM": [
            "BAHARAGORA",
            "BORAM",
            "CHAKULIA",
            "DHALBHUMGARH",
            "DUMARIA",
            "GHATSHILA",
            "GOLMURI-CUM-JUGSALAI",
            "GURABANDHA",
            "MUSABANI",
            "PATAMDA",
            "POTKA",
        ],
        RAMGARH: ["CHITARPUR", "DULMI", "GOLA", "MANDU", "PATRATU", "RAMGARH"],
        RANCHI: [
            "ANGARA",
            "BERO",
            "BUNDU",
            "BURMU",
            "CHANHO",
            "ITKI",
            "KANKE",
            "KHELARI",
            "LAPUNG",
            "MANDAR",
            "NAGRI",
            "NAMKUM",
            "ORMANJHI",
            "RAHE",
            "RATU",
            "SILLI",
            "SONAHATU",
            "TAMAR",
        ],
        SAHIBGANJ: [
            "BARHARWA",
            "BERHAIT",
            "BORIO",
            "MANDRO",
            "PATHNA",
            "RAJMAHAL",
            "SAHIBGANJ",
            "TALJHARI",
            "UDHWA",
        ],
        "SARAIKELA-KHARSAWAN": [
            "CHANDIL",
            "GAMHARIA",
            "ICHAGARH",
            "KHARSAWAN",
            "KUCHAI",
            "KUKRU",
            "NIMDIH",
            "RAJNAGAR",
            "SERAIKELLA",
        ],
        SIMDEGA: [
            "BANO",
            "BANSJOR",
            "BOLBA",
            "JALDEGA",
            "KERSAI",
            "KOLEBIRA",
            "KURDEG",
            "PAKARTANR",
            "SIMDEGA",
            "THETHAITANGAR",
        ],
    },
    JK: {
        ANANTNAG: [
            "ACHABAL",
            "AISHMUQAM",
            "ANANTNAG",
            "BIDDER",
            "BIJBEHARA",
            "DORU",
            "MATTAN",
            "QAZIGUND",
            "SHANGUS",
            "SRIGUFWARA",
            "VAILOO",
            "VERINAG",
        ],
        BADGAM: [
            "B.K.PORA",
            "BEERWAH",
            "BUDGAM",
            "CHADOORA",
            "CHARI-SHARIEF",
            "DREYGAM",
            "HARDU-PUNZOO",
            "KHAG",
            "KHANSAHIB",
            "MAGAM",
            "NAGAM",
            "NARBAL",
            "SOIBUGH",
        ],
        BANDIPORA: ["BANDIPORA", "GUREZ", "HAJIN", "QUILMUQAM", "SUMBAL"],
        BARAMULA: [
            "BARAMULLA",
            "BONIYAR",
            "CHANDANWARI",
            "CHANDOOSA",
            "DANGERPORA",
            "DANGIWACHA",
            "FATEHGRAH",
            "JHULLA",
            "KUNZAR",
            "NEHALPORA",
            "PATTAN",
            "ROHAMA",
            "SINGHPORA (KALAN)",
            "SINGHPORA PATTAN",
            "SOPORE",
            "TANGMARG",
            "URI",
            "WAGOORA",
        ],
        DODA: [
            "ASSAR",
            "BHADERWAH",
            "BHAGWAH",
            "BHALESSA",
            "BHALLA",
            "BHATYAS",
            "DODA",
            "GHAT",
            "GUNDNA",
            "THATHRI",
        ],
        GANDERBAL: ["GANDERBAL", "HARIGANWAN", "KANGAN", "TULMULLA"],
        JAMMU: [
            "AKHNOOR",
            "ARNIA",
            "BHALWAL",
            "BISHNAH",
            "CHOWKI CHOURA",
            "DANSAL",
            "GANDHI NAGAR",
            "JAMMU",
            "JOURIAN",
            "KHOUR",
            "MARH",
            "MIRAN SAHIB",
            "R.S. PURA",
            "SATWARI",
        ],
        KATHUA: [
            "BANI",
            "BARNOTI",
            "BASHOLI",
            "BHADDU",
            "BILLAWAR",
            "HIRANAGAR",
            "KATHUA",
            "LAKHANPUR",
            "MAHANPUR",
            "MALAHAR",
            "MARHEEN",
            "SALLAN",
        ],
        KISHTWAR: [
            "DRABSHALLA",
            "INDERWAL",
            "KISHTWAR",
            "MARWAH",
            "NAGSENI",
            "PADDER",
            "WARWAN",
        ],
        KULGAM: [
            "D H PORA",
            "DEVSAR",
            "H C GAM",
            "KULGAM",
            "QAIMOH",
            "YARIPORA",
        ],
        KUPWARA: [
            "CHAMKOTE",
            "DRUGMULA",
            "HANDWARA",
            "KHUMERIYAL",
            "KRALPORA",
            "KUPWARA",
            "LANGATE",
            "MAWER",
            "RAJWAR",
            "SOGAM",
            "TANGDAR",
            "TREHGAM",
            "VILGAM",
        ],
        PULWAMA: [
            "AWANTIPORA",
            "KAKAPORA",
            "LOORGAM",
            "PAMPORA",
            "PULWAMA",
            "SHADIMERG",
            "TAHAB",
            "TRAL",
        ],
        PUNCH: [
            "BAFLIAZ",
            "BALAKOTE",
            "HARNI",
            "KUNIYIAN",
            "MANDI",
            "MANKOTE",
            "MENDHAR",
            "NANGALI",
            "POONCH",
            "SATHRA",
            "SURANKOTE",
        ],
        RAJAURI: [
            "BALJARALLAN",
            "DANDASAR",
            "DARHAL",
            "DOONGI BRAHMANA",
            "KALAKOTE",
            "KHAWAS",
            "KOTRANKA",
            "LOWER HATHAL",
            "MANJAKOTE",
            "MOGLA",
            "NOWSHERA",
            "PEERI",
            "RAJOURI",
            "SUNDERBANI",
            "THANAMANDI",
        ],
        RAMBAN: ["BANIHAL", "BATOTE", "GOOL", "KHARI", "RAMBAN", "UKHRAL"],
        REASI: ["ARNAS", "CHASSANA", "CHINKAH", "MAHORE", "POUNI", "REASI"],
        SAMBA: ["GHAGWAL", "PURMANDAL", "RAMGARH", "SAMBA", "VIJAYPUR"],
        SHOPIAN: ["IMAMSAHAIB", "KEEGAM", "SHOPIAN", "VEHIL"],
        SRINAGAR: [
            "BATMALOO",
            "GULAB BAGH",
            "HAWAL",
            "IDDGAH",
            "NISHAT",
            "RAINAWARI",
            "SRINAGAR",
            "ZALDAGAR",
        ],
        UDHAMPUR: [
            "BABEY",
            "CHENANI",
            "DUDU",
            "GHORDI",
            "JIB",
            "KULWANTA",
            "MAJALTA",
            "PANCHARI",
            "RAMNAGAR",
            "TIKRI",
            "UDHAMPUR",
        ],
    },
    KA: {
        BAGALKOT: [
            "BADAMI",
            "BAGALKOT",
            "BILAGI",
            "HUNAGUND",
            "JAMAKHANDI",
            "MUDHOL",
        ],
        BALLARI: ["BELLARY EAST", "BELLARY WEST", "SANDUR", "SIRUGUPPA"],
        BELAGAVI: [
            "BAILHONGAL",
            "BELGAUM CITY",
            "BELGAUM RURAL.",
            "KHANAPUR",
            "KITTUR",
            "RAMDURG",
            "SOUNDATTI",
        ],
        "BELAGAVI CHIKKODI": [
            "ATHANI",
            "CHIKODI",
            "GOKAK",
            "HUKKERI",
            "KAGWAD",
            "MUDALGI",
            "NIPPANI",
            "RAIBAG",
        ],
        "BENGALURU RURAL": [
            "DEVANAHALLI",
            "DODDABALLAPURA",
            "HOSAKOTE",
            "NELAMANGALA",
        ],
        "BENGALURU U NORTH": ["NORTH1", "NORTH2", "NORTH3", "NORTH4"],
        "BENGALURU U SOUTH": ["ANEKAL", "SOUTH1", "SOUTH2", "SOUTH3", "SOUTH4"],
        BIDAR: ["AURAD", "BASAVAKALYAN", "BHALKI", "BIDAR", "HUMNABAD"],
        CHAMARAJANAGARA: [
            "CHAMARAJA NAGAR",
            "GUNDULPET",
            "HANUR",
            "KOLLEGAL",
            "YELANDUR",
        ],
        CHIKKABALLAPURA: [
            "BAGEPALLY",
            "CHIKKABALLAPUR",
            "CHINTAMANI",
            "GOWRIBIDANUR",
            "GUDIBANDA",
            "SIDLAGHATTA",
        ],
        CHIKKAMANGALURU: [
            "BIRURU",
            "CHIKMAGALUR",
            "KADUR",
            "KOPPA",
            "MOODIGERE",
            "NARASIMHARAJAPURA",
            "SRINGERI",
            "TARIKERE",
        ],
        CHITRADURGA: [
            "CHALLAKERE",
            "CHITRADURGA",
            "HIRIYUR",
            "HOLALKERE",
            "HOSADURGA",
            "MOLAKALMUR",
        ],
        "DAKSHINA KANNADA": [
            "BANTWAL",
            "BELTHANGADY",
            "MANGALURU NORTH",
            "MANGALURU SOUTH",
            "MOODABIDRE",
            "PUTTUR",
            "SULLIA",
        ],
        DAVANAGERE: [
            "CHANNAGIRI",
            "DAVANAGERE(N)",
            "DAVANAGERE(S)",
            "HARIHARA",
            "HONNALI",
            "JAGALUR",
        ],
        DHARWAD: [
            "DHARWAD",
            "DHARWAD CITY",
            "HDMC",
            "HUBLI",
            "KALGHATAGI",
            "KUNDAGOL",
            "NAVALGUND",
        ],
        GADAG: [
            "GADAG CITY",
            "GADAG RURAL",
            "MUNDARAGI",
            "NARAGUND",
            "RON",
            "SHIRHATTI",
        ],
        HASSAN: [
            "ALUR",
            "ARAKALAGUDU",
            "ARASIKERE",
            "BELUR",
            "CHANNARAYAPATNA",
            "HASSAN",
            "HOLENARASIPURA",
            "SAKALESHAPURA",
        ],
        HAVERI: [
            "BYADAGI",
            "HANAGAL",
            "HAVERI",
            "HIREKERUR",
            "RANNEBENNUR",
            "SAVANUR",
            "SHIGGOAN",
        ],
        KALBURGI: [
            "AFZALPUR",
            "ALAND",
            "CHINCHOLI",
            "CHITTAPUR",
            "GULBARGA NORTH",
            "GULBARGA SOUTH",
            "JEWARGI",
            "SEDAM",
        ],
        KODAGU: ["MADIKERI", "SOMAVARPET", "VIRAJPET"],
        KOLAR: [
            "BANGARAPETE",
            "K G F",
            "KOLAR",
            "MALUR",
            "MULBAGAL",
            "SRINIVASAPUR",
        ],
        KOPPAL: ["GANGAVATHI", "KOPPAL", "KUSTAGI", "YELBURGA"],
        MANDYA: [
            "KRISHNARAJA PET",
            "MADDUR",
            "MALAVALLY",
            "MANDYA NORTH",
            "MANDYA SOUTH",
            "NAGAMANGALA",
            "PANDAVAPURA",
            "SRIRANGA PATNA",
        ],
        MYSURU: [
            "H.D.KOTE",
            "HUNSUR",
            "K.R.NAGARA",
            "MYSORE NORTH",
            "MYSORE RURAL",
            "MYSORE SOUTH",
            "NANJANAGUD",
            "PERIYA PATNA",
            "T.N.PURA",
        ],
        RAICHUR: ["DEVADURGA", "LINGASUGUR", "MANVI", "RAICHUR", "SINDHANUR"],
        RAMANAGARA: ["CHANNAPATNA", "KANAKAPURA", "MAGADI", "RAMANAGARA"],
        SHIVAMOGGA: [
            "BHADRAVATI",
            "HOSANAGAR",
            "SAGAR",
            "SHIKARIPUR",
            "SHIMOGA",
            "SORAB",
            "THIRTHAHALLI",
        ],
        TUMAKURU: [
            "CHIKNAYAKANHALLI",
            "GUBBI",
            "KUNIGAL",
            "TIPTUR",
            "TUMKUR",
            "TURUVEKERE",
        ],
        "TUMAKURU MADHUGIRI": ["KORATAGERE", "MADHUGIRI", "PAVAGADA", "SIRA"],
        UDUPI: ["BRAHAMAVARA", "BYNDOOR", "KARKALA", "KUNDAPURA", "UDUPI"],
        "UTTARA KANNADA": ["ANKOLA", "BHATKAL", "HONNAVAR", "KARWAR", "KUMTA"],
        "UTTARA KANNADA SIRSI": [
            "HALIYAL",
            "JOIDA",
            "MUNDAGOD",
            "SIDDAPUR",
            "SIRSI",
            "YELLAPUR",
        ],
        VIJAYANAGARA: [
            "HADAGALI",
            "HAGARIBOMMANAHALLI",
            "HARAPANAHALLI",
            "HOSPET",
            "KUDLIGI",
        ],
        VIJAYAPURA: [
            "BASAVAN  BAGEWADI",
            "BIJAPUR  RURAL",
            "BIJAPUR CITY",
            "CHADACHAN",
            "INDI",
            "MUDDEBIHAL",
            "SINDAGI",
        ],
        YADAGIRI: ["SHAHAPUR", "SHORAPUR", "YADGIR"],
    },
    KL: {
        ALAPPUZHA: [
            "ALAPPUZHA",
            "AMBALAPPUZHA",
            "CHENGANNUR",
            "CHERTHALA",
            "HARIPPAD",
            "KAYAMKULAM",
            "MAVELIKKARA",
            "MONCOMPU",
            "THALAVADY",
            "THURAVUR",
            "VELIYANADU",
        ],
        ERNAKULAM: [
            "ALUVA",
            "ANGAMALY",
            "ERNAKULAM",
            "KALLOORKKAD",
            "KOLENCHERY",
            "KOOTHATTUKULAM",
            "KOOVAPPADY",
            "KOTHAMANGALAM",
            "MATTANCHERY",
            "MUVATTUPUZHA",
            "N.PARUR",
            "PERUMBAVOOR",
            "PIRAVOM",
            "TRIPPUNITHURA",
            "VYPEEN",
        ],
        IDUKKI: [
            "ADIMALY",
            "ARAKULAM",
            "KARIMANNOOR",
            "KATTAPPANA",
            "MUNNAR",
            "NEDUMKANDAM",
            "PEERMADU",
            "THODUPUZHA",
        ],
        KANNUR: [
            "CHOCKLI",
            "IRIKKUR",
            "IRITTY",
            "KANNUR NORTH",
            "KANNUR SOUTH",
            "KUTHUPARAMBA",
            "MADAYI",
            "MATTANNUR",
            "PANOOR",
            "PAPPINISSERI",
            "PAYYANNUR",
            "TALIPARAMBA NORTH",
            "TALIPARAMBA SOUTH",
            "THALASSERY NORTH",
            "THALESSERY SOUTH",
        ],
        KASARAGOD: [
            "BEKAL",
            "CHERUVATHUR",
            "CHITTARIKKAL",
            "HOSDURG",
            "KASARAGOD",
            "KUMBALA",
            "MANJESHWAR",
        ],
        KOLLAM: [
            "ANCHAL",
            "CHADAYAMANGALAM",
            "CHATHANNOOR",
            "CHAVARA",
            "KARUNAGAPPALLY",
            "KOLLAM",
            "KOTTARAKARA",
            "KULAKKADA",
            "KUNDARA",
            "PUNALUR",
            "SASTHAMCOTTA",
            "VELIYAM",
        ],
        KOTTAYAM: [
            "CHANGANASSERY",
            "ERATTUPETTA",
            "ETTUMANOOR",
            "KANJIRAPPALLY",
            "KARUKACHAL",
            "KOTTAYAM(EAST)",
            "KOTTAYAM(WEST)",
            "KOZHUVANAL",
            "KURAVILANGADU",
            "PALA",
            "PAMPADY",
            "RAMAPURAM",
            "VAIKOM",
        ],
        KOZHIKODE: [
            "BALUSSERY",
            "CHELANNUR",
            "KODUVALLY",
            "KOZHIKKODE URC SOUTH",
            "KOZHIKODE",
            "KOZHIKODE URC",
            "KUNNAMANGALAM",
            "KUNNUMMAL",
            "MAVOOR",
            "MELADY",
            "PANTHALAYANI",
            "PERAMBRA",
            "THODANNUR",
            "THUNERI",
            "VATAKARA",
        ],
        MALAPPURAM: [
            "AREACODE",
            "EDAPPAL",
            "KONDOTTY",
            "KUTTIPURAM",
            "MALAPPURAM",
            "MANJERI",
            "MANKADA",
            "NILAMBUR",
            "PARAPPANANGADI",
            "PERINTHALMANNA",
            "PONNANI",
            "TANUR",
            "TIRUR",
            "VENGARA",
            "WANDOOR",
        ],
        PALAKKAD: [
            "AGALI",
            "ALATHUR",
            "CHERPULASSERY",
            "CHITTUR",
            "KOLLENGODE",
            "KUZHALMANNAM",
            "MANNARKKAD",
            "OTTAPALAM",
            "PALAKKAD",
            "PARLI",
            "PATTAMBI",
            "SHORANUR",
            "THRITHALA",
        ],
        PATHANAMTHITTA: [
            "ADOOR",
            "ARANMULA",
            "KONNI",
            "KOZHENCHERRY",
            "MALLAPALLY",
            "PANDALAM",
            "PATHANAMTHITTA",
            "PULLAD",
            "RANNI",
            "THIRUVALLA",
            "VENNIKULAM",
        ],
        THIRUVANANTHAPURAM: [
            "ATTINGAL",
            "BALARAMAPURAM",
            "KANIYAPURAM",
            "KATTAKKADA",
            "KILIMANOOR",
            "NEDUMANGADU",
            "NEYYATTINKARA",
            "PALODE",
            "PARASSALA",
            "THIRUVANANTHAPURAM",
            "TRIVANDRUM SOUTH",
            "VARKALA",
        ],
        THRISSUR: [
            "ANTHIKKAD",
            "CHALAKUDY",
            "CHAVAKKAD",
            "CHERPU",
            "CHOWANNUR",
            "IRINJALAKUDA",
            "KODAKARA",
            "KODUNGALLUR",
            "MALA",
            "MATHILAKAM",
            "MULLASSERY",
            "OLLUKKARA",
            "PAZHAYANNUR",
            "PUZHAKKAL",
            "THALIKULAM",
            "URC THRISSUR",
            "VELLANGALLUR",
            "WADAKKANCHERY",
        ],
        WAYANAD: ["MANANTHAVADY", "SULTHAN BATHERY", "VYTHIRI"],
    },
    LA: {
        KARGIL: [
            "CHIKTAN",
            "DRASS",
            "KARGIL",
            "SANKOO",
            "SHARGOLE",
            "TAISURU",
            "ZANSKAR",
        ],
        "LEH (LADAKH)": ["DURBUK", "KHALTSE", "KHARU", "LEH", "NUBRA", "NYOMA"],
    },
    LD: {
        LAKSHADWEEP: ["AMINI", "ANDROTT", "KAVARATTI"],
    },
    MH: {
        AHMADNAGAR: [
            "AKOLE",
            "JAMKHED",
            "KARJAT",
            "KOPARGAON",
            "MC AHMEDNAGAR",
            "NAGAR",
            "NEWASA",
            "PARNER",
            "PATHARDI",
            "RAHATA",
            "RAHURI",
            "SANGAMNER",
            "SHEVGAON",
            "SHRIGONDA",
            "SHRIRAMPOOR",
        ],
        AKOLA: [
            "AKOLA MC",
            "AKOLA PS",
            "AKOT",
            "BALAPUR",
            "BARSHITAKLI",
            "MURTIZAPUR",
            "PATUR",
            "TELHARA",
        ],
        AMRAVATI: [
            "ACHALPUR",
            "AMRAVATI",
            "AMRAVATI MC",
            "ANJANGAON SURJI",
            "BHATKULI",
            "CHANDUR BZ",
            "CHANDUR RLY",
            "CHIKHALDARA",
            "DARYAPUR",
            "DHAMANGAON RLY",
            "DHARNI",
            "MORSHI",
            "NANDGAON KH",
            "TIOSA",
            "WARUD",
        ],
        BHANDARA: [
            "BHANDARA",
            "LAKHANDUR",
            "LAKHANI",
            "MOHADI",
            "PAUNI",
            "SAKOLI",
            "TUMSAR",
        ],
        BID: [
            "AMBAJOGAI",
            "ASHTI",
            "BEED",
            "DHARUR",
            "GEORAI",
            "KAIJ",
            "MAJALGAON",
            "PARLI",
            "PATODA",
            "SHIRUR",
            "URC BEED",
            "WADWANI",
        ],
        BULDANA: [
            "BULDANA",
            "CHIKHALI",
            "DEULGAON RAJA",
            "JALGAON JAMOD",
            "KHAMGAON",
            "LOANR",
            "MALAKAPUR",
            "MEHAKAR",
            "MOTALA",
            "NANDURA",
            "SANGRAMPUR",
            "SHEGAON",
            "SINDKHED RAJA",
        ],
        CHANDRAPUR: [
            "BALLARPUR",
            "BHADRAWATI",
            "BRAMHAPURI",
            "CHANDRAPUR",
            "CHIMUR",
            "GONDPIPARI",
            "JIWATI",
            "KORPANA",
            "MUL",
            "NAGBHID",
            "POMBURNA",
            "RAJURA",
            "SAOLI",
            "SINDEWAHI",
            "WARORA",
        ],
        "CHHATRAPATI SAMBHAJINAGAR": [
            "CHHATRAPATI SAMBHAJINAGAR",
            "GANGAPUR",
            "KANNAD",
            "KHULTABAD",
            "PAITHAN",
            "PHULAMBRI",
            "SILLOD",
            "SOEGAON",
            "URC1",
            "URC2",
            "VAIJAPUR",
        ],
        DHARASHIV: [
            "BHOOM",
            "DHARASHIV",
            "KALLAMB",
            "LOHARA",
            "OMERGA",
            "PARANDA",
            "TULJAPUR",
            "WASHI",
        ],
        DHULE: ["DHULE", "DHULE M.N.P.", "SAKRI", "SHINDKHEDA", "SHIRPUR"],
        GADCHIROLI: [
            "AHERI",
            "ARMORI",
            "BHAMRAGAD",
            "CHAMORSHI",
            "DESAIGANJ",
            "DHANORA",
            "ETAPALLI",
            "GADCHIROLI",
            "KORCHI",
            "KURKHEDA",
            "MULCHERA",
            "SIRONCHA",
        ],
        GONDIYA: [
            "AMGAON",
            "ARJUNI MOR",
            "DEORI",
            "GONDIA",
            "GOREGAON",
            "SADAK ARJUNI",
            "SALEKASA",
            "TIRODA",
        ],
        HINGOLI: [
            "AUNDHA NAGNATH",
            "BASMATH",
            "HINGOLI",
            "KALAMNURI",
            "SENGAON",
        ],
        JALGAON: [
            "AMALNER",
            "BHADGAON",
            "BHUSAWAL",
            "BODWAD",
            "CHALISGAON",
            "CHOPDA",
            "DHARANGAON",
            "ERANDOL",
            "JALGAON",
            "JALGAON M. CORP.",
            "JAMNER",
            "MUKTAINAGAR",
            "PACHORA",
            "PAROLA",
            "RAWER",
            "YAWAL",
        ],
        JALNA: [
            "AMBAD",
            "BADNAPUR",
            "BHOKARDAN",
            "GHANSAWANGI",
            "JAFRABAD",
            "JALNA",
            "MANTHA",
            "PARTUR",
        ],
        KOLHAPUR: [
            "AAJARA",
            "BHUDARGAD",
            "CHANDGAD",
            "GADHINGLAJ",
            "GAGANBAWADA",
            "HATKALANGLE",
            "KAGAL",
            "KARVEER",
            "KOLHAPUR",
            "PANHALA",
            "RADHANAGARI",
            "SHAHUWADI",
            "SHIROL",
        ],
        LATUR: [
            "AHAMADPUR",
            "AUSA",
            "CHAKUR",
            "DEVANI",
            "JALKOT",
            "LATUR",
            "LATUR URC1",
            "LATUR URC2",
            "NILANGA",
            "RENAPUR",
            "SHIRUR ANANTPAL",
            "UDGIR",
        ],
        "MUMBAI (SUBURBAN)": [
            "URC-1 (BORIVALI)",
            "URC-10 (PAREL)",
            "URC-11(DADAR)",
            "URC-12(BYCULLA)",
            "URC-2 (KANDIVALI)",
            "URC-3 (GOREGAON)",
            "URC-4 (ANDHERI)",
            "URC-5 (SANTACRUZ)",
            "URC-6 (BHANDUP)",
            "URC-7 (GHATKOPAR)",
            "URC-8 (CHEMBUR)",
            "URC-9 (KURLA)",
        ],
        "MUMBAI II": [
            "MUMBAI_DYD_URC1 ( GRANT ROAD )",
            "MUMBAI_DYD_URC2 ( SION )",
            "MUMBAI_DYD_URC3 ( GHATKOPAR )",
            "MUMBAI_DYD_URC4 ( MULUND )",
            "MUMBAI_DYD_URC5 ( ANDHERI )",
            "MUMBAI_DYD_URC6 ( MALAD (W) )",
            "MUMBAI_DYD_URC7 ( KANDIVALI (E) )",
        ],
        NAGPUR: [
            "BHIWAPUR",
            "HINGNA",
            "KALMESHWAR",
            "KAMPTEE",
            "KATOL",
            "KUHI",
            "MOUDA",
            "NAGPUR (GRAMIN)",
            "NARKHED",
            "PARSEONI",
            "RAMTEK",
            "SAONER",
            "UMRED",
            "URC 1",
            "URC 2",
            "URC 3",
            "URC 4",
            "URC 5",
        ],
        NANDED: [
            "ARDHAPUR",
            "BHOKAR",
            "BILOLI",
            "DEGLOOR",
            "DHARMABAD",
            "HADGAON",
            "HIMAYAT NAGAR",
            "KANDHAR",
            "KINWAT",
            "LOHA",
            "MAHOOR",
            "MUDKHED",
            "MUKHED",
            "NAIGAON",
            "NANDED",
            "NANDED M.C.",
            "UMRI",
        ],
        NANDURBAR: [
            "AKKALKUWA",
            "DHADGAON",
            "NANDURBAR",
            "NAVAPUR",
            "SHAHADA",
            "TALODA",
        ],
        NASHIK: [
            "BAGLAN",
            "CHANDWAD",
            "DEVLA",
            "DINDORI",
            "IGATPURI",
            "KALWAN",
            "MALEGAON",
            "MALEGAON MC",
            "NANDGAON",
            "NASHIK",
            "NASHIK URC-1",
            "NASHIK URC-2",
            "NIPHAD",
            "PEINT",
            "SINNER",
            "SURGANA",
            "TRIMBAK",
            "YEOLA",
        ],
        PALGHAR: [
            "DAHANU",
            "JAWHAR",
            "MOKHADA",
            "PALGHAR",
            "TALASARI",
            "VASAI",
            "VIKRAMGAD",
            "WADA",
        ],
        PARBHANI: [
            "GANGAKHED",
            "JINTUR",
            "MANWAT",
            "PALAM",
            "PARBHANI URC",
            "PARHBANI",
            "PATHRI",
            "PURNA",
            "SAILU",
            "SONPETH",
        ],
        PUNE: [
            "AKURDI",
            "AMBEGAON",
            "AUNDH",
            "BARAMATI",
            "BHOR",
            "BIBWEWADI",
            "DAUND",
            "HADPASAR",
            "HAVELI",
            "INDAPUR",
            "JUNNAR",
            "KHED",
            "MAVAL",
            "MULSHI",
            "PIMPRI",
            "PUNE CITY",
            "PURANDAR",
            "SHIRUR",
            "VELHE",
            "YERAWADA",
        ],
        "RAIGARH (MAHARASHTRA)": [
            "ALIBAG",
            "KARJAT",
            "KHALAPUR",
            "MAHAD",
            "MANGAON",
            "MHASALA",
            "MURUD",
            "PANVEL",
            "PEN",
            "POLADPUR",
            "ROHA",
            "SHRIVARDHAN",
            "SUDHAGAD",
            "TALA",
            "URAN",
        ],
        RATNAGIRI: [
            "CHIPLUN",
            "DAPOLI",
            "GUHAGAR",
            "KHED",
            "LANJA",
            "MANDANGAD",
            "RAJAPUR",
            "RATNAGIRI",
            "SANGMESHWAR",
        ],
        SANGLI: [
            "ATPADI",
            "JATH",
            "KADEGAON",
            "KAVATHE MAHANKAL",
            "KHANAPUR",
            "MIRAJ",
            "PALUS",
            "SANGLI MIRAJ KUPWAD M. CORPORATION",
            "SHIRALA",
            "TASGAON",
            "WALWA",
        ],
        SATARA: [
            "JAOLI",
            "KARAD",
            "KHANDALA",
            "KHATAV",
            "KOREGAON",
            "MAHABALESHWAR",
            "MAN",
            "PATAN",
            "PHALTAN",
            "SATARA",
            "WAI",
        ],
        SINDHUDURG: [
            "DEVGAD",
            "DODAMARG",
            "KANKAVLI",
            "KUDAL",
            "MALVAN",
            "SAWANTWADI",
            "VAIBHAVWADI",
            "VENGURLE",
        ],
        SOLAPUR: [
            "AKKALKOT",
            "BARSHI",
            "KARMALA",
            "MADHA",
            "MALSHIRAS",
            "MANGALWEDHA",
            "MOHOL",
            "PANDHARPUR",
            "SANGOLA",
            "SOLAPUR NORTH",
            "SOLAPUR SOUTH",
            "SOLAPUR URC-1",
            "SOLAPUR URC-2",
        ],
        THANE: [
            "AMBERNATH",
            "BHIVANDI MNC-URC1",
            "BHIWANDI",
            "KALYAN",
            "KALYAN DOMBIVLI-URC1",
            "MIRA BHAYANDAR",
            "MURBAD",
            "NAVI MUMBAI-URC1",
            "SHAHAPUR",
            "THANE MNC-URC1",
            "THANE MNC-URC2",
            "ULHASNAGAR- URC1",
        ],
        WARDHA: [
            "ARVI",
            "ASHTI",
            "DEOLI",
            "HINGANGHAT",
            "KARANJA",
            "SAMUDRAPUR",
            "SELOO",
            "WARDHA",
        ],
        WASHIM: [
            "KARANJA LAD",
            "MALEGAON",
            "MANGRULPIR",
            "MANORA",
            "RISOD",
            "WASHIM",
        ],
        YAVATMAL: [
            "ARNI",
            "BABHULGAON",
            "DARWHA",
            "DIGRAS",
            "GHATANJI",
            "KALAMB",
            "MAHAGAON",
            "MAREGAON",
            "NER",
            "PANDHARKAWADA",
            "PUSAD",
            "RALEGAON",
            "UMARKHED",
            "WANI",
            "YAVATMAL",
            "ZARI",
        ],
    },
    ML: {
        "EAST GARO HILLS": ["RONGJENG", "SAMANDA", "SONGSAK"],
        "EAST JAINTIA HILLS": ["KHLIEHRIAT", "SAIPUNG"],
        "EAST KHASI HILLS": [
            "KHATAR SHNONG - LAITKROH",
            "MAWKYNREW",
            "MAWLAI",
            "MAWPAT",
            "MAWPHLANG",
            "MAWRYNGKNENG",
            "MAWSYNRAM",
            "MYLLIEM",
            "PYNURSLA",
            "SHELLA BHOLAGANJ",
            "SHILLONG MUNICIPAL AND CANTT.",
            "SOHIONG",
        ],
        "EASTERN WEST KHASI HILLS": ["MAIRANG", "MAWTHADRAISHAN"],
        "NORTH GARO HILLS": ["BAJENGDOBA", "KHARKUTTA", "RESUBELPARA"],
        "RI BHOI": ["BHOIRYMBONG", "JIRANG", "UMLING", "UMSNING"],
        "SOUTH GARO HILLS": [
            "BAGHMARA",
            "CHOKPOT",
            "GASUAPARA",
            "RONGARA BLOCK",
        ],
        "SOUTH WEST GARO HILLS": ["BETASING", "DAMALGRE", "ZIKZAK"],
        "SOUTH WEST KHASI HILLS": ["MAWKYRWAT", "RANIKOR"],
        "WEST GARO HILLS": [
            "DADENGGRE",
            "DALU",
            "DEMDEMA",
            "GAMBEGRE",
            "RONGRAM",
            "SELSELLA",
            "TIKRIKILLA",
            "TURA URBAN AREA",
        ],
        "WEST JAINTIA HILLS": ["AMLAREM", "LASKEIN", "THADLASKEIN"],
        "WEST KHASI HILLS": ["MAWSHYNRUT", "NONGSTOIN"],
    },
    MN: {
        BISHNUPUR: ["BISHNUPUR", "MOIRANG"],
        CHANDEL: ["CHAKPIKARONG", "CHANDEL"],
        CHURACHANDPUR: ["CHURACHANDPUR", "HENGLEP", "SAMULAMLAN", "SINGNGAT"],
        "IMPHAL EAST": ["IRILBUNG", "SAWOMBUNG IMPHAL EAST- I"],
        "IMPHAL WEST": ["HAORANG", "IMC", "WANGOI"],
        JIRIBAM: ["JIRIBAM"],
        KAKCHING: ["KAKCHING"],
        KAMJONG: ["KAMJONG", "KASOM KL.", "PHUNGYAR"],
        KANGPOKPI: ["KANGPOKPI", "SAIKUL", "SAITU"],
        NONEY: ["NUNGBA"],
        PHERZAWL: ["THANLON", "TIPAIMUKH"],
        SENAPATI: ["PAOMATA", "PURUL", "TADUBI"],
        TAMENGLONG: ["TAMEI", "TAMENGLONG", "TOUSEM"],
        TENGNOUPAL: ["MACHI", "TENGNOUPAL"],
        THOUBAL: ["THOUBAL"],
        UKHRUL: ["CHINGAI", "UKHRUL"],
    },
    MP: {
        "AGAR MALWA": ["AGAR", "BAROD", "NALKHEDA", "SUSNER"],
        ALIRAJPUR: [
            "ALIRAJPUR",
            "BHABARA",
            "JOBAT",
            "KATTHIWARA",
            "SONDWA",
            "UDAYGARH",
        ],
        ANUPPUR: ["ANUPPUR", "JAITHARI", "KOTMA", "PUSHPRAJ GARH"],
        ASHOKNAGAR: ["ASHOKNAGAR", "CHANDERI", "ISAGARH", "MUNGAOLI"],
        BALAGHAT: [
            "BAIHAR",
            "BALAGHAT",
            "BIRSA",
            "KATANGI",
            "KHAIRLANJI",
            "KIRNAPUR",
            "LAL BURRA",
            "LANJI",
            "PARASWADA",
            "WARA SEONI",
        ],
        BARWANI: [
            "BARWANI",
            "NIWALI",
            "PANSEMAL",
            "PATI",
            "RAJPUR",
            "SENDHWA",
            "THIKRI",
        ],
        BETUL: [
            "AMLA",
            "ATHNER",
            "BETUL",
            "BHAINSDEHI",
            "BHIMPUR",
            "CHICHOLI",
            "GHORADONGRI",
            "MULTAI",
            "PRABHAT PATTAN",
            "SHAHPUR",
        ],
        BHIND: ["ATER", "BHIND", "GOHAD", "LAHAR", "MEHGAON", "ROUN"],
        BHOPAL: [
            "BERASIA",
            "PHANDA RURAL",
            "PHANDA URBAN NEW",
            "PHANDA URBAN OLD",
        ],
        BURHANPUR: ["BURHANPUR", "KHAKNAR"],
        CHHATARPUR: [
            "BADA MALEHRA",
            "BARIGARH",
            "BIJAWAR",
            "BUXWAHA",
            "ISHANAGAAR",
            "LAUNDI",
            "NOWGONG",
            "RAJNAGAR",
        ],
        CHHINDWARA: [
            "AMARWADA",
            "BICHHUA",
            "CHHINDWARA",
            "CHOURAI",
            "HARRAI",
            "JUNNARDEO",
            "MOHKHED",
            "PANDHURNA",
            "PARASIA",
            "SAUSAR",
            "TAMIA",
        ],
        DAMOH: [
            "BATIYAGARH",
            "DAMOH",
            "HATTA",
            "JABERA",
            "PATERA",
            "PATHARIA",
            "TENDUKHEDA",
        ],
        DATIA: ["BHANDER", "DATIA", "SEONDHA"],
        DEWAS: [
            "BAGLI",
            "DEWAS",
            "KANNOD",
            "KHATEGAON",
            "SONKATCH",
            "TONKKHURD",
        ],
        DHAR: [
            "BADNAVAR",
            "BAGH",
            "DAHI",
            "DHAR",
            "DHARAMPURI",
            "GANDHWANI",
            "KUKSHI",
            "MANAVAR",
            "NALCHHA",
            "NISARPUR",
            "SARDARPUR",
            "TIRLA",
            "UMARBAN",
        ],
        DINDORI: [
            "AMARPUR",
            "BAJAG",
            "DINDORI",
            "KARANJIA",
            "MEHANDWANI",
            "SAMNAPUR",
            "SHAHPURA",
        ],
        GUNA: ["ARON", "BAMORI", "CHACHODA", "GUNA", "RAGHOGARH"],
        GWALIOR: [
            "BHITARWAR",
            "DABRA",
            "GHATIGAON",
            "MORAR(RURAL)",
            "MORAR(URBON)",
        ],
        HARDA: ["HARDA", "KHIRKIYA", "TIMARNI"],
        HOSHANGABAD: [
            "BABAI",
            "BANKHEDI",
            "HOSHANGABAD",
            "KESLA",
            "PIPERIYA",
            "SEONI MALWA",
            "SOHAGPUR",
        ],
        INDORE: ["DEPALPUR", "INDORE RURAL", "INDORE URBAN", "MHOW", "SANWER"],
        JABALPUR: [
            "JABALPUR (RURAL)",
            "JABALPUR (URBAN)",
            "KUNDAM",
            "MAJHOLI",
            "PANAGAR",
            "PATAN",
            "SHAHPURA",
            "SIHORA",
        ],
        JHABUA: [
            "JHABUA",
            "MEGHNAGAR",
            "PETLAWAD",
            "RAMA",
            "RANAPUR",
            "THANDLA",
        ],
        KATNI: [
            "BADWARA",
            "BAHORIBAND",
            "DHEEMAR KHEDA",
            "KATNI",
            "RITHI",
            "VIJAY RAGHAVGARH",
        ],
        KHANDWA: [
            "BALADI",
            "CHHAIGAONMAKHAN",
            "HARSUD",
            "KHALWA",
            "KHANDWA",
            "PANDHANA",
            "PUNASA",
        ],
        KHARGONE: [
            "BADWAHA",
            "BHAGWANPURA",
            "BHIKANGAON",
            "GOGAWAN",
            "JHIRNIYA",
            "KASRAWAD",
            "KHARGONE",
            "MAHESHWAR",
            "SEGAON",
        ],
        MANDLA: [
            "BEEJADANDI",
            "BICHHIA",
            "GHUGHRI",
            "MANDLA",
            "MAWAI",
            "MOHGAON",
            "NAINPUR",
            "NARAYANGANJ",
            "NIWAS",
        ],
        MANDSAUR: ["BHANPURA", "GAROTH", "MALHARGARH", "MANDSAUR", "SITAMAU"],
        MORENA: [
            "AMBAH",
            "JOURA",
            "KAILARAS",
            "MORENA",
            "PAHARGARH",
            "PORSA",
            "SABALGARH",
        ],
        NARSIMHAPUR: [
            "CHAWARPATHA",
            "CHICHLI",
            "GOTEGAON (SHRIDHAM)",
            "KARELI",
            "NARSINGHPUR",
            "SAIKHEDA",
        ],
        NEEMUCH: ["JAWAD", "MANASA", "NEEMUCH"],
        NIWARI: ["NIWARI", "PRATHVIPUR"],
        PANNA: ["AJAIGARH", "GUNOUR", "PANNA", "PAWAI", "SHAHNAGAR"],
        RAISEN: [
            "BADI",
            "BEGAMGANJ",
            "GAIRATGANJ",
            "OBEDULLAGANJ",
            "SANCHI",
            "SILWANI",
            "UDAIPURA",
        ],
        RAJGARH: [
            "BIAORA",
            "KHILCHIPUR",
            "NARSINGHGARH",
            "RAJGARH",
            "SARANGPUR",
            "ZIRAPUR",
        ],
        RATLAM: ["ALOT", "BAJNA", "JAORA", "PIPLODA", "RATLAM", "SAILANA"],
        REWA: [
            "GANGEO",
            "HANUMANA",
            "JAWA",
            "MAUGANJ",
            "NAIGARHI",
            "RAIPUR(K)",
            "REWA",
            "SIRMOUR",
            "TEONTHAR",
        ],
        SAGAR: [
            "BANDA",
            "BEENA",
            "DEORI",
            "JAISINAGAR",
            "KESLI",
            "KHURAI",
            "MALTHON",
            "RAHATGARH",
            "REHLI",
            "SAGAR",
            "SHAHGARH",
        ],
        SATNA: [
            "AMARPATAN",
            "MAIHAR",
            "MAJHGWAN",
            "NAGOD",
            "RAM NAGAR",
            "RAMPUR BAGHELAN",
            "SOHAWAL",
            "UNCHERA",
        ],
        SEHORE: ["ASHTA", "BUDHANI", "ICHHAWAR", "NASRULLAGANJ", "SEHORE"],
        SEONI: [
            "BARGHAT",
            "CHHAPARA",
            "DHANORA",
            "GHANSORE",
            "KEOLARI",
            "KURAI",
            "LAKHNADON",
            "SEONI",
        ],
        SHAHDOL: ["BEOHARI", "BURHAR", "GOHPARU", "JAISINGHNAGAR", "SOHAGPUR"],
        SHAJAPUR: ["KALAPIPAL", "M. BARODIYA", "SHAJAPUR", "SHUJALPUR"],
        SHEOPUR: ["KARAHAL", "SHEOPUR", "VIJAYPUR"],
        SHIVPURI: [
            "BADARWAS",
            "KARAIRA",
            "KHANIYADHANA",
            "KOLARAS",
            "NARWAR",
            "PICHHORE",
            "POHRI",
            "SHIVPURI",
        ],
        SIDHI: ["KUSAMI", "MAJHAULI", "RAMPUR NAIKIN", "SIDHI", "SIHAWAL"],
        SINGRAULI: ["CHITARANGI", "DEOSAR", "WAIDHAN"],
        TIKAMGARH: ["BALDEWGARH", "JATARA", "PALERA", "TIKAMGARH"],
        UJJAIN: [
            "BARNAGAR",
            "GHATTIA",
            "KHACHROD",
            "MAHIDPUR",
            "TARANA",
            "UJJAIN RURAL",
            "UJJAIN URBAN",
        ],
        UMARIA: ["KARKELI", "MANPUR", "PALI"],
        VIDISHA: [
            "BASODA",
            "GYARASPUR",
            "KURWAI",
            "LATERI",
            "NATERAN",
            "SIRONJ",
            "VIDISHA",
        ],
    },
    MZ: {
        AIZAWL: [
            "AIBAWK",
            "BAWNGKAWN",
            "BUNGKAWN",
            "CHANMARI",
            "DARLAWN",
            "ELECTRIC",
            "KHAWRUHLIAN",
            "THINGSULTHLIAH",
            "VENGHLUI",
            "ZEMABAWK",
        ],
        CHAMPHAI: ["CHAMPHAI", "VANZAU"],
        HNAHTHIAL: ["EASTERN"],
        KHAWZAWL: ["KHAWZAWL"],
        KOLASIB: ["BILKHAWTHLIR", "KAWNPUI", "KOLASIB"],
        LAWNGTLAI: [
            "BARAPANSURY",
            "BUNGTLANG",
            "KAMALANAGAR",
            "LAWNGTLAI",
            "SANGAU",
        ],
        LUNGLEI: ["BUNGHMUN", "STATION", "TLABUNG"],
        MAMIT: ["MAMIT", "RAWPUICHHIP", "REIEK", "W.PHAILENG"],
        SAIHA: ["SIAHA", "TIPA"],
        SAITUAL: ["NGOPA", "SAITUAL"],
        SERCHHIP: ["LUNGPHO", "N.VANLAIPHAI", "SERCHHIP"],
    },
    NL: {
        DIMAPUR: [
            "DHANSIRIPAR",
            "DIMAPUR URBAN",
            "KUSHIABILL",
            "MEDZIPHEMA",
            "NUILAND",
        ],
        KIPHIRE: ["KIPHIRE", "PUNGRO", "SEYOCHUNG"],
        KOHIMA: [
            "CHIEPHOBOZOU",
            "L. KHEL KOHIMA",
            "SECHU ZUBZA",
            "TSEMINYU",
            "VISWEMA",
        ],
        LONGLENG: ["LONGLENG", "TAMLU"],
        MOKOKCHUNG: [
            "CHANGTONGYA-B",
            "KHENSA",
            "KOBULONG",
            "MANGKOLEMBA-II",
            "MOKOKCHUNG VILLAGE",
            "WATIYIM",
        ],
        MON: ["ABOI", "MON", "TIZIT", "TOBU", "WAKCHING"],
        PEREN: ["AHTHIBUNG", "PEREN", "TENING"],
        PHEK: ["CHOZUBA", "MELURI", "PFUTSERO", "PHEK"],
        TUENSANG: ["HAKUSHANG", "LONGKHIM", "NOKLAK", "NOKSEN", "SHAMATOR"],
        WOKHA: ["BHANDARI", "SANIS", "WOKHA"],
        ZUNHEBOTO: ["AGHUNATO", "AKULUTO", "PUGHOBOTO", "SATAKHA", "ZUNHEBOTO"],
    },
    OR: {
        ANGUL: [
            "ANGUL",
            "ATHAMALLIK",
            "BANARPAL",
            "CHHENDIPADA",
            "KANIHA",
            "KISHORENAGAR",
            "PALLAHARA",
            "TALCHER",
        ],
        BALASORE: [
            "BAHANAGA",
            "BALIAPAL",
            "BASTA",
            "BHOGARAI",
            "JALESWAR",
            "KHAIRA",
            "NILGIRI",
            "OUPADA",
            "REMUNA",
            "SADAR",
            "SIMULIA",
            "SORO",
        ],
        BARAGARH: [
            "AMBABHONA",
            "ATTABIRA",
            "BARGARH",
            "BARPALI",
            "BHATALI",
            "BHEDEN",
            "BIJEPUR",
            "GAISILET",
            "JHARBANDH",
            "PAIKMAL",
            "RAJBORASAMBAR",
            "SOHELLA",
        ],
        BHADRAK: [
            "BASUDEVPUR",
            "BHADRAK",
            "BHANDARIPOKHARI",
            "BONTH",
            "CHANDABALI",
            "DHAMNAGAR",
            "TIHIDI",
        ],
        BOLANGIR: [
            "AGALPUR",
            "BALANGIR",
            "BANGOMUNDA",
            "BELPADA",
            "DEOGAON",
            "GUDVELA",
            "KHAPRAKHOL",
            "LOISINGHA",
            "MURIBAHAL",
            "PATNAGARH",
            "PUINTALA",
            "SAINTALA",
            "TITILAGARH",
            "TUREKELA",
        ],
        BOUDH: ["BOUDH", "HARABHANGA", "KANTAMAL"],
        CUTTACK: [
            "ATHGARH",
            "BANKI",
            "BARAMBA",
            "BARANGA",
            "CUTTACK MC",
            "CUTTACK SADAR",
            "DOMPARA",
            "KANTAPARA",
            "MAHANGA",
            "NARSINGHPUR",
            "NIALI",
            "NISCHINTAKOILI",
            "SALIPUR",
            "TANGI",
            "TIGIRIA",
        ],
        DEOGARH: ["BARKOTE", "REAMAL", "TILEIBANI"],
        DHENKANAL: [
            "BHUBAN",
            "DHENKANAL SADAR",
            "GONDIA",
            "HINDOL",
            "KAMAKHYANAGAR",
            "KANKADAHAD",
            "ODAPADA",
            "PARJANG",
        ],
        GAJAPATI: [
            "GOSANI",
            "GUMMA",
            "KASHINAGAR",
            "MOHANA",
            "NUAGADA",
            "R.UDAYAGIRI",
            "RAYAGADA",
        ],
        GANJAM: [
            "ASKA",
            "BEGUNIAPADA",
            "BELLAGUNTHA",
            "BHANJANAGAR",
            "BUGUDA",
            "CHATRAPUR",
            "CHIKITI",
            "DHARAKOTE",
            "DIGAPAHANDI",
            "GANJAM",
            "HINJILICUT",
            "JAGANATHPRASAD",
            "KABISURYANAGAR",
            "KHALLIKOTE",
            "KUKUDAKHANDI",
            "PATRAPUR",
            "POLASARA",
            "PURUSOTAMPUR",
            "RANGEILUNDA",
            "SANAKHEMUNDI",
            "SHERAGADA",
            "SURADA",
        ],
        JAGATSINGHPUR: [
            "BALIKUDA",
            "BIRIDI",
            "ERASAMA",
            "JAGATSINGHPUR",
            "KUJANG",
            "NAUGAON",
            "RAGHUNATHPUR",
            "TIRTOL",
        ],
        JAJPUR: [
            "BARCHANA",
            "BARI",
            "BINJHARPUR",
            "DANAGADI",
            "DASARATHPUR",
            "DHARMASALA",
            "JAJPUR",
            "KORAI",
            "RASULPUR",
            "SUKINDA",
        ],
        JHARSUGUDA: [
            "JHARSUGUDA",
            "KIRMIRA",
            "KOLABIRA",
            "LAIKERA",
            "LAKHANPUR",
        ],
        KALAHANDI: [
            "BHAWANIPATNA",
            "DHARAMGARH",
            "GOLAMUNDA",
            "JAIPATNA",
            "JUNAGARH",
            "KALAMPUR",
            "KARLAMUNDA",
            "KESINGA",
            "KOKSARA",
            "LANJIGARH",
            "M.RAMPUR",
            "NARLA",
            "TH RAMPUR",
        ],
        KANDHAMAL: [
            "BALLIGUDA",
            "CHAKAPAD",
            "DARINGBADI",
            "G.UDAYAGIRI",
            "K.NUAGAM",
            "KHAJURIPADA",
            "KOTAGHAR",
            "PHIRINGIA",
            "PHULBANI",
            "RAIKIA",
            "TIKABALI",
            "TUMUDIBANDHA",
        ],
        KENDRAPARA: [
            "AUL",
            "DERABISH",
            "GARADAPUR",
            "KENDRAPARA",
            "MAHAKALPARA",
            "MARSHAGHAI",
            "PATTAMUNDAI",
            "RAJKANIKA",
            "RAJNAGAR",
        ],
        KEONJHAR: [
            "ANANDAPUR",
            "BANSPAL",
            "CHAMPUA",
            "GHASIPURA",
            "GHATAGAON",
            "HARICHANDANPUR",
            "HATADIHI",
            "JHUMPURA",
            "JODA",
            "KEONJHAR",
            "PATNA",
            "SAHARAPADA",
            "TELKOI",
        ],
        KHURDHA: [
            "BALIANTA",
            "BALIPATNA",
            "BANAPUR",
            "BEGUNIA",
            "BHUBANESWAR",
            "BHUBANESWAR MC",
            "BOLGARH",
            "CHILIKA",
            "JATNI",
            "KHORDHA",
            "TANGI",
        ],
        KORAPUT: [
            "BANDHUGAM",
            "BOIPARIGUDA",
            "BORIGUMMA",
            "DASMANTPUR",
            "JEYPORE",
            "KORAPUT",
            "KOTPAD",
            "KUNDRA",
            "LAMTAPUT",
            "LAXMIPUR",
            "NANDAPUR",
            "NARAYANAPATNA",
            "POTTANGI",
            "SEMILIGUDA",
        ],
        MALKANGIRI: [
            "CHITRAKONDA",
            "KALIMELA",
            "KHAIRPUT",
            "KORUKONDA",
            "MALKANGIRI",
            "MATHILI",
            "PODIA",
        ],
        MAYURBHANJ: [
            "BAHALDA",
            "BANGRIPOSI",
            "BARASAHI",
            "BARIPADA",
            "BETNOTI",
            "BIJATOLA",
            "BISOI",
            "G B NAGAR",
            "JAMDA",
            "JASHIPUR",
            "KAPTIPADA",
            "KARANJIA",
            "KHUNTA",
            "KULIANA",
            "KUSUMI",
            "MORADA",
            "RAIRANGPUR",
            "RARUAN",
            "RASGOVINDPUR",
            "SARASKANA",
            "SHAMAKHUNTA",
            "SUKRULI",
            "SULIAPADA",
            "THAKURMUNDA",
            "TIRING",
            "UDALA",
        ],
        NABARANGPUR: [
            "CHANDAHANDI",
            "DABUGAM",
            "JHARIGAM",
            "KOSAGUMUDA",
            "NABARANGPUR",
            "NANDAHANDI",
            "PAPADAHANDI",
            "RAIGHAR",
            "TENTULIKHUNTI",
            "UMERKOTE",
        ],
        NAYAGARH: [
            "BHAPUR",
            "DASPALLA",
            "GANIA",
            "KHANDAPADA",
            "NAYAGARH",
            "NUAGAON",
            "ODAGAON",
            "RANPUR",
        ],
        NUAPADA: ["BODEN", "KHARIAR", "KOMNA", "NUAPADA", "SINAPALI"],
        PURI: [
            "ASTARANG",
            "BRAHMAGIRI",
            "DELANG",
            "GOP",
            "KAKATPUR",
            "KANAS",
            "KRUSHNAPRASAD",
            "NIMAPARA",
            "PIPILI",
            "PURI SADAR",
            "SATYABADI",
        ],
        RAYAGADA: [
            "BISSAMCUTTACK",
            "CHANDRAPUR",
            "GUDARI",
            "GUNUPUR",
            "K.SINGPUR",
            "KASIPUR",
            "KOLNARA",
            "MUNIGUDA",
            "PADAMPUR",
            "RAMANAGUDA",
            "RAYAGADA",
        ],
        SAMBALPUR: [
            "BAMRA",
            "DHANKAUDA",
            "JAMANKIRA",
            "JUJUMURA",
            "KUCHINDA",
            "MANESWAR",
            "NAKTIDEUL",
            "RAIRAKHOL",
            "RENGALI",
        ],
        SONEPUR: [
            "BINKA",
            "BIRMAHARAJPUR",
            "DUNGURIPALI",
            "SONEPUR",
            "TARVA",
            "ULLUNDA",
        ],
        SUNDERGARH: [
            "BALISANKARA",
            "BARGAON",
            "BISRA",
            "BONAI",
            "GURUNDIA",
            "HEMGIRI",
            "KOIRA",
            "KUARMUNDA",
            "KUTRA",
            "LAHUNIPARA",
            "LATHIKATA",
            "LEPHRIPARA",
            "NUAGAON",
            "RAJGANGPUR",
            "SUBDEGA",
            "SUNDARGARH",
            "TANGARPALI",
        ],
    },
    PB: {
        AMRITSAR: [
            "AJNALA-1",
            "AJNALA-2",
            "AMRITSAR 1",
            "AMRITSAR 2",
            "AMRITSAR 3",
            "AMRITSAR 4",
            "CHOGAWAN 1",
            "CHOGAWAN 2",
            "JANDIALA GURU",
            "MAJITHA 1",
            "MAJITHA 2",
            "RAYYA 1",
            "RAYYA 2",
            "TARSIKA",
            "VERKA",
        ],
        BARNALA: ["BARNALA", "MEHAL KALAN", "SEHNA"],
        BATHINDA: [
            "BATHINDA",
            "BHAGTA BHAI KA",
            "GONIANA MANDI",
            "MAUR",
            "RAMPURA PHUL",
            "SANGAT",
            "TALWANDI SABO",
        ],
        FARIDKOT: [
            "FARIDKOT-01",
            "FARIDKOT-02",
            "FARIDKOT-03",
            "JAITU",
            "KOTKAPURA",
        ],
        "FATEHGARH SAHIB": [
            "AMLOH",
            "BASSI PATHANA",
            "FATEHGARH SAHIB",
            "JAKHWALI",
            "KHAMANO",
            "KHERA",
            "MANDI GOBINDGARH",
            "TARKHAN MAJRA",
        ],
        FAZILKA: [
            "ABOHAR-1",
            "ABOHAR-2",
            "FAZILKA-1",
            "FAZILKA-2",
            "GURUHARSHAI-3 (AT JBD)",
            "JALALABAD-1",
            "JALALABAD-2",
            "KHUIAN SARWAR",
        ],
        FIROZPUR: [
            "FEROZEPUR-1",
            "FEROZEPUR-2",
            "FEROZEPUR-3",
            "GHALL KHURD",
            "GURUHARSHAI-1",
            "GURUHARSHAI-2",
            "MAKHU",
            "MALLANWALA KHAS",
            "MAMDOT",
            "SATIYE WALA",
            "ZIRA",
        ],
        GURDASPUR: [
            "BATALA-1",
            "BATALA-2",
            "DERA BABA NANAK - 1",
            "DERA BABA NANAK-2",
            "DHARIWAL-1",
            "DHARIWAL-2",
            "DHIANPUR",
            "DINANAGAR - 1",
            "DINANAGAR-2",
            "DORANGLA",
            "FATEHGARH CHURIAN",
            "GURDASPUR-1",
            "GURDASPUR-2",
            "KAHNUWAN-1",
            "KAHNUWAN-2",
            "KALANAUR",
            "QADIAN - 1",
            "QADIAN-2",
            "SHRI HARGOBINDPUR",
        ],
        HOSHIARPUR: [
            "BHUNGA 1",
            "BHUNGA 2",
            "BULLOWAL",
            "DASUYA 1",
            "DASUYA 2",
            "GARSHANKER 1",
            "GARSHANKER 2",
            "HAJIPUR",
            "HSP 1A",
            "HSP 1B",
            "HSP 2A",
            "HSP 2B",
            "KAMAHI DEVI",
            "KOT FATUHI",
            "MAHILPUR 1",
            "MAHILPUR 2",
            "MUKERIAN 1",
            "MUKERIAN 2",
            "TALWARA",
            "TANDA 1",
            "TANDA 2",
        ],
        JALANDHAR: [
            "ADAMPUR",
            "ALAWALPUR",
            "BHOGPUR",
            "EAST-1",
            "EAST-4",
            "GORAYA-1",
            "GORAYA-2",
            "KARTARPUR",
            "LOHIAN KHASS",
            "NAKODER-01",
            "NAKODER-02",
            "NOORMAHAL",
            "PHILLOUR",
            "SHAHKOT-01",
            "SHAHKOT-02",
            "WEST-01",
            "WEST-02",
        ],
        KAPURTHALA: [
            "BHOLATH",
            "KAPURTHALA-1",
            "KAPURTHALA-2",
            "KAPURTHALA-3",
            "MASITTA",
            "NADALA",
            "PHAGWARA-1",
            "PHAGWARA-2",
            "SULTANPUR LODHI-1",
        ],
        LUDHIANA: [
            "DEHLON-1",
            "DEHLON-2",
            "DORAHA",
            "JAGRAON",
            "KHANNA-1",
            "KHANNA-2",
            "LUDHIANA-1",
            "LUDHIANA-2",
            "MACHHIWARA-1",
            "MACHHIWARA-2",
            "MANGAT-1",
            "MANGAT-2",
            "MANGAT-3",
            "PAKHOWAL",
            "RAIKOT",
            "SAMRALA",
            "SIDHWAN BET-1",
            "SIDHWAN BET-2",
            "SUDHAR",
        ],
        MALERKOTLA: ["AHMEDGARH", "MALERKOTLA - 1", "MALERKOTLA - 2"],
        MANSA: [
            "BUDHLADA-I",
            "BUDHLADA-II AT BARETA",
            "JHUNIR-I",
            "JHUNIR-II AT SDGH",
            "MANSA",
        ],
        MOGA: [
            "BAGHA PURANA",
            "DHARAMKOT 1",
            "DHARAMKOT 2",
            "MOGA 1",
            "MOGA 2",
            "NIHAL SINGH WALA",
        ],
        MUKTSAR: [
            "GIDDERBAHA 1",
            "GIDDERBAHA 2",
            "LAMBI",
            "MALOUT",
            "MUKTSAR 1",
            "MUKTSAR 2",
        ],
        PATHANKOT: [
            "BAMIAL",
            "DHAR-1",
            "DHAR-2",
            "NAROT JAIMAL SINGH",
            "PATHANKOT-1",
            "PATHANKOT-2",
            "PATHANKOT-3",
        ],
        PATIALA: [
            "BABARPUR AT NABHA",
            "BHADSON-1",
            "BHADSON-2",
            "BHUNERHERI-1",
            "BHUNERHERI-2",
            "DARIAN",
            "DEVIGARH",
            "GHANOUR",
            "PATIALA-1",
            "PATIALA-2",
            "PATIALA-3",
            "RAJPURA-1",
            "RAJPURA-2",
            "SAMANA-1 (AT PATRAN)",
            "SAMANA-2",
            "SAMANA-3",
        ],
        RUPNAGAR: [
            "ANANDPUR SAHIB",
            "CHAMKAUR SAHIB",
            "JHAJ",
            "KIRATPUR SAHIB",
            "MIANPUR",
            "MORINDA",
            "NANGAL",
            "ROPAR-2",
            "SALURA",
            "TAKHATGARH",
        ],
        SANGRUR: [
            "CHEEMA",
            "DHURI",
            "LEHRAGAGA",
            "MOONAK",
            "SANGRUR - 1",
            "SANGRUR - 2",
            "SHERPUR",
            "SUNAM - 1",
            "SUNAM - 2",
        ],
        "SAS NAGAR": [
            "BANUR",
            "DERA BASSI 1",
            "DERA BASSI 2",
            "KHARAR 1",
            "KHARAR 2",
            "KHARAR 3",
            "KURALI",
            "MAJRI",
        ],
        "SBS NAGAR": [
            "AUR",
            "BALACHAUR-1",
            "BALACHAUR-2",
            "BANGA",
            "MUKANDPUR",
            "NAWANSHAHAR-1",
            "SAROYA",
        ],
        "TARAN TARAN": [
            "BHIKHIWIND",
            "CHOHLA SAHIB",
            "GANDIWIND",
            "KHADUR SAHIB",
            "NAUSHEHRA PANNUAN",
            "NOORDI",
            "PATTI",
            "TARNTARAN PROPER",
            "VALTOHA",
        ],
    },
    PY: {
        KARAIKAL: ["KARAIKAL"],
        MAHE: ["MAHE"],
        PONDICHERRY: ["BRC-1", "BRC-2", "BRC-3"],
        YANAM: ["YANAM"],
    },
    RJ: {
        AJMER: [
            "AJMER RURAL",
            "AJMER(U)",
            "ARAIN",
            "JAWAJA",
            "KISHANGARH",
            "PISANGAN",
            "SRI NAGAR",
        ],
        ALWAR: [
            "GOVINDGARH",
            "KATHUMAR",
            "KISHANGARH BAS",
            "LAKSHMANGARH",
            "MALAKHEDA",
            "RAINI",
            "RAJGARH",
            "RAMGARH",
            "THANAGAZI",
            "UMRAIN",
        ],
        ANOOPGARH: ["ANOOPGARH", "GHARASANA", "VIJAYNAGAR"],
        BALOTARA: [
            "BALOTRA",
            "GIDA",
            "KALYANPUR",
            "PATODI",
            "SAMDARI",
            "SINDHARI",
            "SIWANA",
        ],
        BANSWARA: [
            "ANANDPURI",
            "ARTHUNA",
            "BAGIDORA",
            "BANSWARA",
            "CHOTISARVAN",
            "GANGADTALAI",
            "GARHI",
            "GHATOL",
            "KUSHALGARH",
            "SAJJANGARH",
            "TALWARA",
        ],
        BARAN: [
            "ANTA",
            "ATRU",
            "BARAN",
            "CHHABRA",
            "CHHIPABAROD",
            "KISHANGANJ",
            "MANGROL",
            "SHAHBAD",
        ],
        BARMER: [
            "AADEL",
            "BAITU",
            "BALOTRA",
            "BARMER",
            "BARMER RURAL",
            "CHOHTAN",
            "DHANAU",
            "DHORIMANA",
            "FAGLIYA",
            "GADRAROAD",
            "GUDAMALANI",
            "PANYLA KLA",
            "RAMSAR",
            "SEDWA",
            "SHIV",
        ],
        BEAWAR: ["JAITARAN", "JAWAJA", "MASUDA", "RAIPUR"],
        BHARATPUR: [
            "BAYANA",
            "BHUSAWAR",
            "NADBAI",
            "ROOPWAS",
            "SEWAR",
            "UCHAIN",
            "WEIR",
        ],
        BHILWARA: [
            "AASIND",
            "BADNOR",
            "BANERA",
            "BIJOLIYA",
            "HURDA",
            "KAREDA",
            "KOTRI",
            "MANDAL",
            "MANDALGARH",
            "RAIPUR",
            "SAHADA",
            "SUWANA",
        ],
        BIKANER: [
            "BAJJU KHALSA",
            "BIKANER",
            "KHAJUWALA",
            "KOLAYAT",
            "LUNKARANSAR",
            "NOKHA",
            "PANCHOO",
            "POOGAL",
            "SHRI DUNGARGARH",
        ],
        BUNDI: ["BUNDI", "HINDOLI", "K.PATAN", "NAINWA", "TALERA"],
        CHITTAURGARH: [
            "BADI SADRI",
            "BEGUN",
            "BHADESAR",
            "BHAINSROADGARH",
            "BHOPAL SAGAR",
            "CHITTORGARH",
            "DUNGLA",
            "GANGRAR",
            "KAPASAN",
            "NIMBAHERA",
            "RASHMI",
        ],
        CHURU: [
            "BIDASAR",
            "CHURU",
            "RAJGARH",
            "RATANGARH",
            "SARDARSHAHAR",
            "SUJANGARH",
            "TARANAGAR",
        ],
        DAUSA: [
            "BAIJUPADA",
            "BANDIKUI",
            "BASWA",
            "DAUSA",
            "LALSOT",
            "LAWAN",
            "MAHWA",
            "NANGAL RAJAWATAN",
            "RAMGARH PACHWARA",
            "SIKANDARA",
            "SIKRAI",
        ],
        DEEG: ["DEEG", "KAMAN", "KUMHER", "NAGAR", "PAHADI"],
        DHAULPUR: [
            "BARI",
            "BASERI",
            "DHOLPUR",
            "RAJAKHERA",
            "SAIPAU",
            "SARAMATHURA",
        ],
        "DIDWANA-KUCHAMAN": [
            "DEEDWANA",
            "KUCHAMAN",
            "LADNUN",
            "MAKRANA",
            "MOLASAR",
            "NAWA",
            "PARBATSAR",
        ],
        DUDU: ["DUDU", "MAUZAMABAD", "PHAGI"],
        DUNGARPUR: [
            "ASPUR",
            "BICCHIWARA",
            "CHIKHALI",
            "DOVDA",
            "DUNGARPUR",
            "GALIYAKOT",
            "JHONTHARI",
            "SABLA",
            "SAGWARA",
            "SIMALWARA",
        ],
        GANGANAGAR: [
            "ANOOPGARH",
            "KARANPUR",
            "PADAMPUR",
            "RAISINGHNAGAR",
            "SADULSHAHAR",
            "SRI GANGANAGAR",
            "SURATGARH",
        ],
        "GANGAPUR CITY": ["BAMANWAS", "GANGAPUR CITY", "NADOTI"],
        HANUMANGARH: [
            "BHADRA",
            "HANUMANGARH",
            "NOHAR",
            "PILIBANGAN",
            "RAWATSAR",
            "SANGARIA",
            "TIBBI",
        ],
        JAIPUR: [
            "JAIPUR EAST",
            "JAIPUR WEST",
            "JHOTWARA CITY",
            "PAOTA",
            "SAMBHAR LAKE",
            "SANGANER CITY",
        ],
        "JAIPUR(RURAL)": [
            "AMBER",
            "ANDHI",
            "BASSI",
            "CHAKSU",
            "GOVINDGARH",
            "JALSU",
            "JAMWA RAMGARH",
            "JHOTWARA",
            "JOBNER",
            "KISHANGARH RENWAL",
            "KOTKHAWADA",
            "MADHORAJPURA",
            "SAMBHAR LAKE",
            "SANGANER",
            "SHAHPURA",
            "TUNGA",
            "VIRATNAGAR",
        ],
        JAISALMER: [
            "BHANIYANA",
            "FATHEGARH",
            "JAISALMER",
            "MOHANGARH",
            "NACHANA",
            "POKARAN",
            "SAM",
        ],
        JALOR: ["AAHOR", "BHINMAL", "JALORE", "JASWANTPURA", "SAYALA"],
        JHALAWAR: [
            "AKLERA",
            "BAKANI",
            "BHAWANIMANDI",
            "DAG",
            "JHALARAPATAN",
            "KHANPUR",
            "MANOHARTHANA",
            "SUNEL",
        ],
        JHUNJHUNU: [
            "ALSISAR",
            "BUHANA",
            "CHIRAWA",
            "JHUNJHUNU",
            "KHETRI",
            "MANDAWA",
            "NAWALGARH",
            "PILANI",
            "SINGHANA",
            "SURAJGARH",
            "UDAIPURWATI",
        ],
        JODHPUR: ["JODHPUR CITY", "KERU", "MANDORE", "PIPAR CITY", "TINWARI"],
        "JODHPUR(RURAL)": [
            "BALESAR",
            "BAORI",
            "BHOPALGARH",
            "BILARA",
            "CHAMU",
            "DHAWA",
            "KERU",
            "LUNI",
            "MANDORE",
            "OSIAN",
            "PIPAR CITY",
            "SEKHALA",
            "SHERGARH",
            "TINWARI",
        ],
        KARAULI: [
            "HINDAUN",
            "KARAULI",
            "MADRAIL",
            "MASALPUR",
            "SAPOTRA",
            "SHRI MAHAVEER JI",
            "TODABHIM",
        ],
        KEKRI: ["BHINAI", "KEKRI", "SARWAR", "SAWAR"],
        "KHAIRTHAL-TIJARA": [
            "KISHANGARH BAS",
            "KOTKASIM",
            "MUNDAWAR",
            "TIZARA",
        ],
        KOTA: ["ITAWA", "KHAIRABAD", "KOTA", "LADPURA", "SANGOD", "SULTANPUR"],
        "KOTPUTLI-BEHROR": [
            "BANSUR",
            "BEHROR",
            "KOTPUTLI",
            "NEEMRANA",
            "PAOTA",
        ],
        NAGAUR: [
            "BHERUNDA",
            "DEGANA",
            "JAYAL",
            "KHINWSAR",
            "KUCHAMAN",
            "MERTACITY",
            "MUNDWA",
            "NAGAUR",
            "RIYAN",
        ],
        "NEEM KA THANA": [
            "AJEETGARH",
            "NEEM KA THANA",
            "PATAN",
            "SHRI MADHOPUR",
        ],
        PALI: [
            "BALI",
            "DESURI",
            "MARWAR JUNCTION",
            "PALI",
            "RANI",
            "ROHAT",
            "SOJAT",
            "SUMERPUR",
        ],
        PHALODI: [
            "AAU",
            "BAP",
            "BAPINI",
            "DECHU",
            "GHANTIYALI",
            "LOHAWAT",
            "PHALODI",
        ],
        "PRATAPGARH (RAJ.)": [
            "ARNOD",
            "CHHOTI SADRI",
            "DALOT",
            "DHAMOTAR",
            "DHARIYAWAD",
            "PEEPALKHOOT",
            "PRATAPGARH",
            "SUHAGPURA",
        ],
        RAJSAMAND: [
            "AMET",
            "BHIM",
            "DELWADA",
            "DEOGARH",
            "KHAMNOR",
            "KUMBHALGARH",
            "RAILMAGRA",
            "RAJSAMAND",
        ],
        SALUMBAR: [
            "JAISAMAND",
            "JHALLARA",
            "LASADIYA",
            "SALUMBAR",
            "SARADA",
            "SEMARI",
        ],
        SANCHORE: ["BAGODA", "CHITALWANA", "RANIWARA", "SANCHORE", "SARNAU"],
        "SAWAI MADHOPUR": [
            "BOUNLI",
            "CHAUTH KA BARWARA",
            "GANGAPUR CITY",
            "KHANDAR",
            "MALARNA DUNGAR",
            "SAWAI MADHOPUR",
        ],
        SHAHPURA: ["JAHAJPUR", "SHAHPURA"],
        SIKAR: [
            "DANTARAMGARH",
            "DHOD",
            "FATEHPUR",
            "KHANDELA",
            "LAXMANGARH",
            "NECHWA",
            "PALSANA",
            "PATAN",
            "PIPRALI",
        ],
        SIROHI: ["ABU-ROAD", "PINDWARA", "REODAR", "SHEOGANJ", "SIROHI"],
        TONK: [
            "DEOLI",
            "MALPURA",
            "NEWAI",
            "PEEPLU",
            "TODARAISINGH",
            "TONK",
            "UNIYARA",
        ],
        UDAIPUR: [
            "BADGAON",
            "BHINDER",
            "GIRWA",
            "GOGUNDA",
            "JHADOL",
            "KHERWARA",
            "KOTRA",
            "KURABAD",
            "MAVLI",
            "NAYAGAON",
            "PHALASIYA",
            "RISHABHDEV",
            "SAYRA",
            "VALLABHNAGAR",
        ],
    },
    SK: {
        GANGTOK: ["KHAMDONG", "MARTAM", "NANDOK", "RAKDONG TINTEK", "RANKA"],
        GYALSHING: [
            "BERMIOK MARTAM",
            "CHONGRANG",
            "DENTAM",
            "GYALSHING",
            "YUKSAM",
        ],
        MANGAN: ["CHUNGTHANG", "KABI", "MANGAN", "PASSINGDONG"],
        NAMCHI: [
            "JORETHANG",
            "NAMCHI",
            "NAMTHANG",
            "RAVANGLA",
            "SIKKIP",
            "SUMBUK",
            "TEMI",
            "YANGANG",
        ],
        PAKYONG: ["DUGA", "PAKYONG", "PARAKHA", "REGU", "RHENOCK"],
        SORENG: [
            "BAIGUNEY",
            "CHUMBONG",
            "DARAMDIN",
            "KALUK",
            "MANGALBARIA",
            "SORENG",
        ],
    },
    TG: {
        ADILABAD: [
            "ADILABAD (RURAL)",
            "ADILABAD (URBAN)",
            "BAZARHATHNOOR",
            "BELA",
            "BHEEMPOOR",
            "BOATH",
            "GADIGUDA",
            "GUDIHATHNUR",
            "ICHODA",
            "INDERAVELLY",
            "JAINAD",
            "MAVALA",
            "NARNOOR",
            "NERADIGONDA",
            "SIRIKONDA",
            "TALAMADUGU",
            "TAMSI",
            "UTNUR",
        ],
        "BHADRADRI KOTHAGUDEM": [
            "ALLAPALLI",
            "ANNAPUREDDIPALLE",
            "ASWAPURAM",
            "ASWARAOPETA",
            "BHADRACHALAM",
            "BURGAMPADU",
            "CHANDRUGONDA",
            "CHERLA",
            "CHUNCHUPALLY",
            "DAMMAPETA",
            "DUMMUGUDEM",
            "GUNDALA",
            "JULURPAD",
            "KARAKAGUDEM",
            "KOTHAGUDEM",
            "LAXMIDEVIPALLI",
            "MANUGURU",
            "MULAKALAPALLE",
            "PALVANCHA",
            "PINAPAKA",
            "SUJATHANAGAR",
            "TEKULAPALLE",
            "YELLANDU",
        ],
        HANUMAKONDA: [
            "ATMAKUR",
            "BHEEMADEVARAPALLE",
            "DAMERA",
            "DHARMASAGAR",
            "ELKATHURTHI",
            "HANAMKONDA",
            "HASANPARTHY",
            "INAVOLE",
            "KAMALAPUR",
            "KHAZIPET",
            "NADIKUDA",
            "PARKAL",
            "SHAYAMPET",
            "VELAIR",
        ],
        HYDERABAD: [
            "AMBERPET",
            "AMEERPET",
            "ASIF NAGAR II (EB)",
            "ASIFNAGAR",
            "BAHADURPURA",
            "BAHADURPURA II (EB)",
            "BANDLAGUDA",
            "BANDLAGUDA II (EB)",
            "CHARMINAR",
            "CHARMINAR II (EB)",
            "GOLCONDA",
            "HIMAYATNAGAR",
            "KHAIRATABAD",
            "KHARATABAD II (EB)",
            "MAREDPALLY",
            "MUSHEERABAD",
            "MUSHEERABAD II (EB)",
            "NAMPALLY",
            "SAIDABAD",
            "SAIDABAD II (EB)",
            "SECUNDERABAD",
            "SECUNDERABAD II (EB)",
            "SHAIKPET",
            "TIRUMALAGIRI",
        ],
        JAGTIAL: [
            "BEERPUR",
            "BHEEMARAM",
            "BUGGARAM",
            "DHARMAPURI",
            "ENDAPALLI",
            "GOLLAPALLY",
            "IBRAHIMPATNAM",
            "JAGTIAL",
            "JAGTIAL  RURAL",
            "KATHALAPUR",
            "KODIMIAL",
            "KORATLA",
            "MALLAPUR",
            "MALLIAL",
            "MEDIPALLY",
            "METPALLY",
            "PEGADAPALLY",
            "RAIKAL",
            "SARANGAPUR",
            "VELGATOOR",
        ],
        JANGAON: [
            "BACHANNAPETA",
            "CHILPUR",
            "DEVARUPPALA",
            "GANPUR (STN)",
            "JANGAON",
            "KODAKANDLA",
            "LINGALAGHANPUR",
            "NARMETTA",
            "PALAKURTHI",
            "RAGHUNATHPALLE",
            "THARIGOPPULA",
            "ZAFFERGADH",
        ],
        JAYASHANKAR: [
            "BHUPALPALLE",
            "CHITYAL",
            "GHANAPUR MULUG",
            "KATARAM",
            "MAHADEVPUR",
            "MALHARRAO",
            "MOGULLAPALLE",
            "MUTHARAM MAHADEVPUR",
            "PALMELA",
            "REGONDA",
            "TEKUMATLA",
        ],
        "JOGULAMBA GADWAL": [
            "AIZA",
            "ALAMPUR",
            "DHARUR",
            "GADWAL",
            "GHATTU",
            "ITIKYAL",
            "KALOOR TIMMANADODDI",
            "MALDAKAL",
            "MANOPAD",
            "RAJOLI",
            "UNDAVELLI",
            "WADDEPALLE",
        ],
        KAMAREDDY: [
            "BANSWADA",
            "BHIKNUR",
            "BIBIPET",
            "BICHKUNDA",
            "BIRKOOR",
            "DOMAKONDA",
            "DONGLI",
            "GANDHARI",
            "JUKKAL",
            "KAMAREDDY",
            "LINGAMPET",
            "MACHAREDDY",
            "MADNUR",
            "NAGA_REDDIPET",
            "NASURULLABAD",
            "NIZAMSAGAR",
            "PEDDA KODAPGAL",
            "PITLAM",
            "RAJAMPET",
            "RAMAREDDY",
            "SADASIVANAGAR",
            "TADWAI",
            "YELLAREDDY",
        ],
        KARIMNAGAR: [
            "CHIGURUMAMIDI",
            "CHOPPADANDI",
            "ELLANDAKUNTA",
            "GANGADHARA",
            "GANNERVARAM",
            "HUZURABAD",
            "JAMMIKUNTA",
            "KARIMNAGAR",
            "KARIMNAGAR (RURAL)",
            "KOTHAPALLE",
            "MANAKONDUR",
            "RAMADUGU",
            "SAIDAPUR (V)",
            "SHANKARAPATNAM",
            "THIMMAPUR",
            "VEENAVANKA",
        ],
        KHAMMAM: [
            "BONAKAL",
            "CHINTHAKANI",
            "ENKURU",
            "KALLURU",
            "KAMEPALLY",
            "KHAMMAM (RURAL)",
            "KHAMMAM (URBAN)",
            "KONIJERLA",
            "KUSUMANCHI",
            "MADHIRA",
            "MUDIGONDA",
            "NELAKONDAPALLY",
            "PENUBALLI",
            "RAGHUNADHAPALEM",
            "SATHUPALLY",
            "SINGARENI",
            "THALLADA",
            "THIRUMALAYAPALEM",
            "VEMSOOR",
            "WYRA",
            "YERRUPALEM",
        ],
        "KUMURAM BHEEM ASIFABAD": [
            "ASIFABAD",
            "BEJJUR",
            "CHINTALAMANEPALLY",
            "DAHEGAON",
            "JAINOOR",
            "KAGAZNAGAR",
            "KERAMERI",
            "KOUTHALA",
            "LINGAPUR",
            "PENCHIKALPET",
            "REBBENA",
            "SIRPUR (T)",
            "SIRPUR (U)",
            "TIRYANI",
            "WANKIDI",
        ],
        MAHABUBABAD: [
            "BAYYARAM",
            "CHINNAGUDUR",
            "DANTHALAPALLY",
            "DORNAKAL",
            "GANGARAM",
            "GARLA",
            "GUDUR",
            "INUGURTHY",
            "KESAMUDRAM",
            "KOTHAGUDA",
            "KURAVI",
            "MAHABUBABAD",
            "MARIPEDA",
            "NARSIMHULAPET",
            "NELLIKUDUR",
            "PEDDAVANGARA",
            "SEEROLE",
            "THORRUR",
        ],
        MAHABUBNAGAR: [
            "ADDAKAL",
            "BALANAGAR",
            "BHOOTHPUR",
            "CHINNA CHINTHA KUNTA",
            "DEVARKADARA",
            "GANDEED",
            "HANWADA",
            "JADCHERLA",
            "KOILKONDA",
            "KOUKUNTLA",
            "MAHABUBNAGAR (RURAL)",
            "MAHABUBNAGAR (URBAN)",
            "MIDJIL",
            "MOHAMMADABAD",
            "MUSAPET",
            "NAWABPET",
            "RAJAPUR",
        ],
        MANCHERIAL: [
            "BELLAMPALLE",
            "BHEEMINI",
            "BHIMARAM",
            "CHENNUR",
            "DANDEPALLE",
            "HAJIPUR",
            "JAIPUR",
            "JANNARAM",
            "KANNEPALLI",
            "KASIPET",
            "KOTAPALLE",
            "LUXETTIPET",
            "MANCHERIAL",
            "MANDAMARRI",
            "NASPUR",
            "NENNAL",
            "TANDUR",
            "VEMANPALLE",
        ],
        MEDAK: [
            "ALLADURG",
            "CHEGUNTA",
            "CHILIPCHED",
            "HAVELIGHANPUR",
            "KOWDIPALLE",
            "KULCHARAM",
            "MANOHARABAD",
            "MASAIPET",
            "MEDAK",
            "NARSAPUR",
            "NARSINGI",
            "NIZAMPET",
            "PAPANNAPET",
            "RAMAYAMPET",
            "REGODE",
            "SHANKARAMPET (A)",
            "SHANKARAMPET (R)",
            "SHIVAMPET",
            "TEKMAL",
            "TUPRAN",
            "YELDURTHY",
        ],
        MEDCHAL: [
            "ALWAL",
            "BACHPALLE",
            "BALANAGAR",
            "DUNDIGAL GANDIMAISAMMA",
            "GHATKESAR",
            "KAPRA",
            "KEESARA",
            "KUKATPALLY",
            "MALKAJGIRI",
            "MEDCHEL",
            "MEDIPALLY",
            "MOODUCHINTHALAPALLY",
            "QUTHBULLAPUR",
            "SHAMIRPET",
            "UPPAL",
        ],
        MULUGU: [
            "ETURNAGARAM",
            "GOVINDARAOPET",
            "KANNAIGUDEM",
            "MANGAPET",
            "MULUGU",
            "TADVAI",
            "VENKATAPUR",
            "VENKATAPURAM",
            "WAZEED",
        ],
        NAGARKURNOOL: [
            "ACHAMPET",
            "AMRABAD",
            "BALMOOR",
            "BIJINAPALLE",
            "CHARAKONDA",
            "KALWAKURTHY",
            "KODAIR",
            "KOLLAPUR",
            "LINGAL",
            "NAGARKURNOOL",
            "PADRA",
            "PEDDAKOTHAPALLE",
            "PENTLAVELLI",
            "TADOOR",
            "TELKAPALLY",
            "THIMMAJIPETA",
            "UPPUNUTHALA",
            "URKONDA",
            "VANGOOR",
            "VELDANDA",
        ],
        NALGONDA: [
            "ADAVI DEVULA PALLI",
            "ANUMULA HALIYA",
            "CHANDAMPET",
            "CHANDUR",
            "CHINTHAPALLE",
            "CHITYALA",
            "DAMARACHERLA",
            "DEVARAKONDA",
            "GHATTUPPAL",
            "GUNDLAPALLE",
            "GURRAMPODE",
            "KANGAL",
            "KATTANGOOR",
            "KETHEPALLE",
            "KONDAMALLAPALLY",
            "MADUGULAPALLY",
            "MARRIGUDA",
            "MIRYALAGUDA",
            "MUNUGODE",
            "NAKREKAL",
            "NALGONDA",
            "NAMPALLE",
            "NARKETPALLE",
            "NEREDUGOMMU",
            "NIDAMANUR",
            "PEDDA ADISERLAPALLE",
            "PEDDAVURA",
            "SALIGOURARAM",
            "THIPPARTHI",
            "THRIPURARAM",
            "TIRUMALAGIRI SAGAR",
            "VEMULAPALLE",
        ],
        NARAYANAPET: [
            "DAMARAGIDDA",
            "DHANWADA",
            "KOSGI",
            "KRISHNA",
            "MADDUR",
            "MAGANOOR",
            "MAKTHAL",
            "MARIKAL",
            "NARAYANPET",
            "NARVA",
            "UTKOOR",
        ],
        NIRMAL: [
            "BASAR",
            "BHAINSA",
            "DASTUARABAD",
            "DILAWARPUR",
            "KADDAMPEDDUR",
            "KHANAPUR",
            "KUBEER",
            "KUNTALA",
            "LAXMANCHANDA",
            "LOKESWARAM",
            "MAMADA",
            "MUDHOLE",
            "NARSAPUR (G)",
            "NIRMAL",
            "NIRMAL (RURAL)",
            "PEMBI",
            "SARANGAPUR",
            "SOAN",
            "TANUR",
        ],
        NIZAMABAD: [
            "ALOOR",
            "ARMUR",
            "BALKONDA",
            "BHEEMGAL",
            "BODHAN",
            "CHANDUR",
            "DHARPALLE",
            "DICHPALLE",
            "DONKESHWAR",
            "INDALWAI",
            "JAKRANPALLE",
            "KAMMARPALLE",
            "KOTGIRI",
            "MAKLOOR",
            "MENDORA",
            "MORTAD",
            "MOSRA",
            "MUGPAL",
            "MUPKAL",
            "NANDIPET",
            "NAVIPET",
            "NIZAMABAD (NORTH)",
            "NIZAMABAD (RURAL)",
            "NIZAMABAD (SOUTH)",
            "POTHANGAL",
            "RANJAL",
            "RUDRUR",
            "SALOORA",
            "SIRKONDA",
            "VAILPUR",
            "VARNI",
            "YEDA PALLE",
            "YERGATLA",
        ],
        PEDDAPALLI: [
            "ANTARGOAN",
            "DHARMARAM",
            "ELGAID",
            "JULAPALLE",
            "KAMANPUR",
            "MANTHANI",
            "MUTHARAM_MANTHANI",
            "ODELA",
            "PALAKURTHY",
            "PEDDAPALLE",
            "RAMAGIRI",
            "RAMAGUNDAM",
            "SRIRAMPUR",
            "SULTANABAD",
        ],
        "RAJANNA SIRICILLA": [
            "BOINPALLE",
            "CHANDURTHI",
            "ELLANTHAKUNTA",
            "GAMBHIRAOPETA",
            "KONARAOPETA",
            "MUSTABAD",
            "RUDRANGI",
            "SIRSILLA",
            "THANGALLAPALLE",
            "VEERNAPALLY",
            "VEMULAWADA",
            "VEMULAWADA (RURAL)",
            "YELLAREDDYPET",
        ],
        RANGAREDDY: [
            "ABDULLAPURMET",
            "AMANGAL",
            "BALAPUR",
            "CHEVELLA",
            "CHOWDERGUDEM",
            "FAROOQNAGAR",
            "GANDIPET",
            "HAYATHNAGAR",
            "IBRAHIMPATNAM",
            "KADTHAL",
            "KANDUKUR",
            "KESHAMPETA",
            "KONDURG",
            "KOTHUR",
            "MADGUL",
            "MAHESHWARAM",
            "MANCHAL",
            "MOINABAD",
            "NANDIGAM",
            "RAJENDRANAGAR",
            "SAROORNAGAR",
            "SERILINGAMPALLY",
            "SHABAD",
            "SHAMSHABAD",
            "SHANKARPALLE",
            "TALAKONDAPALLE",
            "YACHARAM",
        ],
        SANGAREDDY: [
            "AMEENPUR",
            "ANDOLE",
            "CHOWTAKUR",
            "GUMMADIDALA",
            "HATHNOORA",
            "JHARASANGAM",
            "JINNARAM",
            "KALHER",
            "KANDI",
            "KANGTI",
            "KOHIR",
            "KONDAPUR",
            "MANOOR",
            "MOGUDAMPALLY",
            "MUNIPALLY",
            "NAGALGIDDA",
            "NARAYANKHED",
            "NIZAMPET",
            "NYALKAL",
            "PATANCHERU",
            "PULKAL",
            "RAIKODE",
            "RAMACHANDRAPURAM",
            "SADASHIVAPET",
            "SANGAREDDY",
            "SIRGAPOOR",
            "WATPALLY",
            "ZAHEERABAD",
        ],
        SIDDIPET: [
            "AKBARPET-BHOOMPALLY",
            "AKKANNAPETA",
            "BEJJANKI",
            "CHERIYAL",
            "CHINNAKODUR",
            "DHOOLMITTA",
            "DOULTABAD",
            "DUBBAK",
            "GAJWEL",
            "HUSNABAD",
            "JAGADEVPUR",
            "KOHEDA",
            "KOMARAVELLY",
            "KONDAPAK",
            "KUKURNOORPALLY",
            "MADDUR",
            "MARKOOK",
            "MIRDODDI",
            "MULUG",
            "NANGANUR",
            "NARAYANRAOPET",
            "RAYAPOLE",
            "SIDDIPET (RURAL)",
            "SIDDIPET (URBAN)",
            "THOGUTA",
            "WARGAL",
        ],
        SURYAPET: [
            "ANANTHAGIRI",
            "ATMAKUR (S)",
            "CHILKUR",
            "CHINTHALA PALEM",
            "CHIVVEMLA",
            "GARIDEPALLE",
            "HUZUR NAGAR",
            "JAJIREDDIGUDEM",
            "KODAD",
            "MADDIRALA",
            "MATTAMPALLE",
            "MELLACHERVU",
            "MOTHEY",
            "MUNAGALA",
            "NADIGUDEM",
            "NAGARAM",
            "NEREDCHERLA",
            "NOOTHANKAL",
            "PALAKEEDU",
            "PENPAHAD",
            "SURYAPET",
            "THIRUMALAGIRI",
            "THUNGATHURTHI",
        ],
        VIKARABAD: [
            "BANTWARAM",
            "BASHEERABAD",
            "BOMRASPETA",
            "CHOWDAPUR",
            "DHARUR",
            "DOMA",
            "DOULATABAD",
            "DUDYAL",
            "KODANGAL",
            "KOTEPALLY",
            "KULKACHARLA",
            "MARPALLE",
            "MOMINPET",
            "NAWABPET",
            "PARGI",
            "PEDDEMUL",
            "PUDUR",
            "TANDUR",
            "VIKARABAD",
            "YELAL",
        ],
        WANAPARTHY: [
            "AMARCHINTA",
            "ATMAKUR",
            "CHINNAMBAVI",
            "GHANPUR",
            "GOPALPETA",
            "KOTHAKOTA",
            "MADANAPUR",
            "PANGAL",
            "PEBBAIR",
            "PEDDAMANDADI",
            "REVELLY",
            "SRIRANGAPUR",
            "VEEPANGANDLA",
            "WANAPARTHY",
        ],
        WARANGAL: [
            "CHENNARAOPETA",
            "DUGGONDI",
            "GEESUGONDA",
            "KHANAPUR",
            "KHILLA WARANGAL",
            "NALLABELLY",
            "NARSAMPET",
            "NEKKONDA",
            "PARVATHAGIRI",
            "RAIPARTHY",
            "SANGEM",
            "WARANGAL",
            "WARDHANNAPET",
        ],
        "YADADRI BHUVANAGIRI": [
            "ADDAGUDUR",
            "ALAIR",
            "ATHMAKUR(M)",
            "BHONGIRI",
            "BIBINAGAR",
            "BOMMALARAMARAM",
            "CHOUTUPPAL",
            "GUNDALA",
            "M. THURKAPALLY",
            "MOTAKONDUR",
            "MOTHKUR",
            "NARAYANAPUR",
            "POCHAMPALLY",
            "RAJAPET",
            "RAMANNAPETA",
            "VALIGONDA",
            "YADAGIRIGUTTA",
        ],
    },
    TN: {
        ARIYALUR: [
            "ANDIMADAM",
            "ARIYALUR",
            "JAYANKONDAM",
            "SENDURAI",
            "T.PALUR",
            "THIURMANUR",
        ],
        CHENGALPATTU: [
            "ACHARAPAKKAM",
            "CHITHAMUR",
            "KATTANKOLATHUR",
            "LATHUR",
            "MADURANTAGAM",
            "ST.THOMAS MOUNT(RURAL)",
            "ST.THOMAS MOUNT(URBAN)",
            "THIRUKALUKUNDRAM",
            "THIRUPORUR",
        ],
        CHENNAI: [
            "ADYAR",
            "ALANDUR",
            "AMBATTUR",
            "ANNA NAGAR",
            "EGMORE",
            "GEORGE TOWN",
            "KODAMBAKKAM",
            "MYLAPORE",
            "PERAMBUR",
            "PERIAMEDU",
            "PURASAIWALKKAM",
            "ROYAPURAM",
            "T.NAGAR",
            "TEYNAMPET",
            "THIRU VI KA NAGAR",
            "THIRUVOTRIYUR",
            "TONDIARPET",
            "TRIPLICANE",
        ],
        COIMBATORE: [
            "ANAIMALAI",
            "ANNUR",
            "COIMBATORE CITY",
            "KARAMADAI",
            "KINATHUKKADAVU",
            "MADUKKARAI",
            "PERIYANAICKAN PALAYAM",
            "PERUR",
            "POLLACHI NORTH",
            "POLLACHI SOUTH",
            "SARKAR SAMAKKULAM",
            "SULTHANPET",
            "SULUR",
            "THONDAMUTHUR",
            "VALPARAI",
        ],
        CUDDALORE: [
            "ANNAGRAMMAM",
            "BHUVANAGIRI",
            "CUDDALORE",
            "KAMMAPURAM",
            "KATTUMANNARKOIL",
            "KEERAPALAYAM",
            "KUMARATCHI",
            "KURINJIPADI",
            "MANGALORE",
            "NALLUR",
            "NEYVELI",
            "PANRUTI",
            "PARANGIPETTAI",
            "SRIMUSHNAM",
            "VIRUDHACHALAM",
        ],
        DHARMAPURI: [
            "DHARMAPURI",
            "ERIYUR",
            "HARUR",
            "KADATHUR",
            "KARIMANGALAM",
            "MORAPPUR",
            "NALLAMPALLI",
            "PALACODE",
            "PAPPIREDDIPATTI",
            "PENNAGARAM",
        ],
        DINDIGUL: [
            "ATHOOR",
            "BATLAGUNDU",
            "DINDIGUL - RURAL",
            "DINDIGUL -URBAN",
            "GUJILIAMPARAI",
            "KODAIKANAL",
            "NATHAM",
            "NILAKOTTAI",
            "ODDANCHATHRAM",
            "PALANI - RURAL",
            "PALANI - URBAN",
            "REDDIYARCHATRAM",
            "SANARPATTY",
            "THOPPAMPATTY",
            "VADAMADURAI",
            "VEDASANDUR",
        ],
        ERODE: [
            "AMMAPETTAI-ERODE",
            "ANTHIYUR",
            "BHAVANI",
            "BHAVANI SAGAR",
            "CHENNIMALAI",
            "ERODE",
            "GOBI",
            "KODUMUDI",
            "MODAKURICHI",
            "NAMBIYUR",
            "PERUNDURAI",
            "SATHIYAMANGALAM",
            "THALAVADY",
            "THUCKANAICKEN PALAYAM",
        ],
        KALLAKURICHI: [
            "CHINNASALEM",
            "KALLAKURICHI",
            "KALRAYAN HILLS",
            "RISHIVANTHIYAM",
            "SANKARAPURAM",
            "THIRUKOILUR",
            "THIRUNAVALUR",
            "THIYAGADURGAM",
            "ULUNDURPET",
        ],
        KANCHEEPURAM: [
            "KANCHEEPURAM",
            "KUNDRATHUR",
            "SRIPERUMBUDUR",
            "UTHIRAMERUR",
            "WALAJABAD",
        ],
        KANNIYAKUMARI: [
            "AGASTHEESWARAM",
            "KILLIYOOR",
            "KURUNTHANCODE",
            "MELPURAM",
            "MUNCHIRAI",
            "RAJAKKAMANGALAM",
            "THIRUVATTAR",
            "THOVALAI",
            "THUCKALAY",
        ],
        KARUR: [
            "ARAVAKURICHI",
            "K.PARAMATHI",
            "KADAVOOR",
            "KARUR",
            "KRISHNARAYAPURAM",
            "KULITHALAI",
            "THANTHONI",
            "THOGAIMALAI",
        ],
        KRISHNAGIRI: [
            "BARGUR",
            "HOSUR",
            "KAVERIPATINAM",
            "KELAMANGALAM",
            "KRISHNAGIRI",
            "MATHUR",
            "SHOOLAGIRI",
            "THALLY",
            "UTHANGARAI",
            "VEPPANAPALLI",
        ],
        MADURAI: [
            "ALANGANALLUR",
            "CHELLAMPATTI",
            "KALLIKUDI",
            "KOTTAMPATTI",
            "MADURAI EAST",
            "MADURAI NORTH",
            "MADURAI SOUTH",
            "MADURAI WEST",
            "MELUR",
            "SEDAPATTI",
            "T.KALLUPATTI",
            "T.VADIPATTI",
            "THIRUMANGALAM",
            "THIRUPARAMKUNDRAM",
            "USILAMPATTI",
        ],
        MAYILADUTHURAI: [
            "KOLLIDAM",
            "KUTHALAM",
            "MAYILADUDURAI",
            "SEMBANARKOIL",
            "SIRKALI",
        ],
        NAGAPATTINAM: [
            "KEEZHAIYUR",
            "KELVELUR",
            "NAGAPATTINAM",
            "THALAINAYAR",
            "THIRUMARUGAL",
            "VEDARANYAM",
        ],
        NAMAKKAL: [
            "ELACHIPALAYAM",
            "ERUMAPATTI",
            "KABILARMALAI",
            "KOLLIHILLS",
            "MALLASAMUDRAM",
            "MOHANUR",
            "NAMAGIRIPET",
            "NAMAKKAL",
            "PALLIPALAYAM",
            "PARAMATHI",
            "PUDUCHATRAM",
            "RASIPURAM",
            "SENDAMANGALAM",
            "TIRUCHENGODE",
            "VENNANDUR",
        ],
        PERAMBALUR: ["ALATHUR", "PERAMBALUR", "VEPPANTHATTAI", "VEPPUR"],
        PUDUKKOTTAI: [
            "ANNAVASAL",
            "ARANTHANGI",
            "ARIMALAM",
            "AVUDAIYARKOIL",
            "GANDARVAKKOTTAI",
            "KARAMBAKKUDI",
            "KUNNANDARKOIL",
            "MANAMELKUDI",
            "PONNAMARAVATHY",
            "PUDUKKOTTAI",
            "THIRUMAYAM",
            "THIRUVARANKULAM",
            "VIRALIMALAI",
        ],
        RAMANATHAPURAM: [
            "BOGALUR",
            "KADALADI",
            "KAMUTHI",
            "MANDAPAM",
            "MUDUKULATHUR",
            "NAINARKOIL",
            "PARAMAKUDI",
            "RAJASINGAMANGALAM",
            "RAMANATHAPURAM",
            "THIRUPPULLANI",
            "THIRUVADANAI",
        ],
        RANIPET: [
            "ARAKKONAM",
            "ARCOT",
            "KAVERIPAKKAM",
            "NEMILI",
            "SHOLINGAR",
            "TIMIRI",
            "WALAJA EAST",
            "WALAJA WEST",
        ],
        SALEM: [
            "ATTUR",
            "AYOTHIYAPATTINAM",
            "EDAPPADI",
            "GANGAVALLI",
            "KADAYAMPATTI",
            "KOLATHUR",
            "KONGANAPURAM",
            "MAGUNDANCHAVADI",
            "MECHERI",
            "NANGAVALLI",
            "OMALUR",
            "PANAMARATHUPATTI",
            "PETHANAICKENPALAYAM",
            "SALEM-RURAL",
            "SALEM-URBAN",
            "SANKARI",
            "THALAIVASAL",
            "THARAMANGALAM",
            "VALAPPADI",
            "VEERAPANDI",
            "YERCAUD",
        ],
        SIVAGANGAI: [
            "DEVAKOTTAI",
            "ILAYANGUDI",
            "KALAYARKOIL",
            "KALLAL",
            "KANNANGUDI",
            "MANAMADURAI",
            "S.PUDUR",
            "SAKKOTTAI",
            "SINGAMPUNARI",
            "SIVAGANGAI",
            "THIRUPPATUR",
            "THIRUPPUVANAM",
        ],
        TENKASI: [
            "ALANGULAM",
            "KADAYAM",
            "KADAYANALLUR",
            "KEELAPAVOOR",
            "KURUVIKULAM",
            "MELANEELITHANALLUR",
            "SANKARANKOVIL",
            "SHENKOTTAI",
            "TENKASI",
            "VASUDEVANALLUR",
        ],
        THANJAVUR: [
            "AMMAPETTAI-TNJ",
            "BUDALUR",
            "KUMBAKONAM",
            "MADUKKUR",
            "ORATHANADU",
            "PAPANASAM",
            "PATTUKKOTTAI",
            "PERAVURANI",
            "SETHUBAVACHATRAM",
            "THANJAVUR(RURAL)",
            "THANJAVUR(URBAN)",
            "THIRUPPANANDAL",
            "THIRUVAIYAR",
            "THIRUVIDAIMARUDHUR",
            "THIRUVONAM",
        ],
        "THE NILGIRIS": ["COONOOR", "GUDALUR", "KOTAGIRI", "UDHAGAMANDALAM"],
        THENI: [
            "AUNDIPATTY",
            "BODINAYAKANUR",
            "CHINNAMANUR",
            "CUMBUM",
            "MYLADUMPARAI",
            "PERIYAKULAM",
            "THENI",
            "UTHAMAPALAYAM",
        ],
        THOOTHUKKUDI: [
            "ALWARTHIRUNAGAR",
            "KARUNKULAM",
            "KAYATHAR",
            "KOVILPATTI",
            "OTTAPIDARAM",
            "PUDUR",
            "SATHANKULAM",
            "SRIVAIKUNDAM",
            "THIRUCHENTHUR",
            "THOOTHUKUDI RURAL",
            "THOOTHUKUDI URBAN",
            "UDANGUDI",
            "VILATHIKULAM",
        ],
        TIRUCHIRAPPALLI: [
            "ANDHANALLUR",
            "LALGUDI",
            "MANAPPARAI",
            "MANIKANDAM",
            "MANNACHANALLUR",
            "MARUNGAPURI",
            "MUSIRI",
            "PULLAMBADI",
            "THATHIENGARPET",
            "THIRUVERUMBUR",
            "THOTTIYAM",
            "THURAIYUR",
            "TRICHY-URBAN",
            "TRICHY-WEST",
            "UPPILIYAPURAM",
            "VAIYAMPATTI",
        ],
        TIRUNELVELI: [
            "AMBASAMUDRAM",
            "CHERANMAHADEVI",
            "KALAKAD",
            "MANUR",
            "NANGUNERI",
            "PALAY-RURAL",
            "PALAY-URBAN",
            "PAPPAKUDI",
            "RADHAPURAM",
            "TIRUNELVELI URBAN",
            "VALLIYOOR",
        ],
        TIRUPATHUR: [
            "ALANGAYAM",
            "JOLARPET",
            "KANDHILI",
            "MADHANUR",
            "NATRAMPALLI",
            "THIRUPATTUR",
        ],
        TIRUPPUR: [
            "AVINACI",
            "DHARAPURAM",
            "GANGAYAM",
            "GUNDADAM",
            "KUDIMANGALAM",
            "MADATHUKULAM",
            "MOOLANUR",
            "PALLADAM",
            "PONGALUR",
            "TIRUPPUR SOUTH",
            "TIRUPUR",
            "UDUMALAIPATTAI",
            "UTHUKULI",
            "VELLACKOIL",
        ],
        TIRUVALLUR: [
            "ELLAPURAM",
            "GUMMIDIPOONDI",
            "KADAMBATHUR",
            "MINJUR",
            "PALLIPAT",
            "POONAMALLEE",
            "POONDI",
            "PUZHAL",
            "R.K.PET",
            "SHOLAVARAM",
            "THIRUVALANGADU",
            "THIRUVALLUR",
            "TIRUTTANI",
            "VILLIVAKKAM",
        ],
        TIRUVANNAMALAI: [
            "ANAKKAVUR",
            "ARNI",
            "CHENGAM",
            "CHETPET",
            "CHEYYAR",
            "JAWADHU HILLS",
            "KALASAPAKKAM",
            "KILPENNATHUR",
            "PERANAMALLUR",
            "POLUR",
            "PUDUPALAYAM",
            "THANDRAMPET",
            "THELLAR",
            "THURINJAPURAM",
            "TIRUVANNAMALAI",
            "VANDAVASI",
            "VEMBAKKAM",
            "WEST ARNI",
        ],
        TIRUVARUR: [
            "KORADACHERY",
            "KOTTUR",
            "KUDAVASAL",
            "MANNARGUDI",
            "MUTHUPETTAI",
            "NANNILAM",
            "NEEDAMANGALAM",
            "THIRUTHURAIPOONDI",
            "THIRUVARUR",
            "VALANGAIMAN",
        ],
        VELLORE: [
            "ANAICUT",
            "GUDIYATHAM",
            "K.V.KUPPAM",
            "KANIYAMBADI",
            "KATPADI",
            "PERNAMBUT",
            "VELLORE RURAL",
            "VELLORE URBAN",
        ],
        VILLUPURAM: [
            "GINGEE",
            "KANAI",
            "KANDAMANGALAM",
            "KOLIYANUR",
            "MAILAM",
            "MARAKKANAM",
            "MELMALAYANUR",
            "MUGAIYUR",
            "OLAKKUR",
            "THIRUVENNAINALLUR",
            "VAANUR",
            "VALLAM",
            "VIKARAVANDI",
            "VILUPPURAM",
        ],
        VIRUDHUNAGAR: [
            "ARUPPUKOTTAI",
            "KARIYAPATTI",
            "NARIKUDI",
            "RAJAPALAYAM",
            "SATTUR",
            "SIVAKASI",
            "SRIVILLIPUTHUR",
            "THIRUCHULI",
            "VEMBAKOTTAI",
            "VIRUDHUNAGAR",
            "WATRAP",
        ],
    },
    TR: {
        DHALAI: [
            "AMBASSA",
            "AMBASSA M.C",
            "CHAWMANU",
            "DUMBURNAGAR",
            "DURGACHOWMUHANI",
            "GANGANAGAR",
            "MANU",
            "RAISHYABARI",
            "SALEMA",
        ],
        GOMATI: [
            "AMARPUR",
            "AMPINAGAR",
            "KAKRABAN",
            "KARBOOK",
            "KILLA",
            "MATABARI",
            "SHILACHARI",
            "TEPANIA",
            "UDAIPUR M.C.",
        ],
        KHOWAI: [
            "KALYANPUR",
            "KHOWAI",
            "KHOWAI MC",
            "MUNGIAKAMI",
            "PADMABIL",
            "TELIAMURA",
            "TELIAMURA MC",
            "TULASHIKHAR",
        ],
        "NORTH TRIPURA": [
            "DAMCHERRA",
            "DASDA",
            "DHARMANAGAR M.C.",
            "JAMPUI",
            "JUBARAJNAGAR",
            "KADAMTALA",
            "KALACHERRA",
            "LALJURI",
            "PANISAGAR",
        ],
        SEPAHIJALA: [
            "BISHALGARH",
            "BISHALGARH MC",
            "BOXANAGAR",
            "CHARILAM",
            "JAMPUIJALA",
            "KATHALIA",
            "MELAGHAR MC",
            "MOHONBHOG",
            "NALCHAR",
        ],
        "SOUTH TRIPURA": [
            "BAGAFA",
            "BELONIA M.C.",
            "BHARAT CHANDRA NAGAR",
            "HRISHYAMUKH",
            "JOLAIBARI",
            "POANGBARI",
            "RAJNAGAR",
            "RUPAICHARI",
            "SANTIRBAZAR MC",
            "SATCHAND",
        ],
        UNAKOTI: [
            "CHANDIPUR",
            "GOURNAGAR",
            "KAILASHAHAR M.C.",
            "KUMARGHAT",
            "KUMARGHAT M.C.",
            "PECHARTHAL",
        ],
        "WEST TRIPURA": [
            "AGARTALA MUNICIPAL COORPORATION",
            "BAMUTIA",
            "BELBARI",
            "DUKLI",
            "HEZAMARA",
            "JIRANIA",
            "LEFUNGA",
            "MANDAI",
            "MOHANPUR",
            "MOHANPUR MC",
            "OLD AGARTALA",
            "RANIRBAZAR MC",
        ],
    },
    UP: {
        AGRA: [
            "ACCHNERA",
            "AKOLA",
            "BAH",
            "BAROLI AHEER",
            "BICHPURI",
            "ETMADPUR",
            "FATEHABAD",
            "FATEHPUR  SIKRI",
            "JAGNER",
            "JAITPUR  KALAN",
            "KHANDOLI",
            "KHERAGARH",
            "M.A.FATEHPUR SIKRI",
            "M.C.AGRA CITY",
            "PINAHAT",
            "SAIYAN",
            "SHAMSHABAD",
        ],
        ALIGARH: [
            "AKRABAD",
            "ATRAULI",
            "BIJAULI",
            "CHANDAUS",
            "DHANIPUR",
            "GANGIRI",
            "GONDA",
            "IGLAS",
            "JAWAN",
            "KHAIR",
            "LODHA",
            "NAGAR ALIGARH",
            "NAGAR ATRAULI",
            "TAPPAL",
        ],
        "AMBEDKAR NAGAR": [
            "AKBARPUR",
            "BASKHARI",
            "BHEETI",
            "BHIYAON",
            "JAHANGIRGANJ",
            "JALALPUR",
            "KATEHARI",
            "RAMNAGAR",
            "TANDA",
            "TANDA TOWN AREA",
        ],
        "AMETHI - CSM NAGAR": [
            "AMETHI",
            "BAHADURPUR",
            "BHADAR",
            "BHETUA",
            "GAURIGANJ",
            "JAGDISHPUR",
            "JAMO",
            "MUSAFIRKHANA",
            "SANGRAMPUR",
            "SHAHGARH",
            "SHUKULBAZAR",
            "SINGHPUR",
            "TILOI",
        ],
        AURAIYA: [
            "ACHHALDA",
            "AIRWAKATRA",
            "AJITMAL",
            "AURAIYA",
            "BHAGYANAGAR",
            "BIDHUNA",
            "NAGAR CHETRA AURAIYA",
            "SAHAR",
        ],
        AYODHYA: [
            "AMANIGANJ",
            "AYODHYA TOWN AREA",
            "BIKAPUR",
            "HARINTANGANJ",
            "MASAUDHA",
            "MAWAI",
            "MAYA",
            "MILKIPUR",
            "PURA",
            "RUDAULI",
            "SOHAWAL",
            "TARUN",
        ],
        AZAMGARH: [
            "AHIRAULA",
            "ATRAULIYA",
            "AZAMGRAH",
            "AZMATGARH",
            "BILARIYAGANJ",
            "FOOLPOOR",
            "HARRAIYA",
            "JAHANAGANJ",
            "KOILSA",
            "LALGANJ",
            "MAHARAJ GANJ",
            "MARTIN GANJ",
            "MEHNAGER",
            "MIRZAPUR",
            "MOHAMMADPUR",
            "PALAHNI",
            "PALHNA",
            "PAWAE",
            "RANI KI  SARAI",
            "SATHIYAN",
            "TAHBERPUR",
            "TARWA",
            "THEKMA",
        ],
        BAGHPAT: [
            "BAGPAT",
            "BAROUT",
            "BAROUT URBAN",
            "BINOLY",
            "CHHAPROLI",
            "KHEKRA",
            "PILANA",
        ],
        BAHRAICH: [
            "BALHA",
            "CHITTAURA",
            "FAKHAR PUR",
            "HUJUR PUR",
            "JARWAL",
            "KAISER GANJ",
            "MAHSI",
            "MIHIN PURVA",
            "NAGAR AREA",
            "NAWAB GANJ",
            "PAYAGPUR",
            "RISIA",
            "SHIV PUR",
            "TAJWA PUR",
            "VISHESHWAR  GANJ",
        ],
        BALLIA: [
            "BAIRIA",
            "BALLIA N.P.",
            "BANSDEEH",
            "BELAHARI",
            "BERUARBARI",
            "CHILKAHAR",
            "DUBAHAR",
            "GARWAR",
            "HANUMANGANJ",
            "MANIAR",
            "MURLI CHHAPRA",
            "NAGARA",
            "NAVANAGAR",
            "PANDAH",
            "RASARA",
            "REVATI",
            "SEAR",
            "SOHAWN",
        ],
        BALRAMPUR: [
            "BALRAMPUR",
            "BALRAMPUR(MUN. CORP.)",
            "GAINDAS BUZURG",
            "GAINSARI",
            "HARAIYA SATGHARWA",
            "PACHPERWA",
            "REHRA BAZAR",
            "SHRIDUTTGANJ",
            "TULSIPUR",
            "UTRAULA",
            "UTRAULA (MUN. CORP.)",
        ],
        BANDA: [
            "BABERU",
            "BADOKHAR KHURD",
            "BISANDA",
            "JASPURA",
            "KAMASIN",
            "MAHUWA",
            "NAGAR KSHETRA",
            "NARAINI",
            "TINDWARI",
        ],
        BARABANKI: [
            "BANI KODAR",
            "BANKI",
            "BARABANKI CITY",
            "DARIYA BAD",
            "DEWA",
            "FATEH PUR",
            "HAIDAR GARH",
            "HARAKH",
            "MASAULI",
            "NINDURA",
            "PURE DALAI",
            "RAM NAGAR",
            "SIDDHAOR",
            "SIRAULI GAUSPUR",
            "SURAT GANJ",
            "TRIVEDI GANJ",
        ],
        BAREILLY: [
            "ALAMPUR",
            "AONLA",
            "BAHERI",
            "BAHERI TOWN",
            "BAREILLY TOWN",
            "BHADPURA",
            "BHOJIPURA",
            "BHUTA",
            "FARIDPUR",
            "FARIDPUR TOWN",
            "FATEHGANJ",
            "KYARA",
            "MAJHGAWAN",
            "MIRGANJ",
            "NAWABGANJ",
            "RAMNAGAR",
            "RICHHA(DAMKHODA)",
            "SHERGARH",
            "VITHARI CHAINPUR",
        ],
        BASTI: [
            "BAHADURPUR",
            "BANKATI",
            "BASTI SADAR",
            "DUBAULIA",
            "GAUR",
            "HARRIYA",
            "KAPTANGANJ",
            "KUDRAHA",
            "PARSHURAMPUR",
            "RAMNAGAR",
            "RUDHOLI",
            "SALTOVA GOPALPUR",
            "SAUNGHAT",
            "TOWN AREA",
            "VIKRAMJOT",
        ],
        BHADOI: [
            "ABHOLI",
            "AURAI",
            "BHADOHI",
            "DEEGH",
            "GYANPUR",
            "SURIYAVAN",
            "TOWN AREA BHADOHI",
        ],
        BIJNOR: [
            "AAKU(NEHTOR)",
            "AFZALGRAH",
            "ALLHEPUR(DHAMPUR)",
            "BIJNOR(NAGAR)",
            "BURHANPUR(SEOHARA)",
            "CHANDPUR(NAGAR)",
            "DHAMPUR(NAGAR)",
            "HALDAUR",
            "JALILPUR",
            "KIRATPUR",
            "KOTWALI",
            "MOHD.PUR DEVMAL",
            "NAGINA(NAGAR)",
            "NAJIBABAD",
            "NAJIBABAD(NAGAR)",
            "NOORPUR",
        ],
        BUDAUN: [
            "AASAFPUR",
            "AMBIYAPUR",
            "BILSI CITY",
            "BISAULI",
            "BUDAUN CITY",
            "DATAGANJ",
            "DEHGANWAN",
            "ISLAMNAGAR",
            "JAGAT",
            "KAKRALA CITY",
            "MIAUN",
            "QADARCHOWK",
            "SAHASWAN",
            "SAHASWAN CITY",
            "SALARPUR",
            "SAMRER",
            "UJHANI",
            "UJHANI CITY",
            "USAWAN",
            "WAZEERGANJ",
        ],
        BULANDSHAHR: [
            "AGAUTA",
            "ANOOPSHAHAR",
            "ANOOPSHAHRNAGARKSHETR",
            "ARNIA",
            "B.B.NAGAR",
            "BULANDSHAHR",
            "BULANDSHAR NAGAR",
            "DANPUR",
            "DEBAI",
            "DEBAINNAGARKSHETR",
            "GULAOTI",
            "JAHAGIRABAD",
            "JAHAGIRABAD NAGAR",
            "KHURJA",
            "KHURJA NAGAR",
            "LAKHAWATI",
            "PAHASU",
            "SHIKARPUR",
            "SIKANDARABAD NAGAR",
            "SIKANDRABAD",
            "SYNA",
            "UCHAGAON",
        ],
        CHANDAULI: [
            "BARAHANI",
            "CHAHANIYA",
            "CHAKIYA",
            "CHANDAULI",
            "DHANAPUR",
            "MUGALSARAI (NAGAR CHHETRA)",
            "NAUGARH",
            "NIYAMATABAD",
            "SAKALDIHA",
            "SHAHABGANJ",
        ],
        CHITRAKOOT: [
            "CHITRAKOOT",
            "CHITRAKOOT (URBAN)",
            "MANIKPUR",
            "MAU",
            "PAHADI",
            "RAM NAGAR",
        ],
        DEORIA: [
            "BAITALPUR",
            "BANAKATA",
            "BARAHAJ",
            "BARAHAJ NAGAR KSHETRA",
            "BHAGALPUR",
            "BHATNI",
            "BHATPAR RANI",
            "BHLUANI",
            "DEORIA NAGAR KSHETRA",
            "DEORIA SADAR",
            "DESAHI DEORIA",
            "GAURI BAZAR",
            "LAR",
            "PATTHRDEVA",
            "RAMPUR KARKHANA",
            "RUDRAPUR",
            "SALIMPUR",
            "TARAKULAWA",
        ],
        ETAH: [
            "ALIGANJ",
            "AWAGARH",
            "ETAH (URBAN)",
            "JAITHARA",
            "JALESAR",
            "JALESAR (URBAN)",
            "MARHARA",
            "MARHARA (URBAN)",
            "NIDHAULI KALAN",
            "SAKEET",
            "SHEETAL PUR",
        ],
        ETAWAH: [
            "BARHPURA",
            "BASREHAR",
            "BHARTHANA",
            "CHAKARNAGAR",
            "ETAWAH NAGAR CHETRA",
            "JASWANT NAGAR",
            "MAHEWA",
            "SAIFAI",
            "TAKHA",
        ],
        FARRUKHABAD: [
            "BARH PUR",
            "KAIM GANJ",
            "KAMALGANJ",
            "MOHAMDABAD",
            "NAG. KSH.FAR.BAD",
            "NAG.KSHETRA  K.GANJ",
            "NAWABGANJ",
            "RAJE PUR",
            "SHAMSABAD",
        ],
        FATEHPUR: [
            "AIRAYAN",
            "AMAULI",
            "ASHOTHAR",
            "BAHUA",
            "BHITAURA",
            "DEOMAI",
            "DHATA",
            "HASAWA",
            "HATHGAOM",
            "KHAJUHA",
            "MALAWAN",
            "NAGAR BINDKI",
            "NAGAR FATEHPUR",
            "TELIYANI",
            "VIJAIPUR",
        ],
        FIROZABAD: [
            "ARAWN",
            "EKA",
            "FIROZABAD",
            "JASRANA",
            "KHAIRGARH",
            "MADANPUR",
            "NARKHI",
            "SHIKOHABAD",
            "T.A. FIROZABAD",
            "T.A. SHIKOHABAD",
            "TUNDLA",
        ],
        "GAUTAM BUDDHA NAGAR": ["DADRI", "DANKAUR", "JEWAR", "VISRAKH"],
        GHAZIABAD: [
            "BHOJPUR",
            "BHOJPUR TA(MODINAGAR)",
            "GHAZIABAD (MUN.AREA)",
            "LONI",
            "MURAD NAGAR",
            "RAZAPUR",
        ],
        GHAZIPUR: [
            "BARACHAWAR",
            "BHADAURA",
            "BHAWARCOL",
            "BIRNO",
            "DEOKALI",
            "GHAZIPUR SADAR",
            "KARANDA",
            "KASIMABAD",
            "MANIHARI",
            "MARDAH",
            "MOHAMMADABAD",
            "NAGAR CHHETRA",
            "REOTIPUR",
            "SADAT",
            "SAIDPUR",
            "ZAKHANIA",
            "ZAMANIA",
        ],
        GONDA: [
            "BABHANJOT",
            "BELSAR",
            "CHHAPIA",
            "COLONELGANJ",
            "CORNELGANJ(M.C.)",
            "GONDA(MUN. CORP.)",
            "HALDHARMAU",
            "ITIYATHOK",
            "JHANJHRI",
            "KATRA BAZAR",
            "MANKAPUR",
            "MUJEHNA",
            "NAWAB GANJ",
            "NAWABGANJ(MUN.CORP.)",
            "PANDRI KRIPAL",
            "PARASPUR",
            "RUPAIDEEH",
            "TARABGANJ",
            "WAZIRGANJ",
        ],
        GORAKHPUR: [
            "BAANSGAON",
            "BADHALGANJ",
            "BELGHAT",
            "BHAROHIYA",
            "BHATHAT",
            "BRAHMAPUR",
            "CAMPIARGANJ",
            "CHARGANWA",
            "GAGAHA",
            "GOLA",
            "JANGAL KAUDIA",
            "KAUDIRAM",
            "KHAJNI",
            "KHORABAR",
            "NAGAR KSHETRA",
            "PALI",
            "PIPRAICH",
            "PIPRAULI",
            "SAHJANWA",
            "SARDARNAGAR",
            "URUWA",
        ],
        "HAMIRPUR (U.P.)": [
            "GOHAND",
            "KURARA",
            "MAUDHA",
            "MUSKARA",
            "NP HAMIRPUR",
            "NP MAUDAHA",
            "NP RATH",
            "RATH",
            "SARILA",
            "SUMERPUR",
        ],
        "HAPUR (PANCHSHEEL NAGAR)": [
            "DHAULANA",
            "GARH MUKTESWAR",
            "HAPUR",
            "HAPUR (MUN.AREA)",
            "PILKHUWA (MUN.AREA)",
            "SIMBHAWALI",
        ],
        HARDOI: [
            "AHIRORI",
            "BAWAN",
            "BEHANDAR",
            "BHARAWAN",
            "BHARKHANI",
            "BILGRAM",
            "HARIYAWAN",
            "HARPALPUR",
            "KACHAUNA",
            "KOTHAWAN",
            "MADHOGANJ",
            "MALLAWA",
            "PIHANI",
            "SANDI",
            "SANDILA",
            "SHAHABAD",
            "SURSA",
            "TANDIYAWA",
            "TN.AR.  PIHANI",
            "TN.AR.  SANDI",
            "TN.AR. BILGRAM",
            "TN.AR. HARDOI",
            "TN.AR. SANDILA",
            "TN.AR. SHAHABAD",
            "TONDARPUR",
        ],
        HATHRAS: [
            "HASAYAN",
            "HATHRAS",
            "MURSAN",
            "N.P. HATHRAS",
            "N.P. SIKANDRARAO",
            "SADABAD",
            "SAHPAU",
            "SASNI",
            "SIKANDRA RAO",
        ],
        JALAUN: [
            "DAKOR",
            "JALAUN",
            "KADAURA",
            "KONCH",
            "KUTHAUND",
            "MADHAUGADH",
            "MAHEVA",
            "NADIGAWN",
            "RAMPURA",
            "T. A. JALAUN",
            "T. A. KALPI",
            "T. A. KONCH",
            "T. A. ORAI",
        ],
        JAUNPUR: [
            "BADLA PUR",
            "BARSATHI",
            "BUKSHA",
            "DHARMAPUR",
            "DOBHI",
            "JALALPUR",
            "JAUNPUR  [NAGAR]",
            "KARANJA KALA",
            "KERAKAT",
            "KHUTHAN",
            "MACHHALI SHAHAR",
            "MADIYAHUN",
            "MAHARAJ GANJ",
            "MUFTI GANJ",
            "MUGRA BADSHAH PUR",
            "RAM NAGAR",
            "RAM PUR",
            "SHAH GANJ",
            "SIKRARA",
            "SIRKONI",
            "SUITHA KALA",
            "SUJAN GANJ",
        ],
        JHANSI: [
            "BABINA",
            "BAMORE",
            "BANGRA",
            "BARAGAON",
            "CHIRGAON",
            "GURSARAI",
            "JHANSI NAGARCHETRA",
            "MAURANIPUR",
            "MAURANIPUR  N.CHETRA",
            "MOTH",
        ],
        "JYOTIBA PHULE NAGAR (AMROHA)": [
            "AMROHA",
            "AMROHA CITY",
            "DHANORA",
            "GAJRAULA",
            "GANGESHWARI",
            "HASANPUR",
            "HASANPUR CITY",
            "JOYA",
        ],
        KANNAUJ: [
            "CHHIBRAMAU",
            "GUGRAPUR",
            "HASERAN",
            "JALALABAD",
            "KANNAUJ",
            "KANNAUJ CITY",
            "SAURIKH",
            "TAL GRAM",
            "UMARDA",
        ],
        "KANPUR DEHAT": [
            "AKBARPUR",
            "AMARAUDHA",
            "DERAPUR",
            "JHINJHAK",
            "MAITHA",
            "MALASA",
            "RAJPUR",
            "RASULABAD",
            "SANDALPUR",
            "SARVANKHERA",
        ],
        "KANPUR NAGAR": [
            "BHITERGAON",
            "BIDHNU",
            "BILHAUR",
            "CHAUBEPUR",
            "GHATAMPUR",
            "KAKWAN",
            "KALYANPUR",
            "KIDWAI NAGAR",
            "PATARA",
            "PREMNAGAR",
            "SADAR BAZAR",
            "SARSAUL",
            "SHASTRI NAGAR",
            "SHIVRAJPUR",
        ],
        KASGANJ: [
            "AMANPUR",
            "GANJ DUNDWARA",
            "GANJDUNDWARA(URBAN)",
            "KASGANJ",
            "KASGANJ (URBAN)",
            "PATIYALI",
            "SAHAVAR",
            "SIDHPURA",
            "SORON",
            "SORON (URBAN)",
        ],
        KAUSHAMBI: [
            "CHAYAL",
            "KADA",
            "KAUSHAMBI",
            "MANJHANPUR",
            "MURATGANJ",
            "NEWADA",
            "SARSAWAN",
            "SIRATHU",
        ],
        KHERI: [
            "BANKEGANJ",
            "BEHJAM",
            "BIJUA",
            "DHAURAHARA",
            "GOLA",
            "ISANAGAR",
            "KUMBHI-GOLA",
            "LAKHIMPUR",
            "LMP",
            "MITAULI",
            "MOHAMMADI",
            "MOM",
            "NAKAHA",
            "NIGHASAN",
            "PAL",
            "PALIYA",
            "PASGAWAN",
            "PHOOL BEHAR",
            "RAMIYA BEHAR",
        ],
        KUSHINAGAR: [
            "DUDAHI",
            "FAZIL NAGAR",
            "HATA",
            "KAPTANGANJ",
            "KASIA",
            "KHADDA",
            "MOTICHAK",
            "NAURANGIYA",
            "PADARAUNA",
            "PADRAUNA (URBAN)",
            "RAMKOLA",
            "SEORAHI",
            "SUKRAULI",
            "TAMKUHI",
            "VISHUNPURA",
        ],
        LALITPUR: [
            "BAR",
            "BIRDHA",
            "JAKHORA",
            "LALITPUR",
            "MADAWRA",
            "MAHRONI",
            "TALBEHAT",
        ],
        LUCKNOW: [
            "BAKSHI KA TALAB",
            "CHINHAT",
            "GOSHAI GANJ",
            "KAKORI",
            "MAAL",
            "MALIHABAD",
            "MOHAN LAL GANJ",
            "NAGAR SHAITRA, LUCKNOW",
            "SAROJNI NAGAR",
        ],
        MAHARAJGANJ: [
            "BRIJMAN GANJ",
            "DHANI",
            "GHUGHLI",
            "LAKSHMIPUR",
            "MAHRAJGANJ",
            "MITHOURA",
            "NICHLOUL",
            "NOUTANWA",
            "PANIYARA",
            "PARTAWAL",
            "PHARENDA",
            "SISWA",
        ],
        MAHOBA: [
            "CHARKHARI",
            "CHARKHARI URBAN",
            "JAITPUR",
            "KABRAI",
            "NAGAR PALIKA MAHOBA",
            "PANWARI",
        ],
        MAINPURI: [
            "BARNAHAL",
            "BEWAR",
            "GHIROR",
            "JAGIR",
            "KARHAL",
            "KISHANI",
            "KURAWALI",
            "MAINPURI",
            "MAINPURI-CITY",
            "SULTANGANJ",
        ],
        MATHURA: [
            "BALDEO",
            "CHAUMUHAN",
            "CHHATA",
            "FARAH",
            "GOVERDHAN",
            "MANT",
            "MATHURA",
            "NANDGAON",
            "NOHJHEEL",
            "RAYA",
            "T.A. KOSIKALAN",
            "T.A. MATHURA",
            "T.A. VRINDAVAN",
        ],
        MAU: [
            "BADRAW",
            "DOHRIGHAT",
            "FATEHPUR MANDAON",
            "GHOSI",
            "KOPAGANG",
            "MOHAMMADABAD",
            "NAGAR KSHETRA MAU",
            "PARDAHA",
            "RANIPUR",
            "RATANPURA",
        ],
        MEERUT: [
            "DAURALA",
            "HASTINAPUR",
            "JANI",
            "KHARKHODA",
            "MACHRA",
            "MAWANA",
            "MAWANA NAGAR",
            "MEERUT",
            "MEERUT NAGAR",
            "PARIKSHIT GARH",
            "RAJPURA",
            "ROHTA",
            "SARDHANA",
            "SARURPUR",
        ],
        MIRZAPUR: [
            "CHHANBEY",
            "HALIA",
            "JAMALPUR",
            "KONE",
            "LALGANJ",
            "MAJHAWA",
            "MARIHAN",
            "NAGAR",
            "NAGAR PALIKA",
            "NARAYANPUR",
            "PAHARI",
            "RAJGARH",
            "SEEKHAR",
        ],
        MORADABAD: [
            "BHAGATPUR TANDA",
            "BILARI",
            "CHAJLET",
            "DILARI",
            "KUNDERKI",
            "MORADABAD",
            "MORADABAD CITY BOYS",
            "MORADABAD CITY GIRLS",
            "MUNDAPANDAY",
            "THAKURDWARA",
        ],
        MUZAFFARNAGAR: [
            "BAGHRA",
            "BUDHANA",
            "CHARTHAWAL",
            "JANSATH",
            "KHATAULI",
            "MORNA",
            "PURKAJI",
            "SADAR",
            "SADAR [TOWN AREA]",
            "SHAHPUR",
        ],
        PILIBHIT: [
            "AMARIA",
            "BARKHERA",
            "BILSANDA",
            "BISALPUR",
            "LALORIKHERA",
            "MARORI",
            "N. P. BISALPUR",
            "N. P. PILIBHIT",
            "PURANPUR",
        ],
        PRATAPGARH: [
            "AASPUR-DEOSARA",
            "BABA BHELKHARNATH",
            "BABAGANJ",
            "BIHAR",
            "CITY(PRATAPGARH BELHA)",
            "GAURA",
            "KALAKANKER",
            "KUNDA",
            "LALGANJ",
            "LAXMANPUR",
            "MANDHATA",
            "MANGRAURA",
            "PATTI",
            "RAMPUR-SANGRAMGARH",
            "SADAR",
            "SADWA-CHANDRIKA",
            "SANGIPUR",
            "SHIVGARH",
        ],
        PRAYAGRAJ: [
            "BAHADURPUR",
            "BAHARIYA",
            "CHAKA",
            "DHANUPUR",
            "HANDIA",
            "HOLAGARH",
            "JASARA",
            "KARCHHANA",
            "KAUDIHAR II",
            "KAUNDHIYARA",
            "KAURIHAR- I",
            "KORAON",
            "MANDA",
            "MAUAIMA",
            "MEJA",
            "NAGAR CHHETRA",
            "PHOOLPUR",
            "PRATAP PUR",
            "SAIDABAD",
            "SHANKAR GARH",
            "SORAON",
            "URUWA",
        ],
        "RAE BARELI": [
            "AMAWAN",
            "BACHHRAWAN",
            "CHHATOH",
            "DALMAU",
            "DEEH",
            "GAURA",
            "HARCHANDPUR",
            "JAGATPUR",
            "KHIRON",
            "LALGANJ",
            "MAHRAJGANJ",
            "NAGAR SHETRA (RBL)",
            "RAHI",
            "ROHANIYA",
            "SALON",
            "SARENI",
            "SATAON",
            "SHIVGARH",
            "UNCHAHAR",
        ],
        RAMPUR: [
            "BILASPUR",
            "CHAMRAUVA",
            "MILAK",
            "SAID NAGAR",
            "SHAHBAD",
            "SUAR",
            "TOWN AREA RAMPUR",
        ],
        SAHARANPUR: [
            "BALIA KHEDI",
            "DEOBAND",
            "GANGOH",
            "MUZAFFARABAD",
            "NAGAL",
            "NAKUR",
            "NANAUTA",
            "PUNWARKA",
            "RAMPUR MANIHARAN",
            "SADHOLI KADIM",
            "SARSAVA",
            "T.A. DEOBAND",
            "T.A. GANGOH",
            "T.A. SAHAHRANPUR",
        ],
        "SAMBHAL (BHIM NAGAR)": [
            "ASMOLI",
            "BANIYAKHERA",
            "BEHJOI",
            "CHANDAUSI CITY",
            "GUNNOR",
            "JUNAVAI",
            "PAWANSA",
            "RAJPURA",
            "SAMBHAL",
            "SAMBHAL CITY",
        ],
        "SANT KABIR NAGAR": [
            "BAGHAULI",
            "BELHAR KALA",
            "HAINSAR BAZAR",
            "KHALILABAD",
            "MEHNDAVAL",
            "NATHNAGAR",
            "PAULI",
            "SANTHA",
            "SEMARINYAVA",
        ],
        SHAHJAHANPUR: [
            "BANDA",
            "BHAWALKHERA",
            "DADRAUL",
            "JAITIPUR",
            "JALALABAD",
            "KALAN",
            "KANTH",
            "KATRA KHUDAGANJ",
            "KHUTAR",
            "MADNAPUR",
            "MIRJAPUR",
            "NIGOHI",
            "PUWAYA",
            "SINDHAULI",
            "T.A.SHAHJAHANPUR",
            "T.A.TILHAR",
            "TILHAR",
        ],
        "SHAMLI (PRABUDH NAGAR)": [
            "KAIRANA",
            "KAIRANA [TOWN AREA]",
            "KANDHLA",
            "KANDHLA [TOWN AREA]",
            "OON",
            "SHAMLI",
            "SHAMLI [TOWN AREA]",
            "THANABHAWAN",
        ],
        SHRAWASTI: [
            "GILAULA",
            "HARIHARPUR RANI",
            "IKAUNA",
            "JAMUNHA",
            "SIRSIYA",
        ],
        SIDDHARTHNAGAR: [
            "BANSI",
            "BARHANI",
            "BHANVAPUR",
            "BIRDPUR",
            "DUMARIYAGANJ",
            "ITAVA",
            "JOGIYA",
            "KHESARAHA",
            "KHUNIYANV",
            "LOTAN",
            "MITHAVAL",
            "NAUGARH",
            "SHOHARATGARH",
            "USKA BAZAR",
        ],
        SITAPUR: [
            "ALIYA",
            "BEHTA",
            "BISWAN",
            "GONDLAMAU",
            "HARGAON",
            "KASMANDA",
            "KHAIRABAD",
            "LAHARPUR",
            "MACHHAREHTA",
            "MAHMOODABAD",
            "MAHOLI",
            "MISRIKH",
            "N.K.BISWAN",
            "N.K.KHAIRABAD",
            "N.K.MISRIKH",
            "N.K.SITAPUR",
            "PAHALA",
            "PARSENDI",
            "PISAWAN",
            "RAMPURMATHURA",
            "REUSA",
            "SAKARAN",
            "SIDHAULI",
        ],
        SONBHADRA: [
            "BABHANI",
            "CHATRA",
            "CHOPAN",
            "DUDHI",
            "GHORAWAL",
            "MYORPUR",
            "NAGWA",
            "ROBERTSGANJ",
        ],
        SULTANPUR: [
            "AKHANDNAGAR",
            "BALDIRAI",
            "BHADAIYAN",
            "DHANPATGANJ",
            "DOSTPUR",
            "DUBEYPUR",
            "JAISINGHPUR",
            "KADIPUR",
            "KARAUNDI KALA",
            "KUREBHAR",
            "KURWAR",
            "LAMBHUA",
            "MOTIGARPUR",
            "PP KAMAICHA",
            "SULTANPUR CITY",
        ],
        UNNAO: [
            "ASOHA",
            "AURAS",
            "BAGARMAU",
            "BICHHIYA",
            "BIGHAPUR",
            "CITI AREA",
            "FATEHPUR 84",
            "GANGMURADABAD",
            "HASANGANJ",
            "HILOULI",
            "MIYAGANJ",
            "NAVABGANJ",
            "PURWA",
            "SAFIPUR",
            "SIKANDERPUR KARN",
            "SIKANDERPUR SAROSI",
            "SUMERPUR",
        ],
        VARANASI: [
            "ARAJILINES",
            "BARAGAON",
            "CHIRAIGAON",
            "CHOLAPUR",
            "HARHUA",
            "KASHIVIDYAPEETH",
            "NAGAR NIGAM",
            "NAGAR PALIKA RAMNAGAR",
            "PINDRA",
            "SEWAPURI",
        ],
    },
    UT: {
        ALMORA: [
            "BHAISIYACHHANA",
            "BHIKIYASAIN",
            "CHAUKHUTIYA",
            "DHAULADEVI",
            "DWARAHAT",
            "HAWALBAG",
            "LAMGARAH",
            "SALT",
            "SYALDEY",
            "TAKULA",
            "TARIKHET",
        ],
        BAGESHWAR: ["BAGESHWAR", "GARUR", "KAPKOTE"],
        CHAMOLI: [
            "DASHOLI",
            "DEWAL",
            "GAIRSAIN",
            "JOSHIMATH",
            "KARANPRAYAG",
            "NANDANAGAR",
            "NARAYANBAGAR",
            "POKHARI",
            "THARALI",
        ],
        CHAMPAWAT: ["BARAKOT", "CHAMPAWAT", "LOHAGHAT", "PATI"],
        DEHRADUN: [
            "CHAKRATA",
            "DOIWALA",
            "KALSI",
            "RAIPUR",
            "SAHASPUR",
            "VIKASNAGAR",
        ],
        HARDWAR: [
            "BAHADARABAD",
            "BHAGWANPUR",
            "KHANPUR",
            "LAKSAR",
            "NARSAN",
            "ROORKEE",
        ],
        NAINITAL: [
            "BETAALGHAT",
            "BHIMTAL",
            "DHARI",
            "HALDWANI",
            "KOTABAGH",
            "OKHALKANDA",
            "RAMGARH",
            "RAMNAGAR",
        ],
        PAURI: [
            "BIRONKHAL",
            "DUGADDA",
            "DWARIKAHL",
            "EKESHWAR",
            "JAIHARIKHAL",
            "KALJIKHAL",
            "KHIRSU",
            "KOT",
            "NAINIDANDA",
            "PABAU",
            "PAURI",
            "POKHRA",
            "RIKHANIKHAL",
            "THALISAIN",
            "YAMKESHWAR",
        ],
        PITHORAGARH: [
            "BERINAG",
            "BIN",
            "DHARCHULA",
            "DIDIHAT",
            "GANGOLIHAT",
            "KANALICHHEENA",
            "MOONAKOT",
            "MUNSYARI",
        ],
        RUDRAPRAYAG: ["AUGUSTYAMUNI", "JAKHOLI", "UKHIMATH"],
        "TEHRI GARHWAL": [
            "BHILANGANA",
            "CHAMBA",
            "DEVPRAYAG",
            "JAKHNIDHAR",
            "JOUNPUR",
            "KEERTINAGAR",
            "NARENDRANAGAR",
            "PRATAPNAGAR",
            "THOULDHAR",
        ],
        "UDHAM SINGH NAGAR": [
            "BAZPUR",
            "GADARPUR",
            "JASPUR",
            "KASHIPUR",
            "KHATIMA",
            "RUDRAPUR",
            "SITARGANJ",
        ],
        UTTARKASHI: [
            "BHATWARI",
            "CHINYALISAUR",
            "DUNDA",
            "MORI",
            "NAUGAON",
            "PUROLA",
        ],
    },
    WB: {
        ALIPURDUAR: [
            "ALIPURDUAR MUNICIPALITY",
            "ALIPURDUAR-I",
            "ALIPURDUAR-II",
            "FALAKATA",
            "FALAKATA MUNICIPALITY",
            "KALCHINI",
            "KUMARGRAM",
            "MADARIHAT",
        ],
        BANKURA: [
            "BANKURA MUNICIPALITY",
            "BANKURA-I",
            "BANKURA-II",
            "BARJORA",
            "BISHNUPUR",
            "BISHNUPUR MUNICIPALITY",
            "CHHATNA",
            "GANGAJAL GHATI",
            "HIRBANDH [KHATRA-II]",
            "INDAS",
            "INDPUR",
            "JOYPUR",
            "KHATRA-I",
            "KOTULPUR",
            "MEJHIA",
            "ONDA",
            "PATRASAYER",
            "RAIPUR-I",
            "RANIBANDH",
            "SALTORA",
            "SARENGA [RAIPUR-II]",
            "SIMLAPAL",
            "SONAMUKHI",
            "SONAMUKHI MUNICIPALITY",
            "TALDANGRA",
        ],
        BIRBHUM: [
            "BOLPUR MUNICIPALITY",
            "BOLPUR SRINIKETAN",
            "DUBRAJPUR",
            "DUBRAJPUR MUNICIPALITY",
            "ILLAMBAZAR",
            "KHOYRASOLE",
            "LABPUR",
            "MAYURESWAR-I",
            "MAYURESWAR-II",
            "MD. BAZAR",
            "MURARAI-I",
            "MURARAI-II",
            "NALHATI MUNICIPALITY",
            "NALHATI-I",
            "NALHATI-II",
            "NANOOR",
            "RAJNAGAR",
            "RAMPURHAT MUNICIPALITY",
            "RAMPURHAT-I",
            "RAMPURHAT-II",
            "SAINTHIA",
            "SAINTHIA MUNICIPALITY",
            "SURI MUNICIPALITY",
            "SURI-I",
            "SURI-II",
        ],
        COOCHBEHAR: [
            "COOCH BEHAR MUNICIPALITY",
            "COOCH BEHAR-I",
            "COOCH BEHAR-II",
            "DINHATA MUNICIPALITY",
            "DINHATA-I",
            "DINHATA-II",
            "HALDIBARI",
            "HALDIBARI MUNICIPALITY",
            "MATHABHANGA MUNICIPALITY",
            "MATHABHANGA-I",
            "MATHABHANGA-II",
            "MEKHLIGANJ",
            "MEKHLIGANJ MUNICIPALITY",
            "SITAI",
            "SITALKUCHI",
            "TUFANGANJ MUNICIPALITY",
            "TUFANGANJ-I",
            "TUFANGANJ-II",
        ],
        "DAKSHIN DINAJPUR": [
            "BALURGHAT",
            "BALURGHAT MUNICIPALITY",
            "BANSHIHARI",
            "BUNIADPUR MUNICIPALITY",
            "GANGARAMPUR",
            "GANGARAMPUR MUNICIPALITY",
            "HARIRAMPUR",
            "HILI",
            "KUMARGANJ",
            "KUSHMONDI",
            "TAPAN",
        ],
        DARJILING: [
            "DARJEELING MUNICIPALITY",
            "DARJEELING PULBAZAR",
            "JOREBUNGLOW SUKHIA",
            "KURSEONG",
            "KURSEONG MUNICIPALITY",
            "MIRIK",
            "MIRIK MUNICIPALITY",
            "RANGLI RANGLIOT",
        ],
        HOOGHLY: [
            "ARAMBAGH",
            "ARAMBAGH  MUNICIPALITY",
            "BAIDYABATI  MUNICIPALITY",
            "BALAGARH",
            "BANSBERIA MUNICIPALITY",
            "BHADRESWAR  MUNICIPALITY",
            "CHAMPDANI  MUNICIPALITY",
            "CHANDANNAGORE CORPORATION",
            "CHANDITALA-I",
            "CHANDITALA-II",
            "CHINSURAH-MOGRA",
            "DANKUNI  MUNICIPALITY",
            "DHANIAKHALI",
            "GOGHAT-I",
            "GOGHAT-II",
            "HARIPAL",
            "HOOGHLY-CHINSURAH MUNICIPALITY",
            "JANGIPARA",
            "KHANAKUL-I",
            "KHANAKUL-II",
            "KONNAGAR  MUNICIPALITY",
            "PANDUA",
            "POLBA-DADPUR",
            "PURSURAH",
            "RISHRA  MUNICIPALITY",
            "SERAMPORE  MUNICIPALITY",
            "SERAMPUR-UTTARPARA",
            "SINGUR",
            "TARAKESWAR",
            "TARAKESWAR  MUNICIPALITY",
            "UTTARPARA KOTRANG",
        ],
        HOWRAH: [
            "AMTA-I",
            "AMTA-II",
            "BAGNAN-I",
            "BAGNAN-II",
            "BALLY MUNICIPALITY",
            "BALLY- JAGACHA",
            "DOMJUR",
            "HOWRAH MUNICIPAL CORPORATION",
            "JAGATBALLAVPUR",
            "PANCHLA",
            "SANKRAIL",
            "SHYAMPUR-I",
            "SHYAMPUR-II",
            "UDAYNARAYANPUR",
            "ULUBERIA MUNICIPALITY",
            "ULUBERIA-I",
            "ULUBERIA-II",
        ],
        JALPAIGURI: [
            "DHUPGURI",
            "DHUPGURI MUNICIPALITY",
            "JALPAIGURI MUNICIPALITY",
            "JALPAIGURI SADAR",
            "MAL",
            "MAL MUNICIPALITY",
            "MATELLI",
            "MAYNAGURI",
            "NAGRAKATA",
            "RAJGANJ",
            "SILIGURI CORPORATION",
        ],
        JHARGRAM: [
            "BINPUR-1",
            "BINPUR-2",
            "GOPIBALLAVPUR-1",
            "GOPIBALLAVPUR-2",
            "JAMBONI",
            "JHARGRAM",
            "JHARGRAM(MN)",
            "NAYAGRAM",
            "SANKRAIL",
        ],
        KALIMPONG: [
            "GORUBATHAN",
            "KALIMPONG MUNICIPALITY",
            "KALIMPONG-I",
            "KALIMPONG-II",
        ],
        KOLKATA: ["KOLKATA MUNICIPAL CORPORATION"],
        MALDAH: [
            "BAMONGOLA",
            "CHANCHAL-1",
            "CHANCHAL-2",
            "ENGLISH BAZAR(BLOCK)",
            "ENGLISHBAZAR(MNC)",
            "GAZOLE",
            "HABIBPUR",
            "HARISHCHANDRAPUR-1",
            "HARISHCHANDRAPUR-2",
            "KALIACHAK-1",
            "KALIACHAK-2",
            "KALIACHAK-3",
            "MANIKCHAK",
            "OLD MALDA(BLOCK)",
            "OLD MALDA(MNC)",
            "RATUA-1",
            "RATUA-2",
        ],
        MURSHIDABAD: [
            "BARWAN",
            "BELDANGA (M)",
            "BELDANGA-I",
            "BELDANGA-II",
            "BERHAMPORE",
            "BERHAMPORE (M)",
            "BHAGAWANGOLA-I",
            "BHAGAWANGOLA-II",
            "BHARATPUR-I",
            "BHARATPUR-II",
            "DHULIYAN (M)",
            "DOMKAL",
            "DOMKAL (M)",
            "FARAKKA",
            "HARIHARPARA",
            "JALANGI",
            "JANGIPUR (M)",
            "JIAGANJ-AZIMGANJ (M)",
            "KANDI",
            "KANDI (M)",
            "KHARGRAM",
            "LALGOLA",
            "MURSHIDABAD (M)",
            "MURSHIDABAD-JIAGANJ (M.J)",
            "NABAGRAM",
            "NOWDA",
            "RAGHUNATHGANJ-I",
            "RAGHUNATHGANJ-II",
            "RANINAGAR-I",
            "RANINAGAR-II",
            "SAGARDIGHI",
            "SAMSERGANJ",
            "SUTI-I",
            "SUTI-II",
        ],
        NADIA: [
            "BIRNAGAR MUNICIPALITY",
            "CHAKDAH",
            "CHAKDAH MUNICIPALITY",
            "CHAPRA",
            "GAYESHPUR MUNICIPALITY",
            "HANSKHALI",
            "HARINGHATA",
            "HARINGHATA MUNICIPALITY",
            "KALIGANJ",
            "KALYANI",
            "KALYANI MUNICIPALITY",
            "KARIMPUR - I",
            "KARIMPUR - II",
            "KRISHNAGANJ",
            "KRISHNAGAR - I",
            "KRISHNAGAR - II",
            "KRISHNAGAR MUNICIPALITY",
            "NABADWIP",
            "NABADWIP MUNICIPALITY",
            "NAKASHIPARA",
            "RANAGHAT - I",
            "RANAGHAT - II",
            "RANAGHAT COOPERS NAA",
            "RANAGHAT MUNICIPALITY",
            "SANTIPUR",
            "SANTIPUR MUNICIPALITY",
            "TEHARPUR NAA",
            "TEHATTA - I",
            "TEHATTA - II",
        ],
        "NORTH TWENTY FOUR PARGANA": [
            "AMDANGA",
            "ASHOKENAGAR-KALYANGARH MUNICIPALITY",
            "BADURIA",
            "BADURIA MUNICIPALITY",
            "BAGDAH",
            "BARANAGAR MUNICIPALITY",
            "BARASAT - I",
            "BARASAT - II",
            "BARASAT MUNICIPALITY",
            "BARRACKPORE - I",
            "BARRACKPORE - II",
            "BARRACKPORE CANTONMENT BOARD",
            "BARRACKPORE MUNICIPALITY",
            "BASIRHAT - I",
            "BASIRHAT - II",
            "BASIRHAT MUNICIPALITY",
            "BHATPARA MUNICIPALITY",
            "BIDHAN NAGAR MUNICIPAL CORPORATION",
            "BONGAON",
            "BONGAON MUNICIPALITY",
            "DEGANGA",
            "DUM DUM MUNICIPALITY",
            "GAIGHATA",
            "GARULIA MUNICIPALITY",
            "GOBORDANGA MUNICIPALITY",
            "HABRA - I",
            "HABRA - II",
            "HABRA MUNICIPALITY",
            "HALISAHAR MUNICIPALITY",
            "HAROA",
            "HASNABAD",
            "HINGALGANJ",
            "KAMARHATTI MUNICIPALITY",
            "KANCHRAPARA MUNICIPALITY",
            "KHARDAHA MUNICIPALITY",
            "MADHYAMGRAM MUNICIPALITY",
            "MINAKHAN",
            "NAIHATI MUNICIPALITY",
            "NEW BARRACKPORE MUNICIPALITY",
            "NORTH BARRACKPORE MUNICIPALITY",
            "NORTH DUM DUM MUNICIPALITY",
            "PANIHATI MUNICIPALITY",
            "RAJARHAT",
            "SANDESHKHALI - I",
            "SANDESHKHALI - II",
            "SOUTH DUM DUM MUNICIPALITY",
            "SWARUPNAGAR",
            "TAKI MUNICIPALITY",
            "TITAGARH MUNICIPALITY",
        ],
        "PASCHIM BARDHAMAN": [
            "ANDAL",
            "ASANSOL MUNICIPAL CORPORATION",
            "BARABANI",
            "DURGAPUR MUNICIPAL CORPORATION",
            "DURGAPUR-FARIDPUR",
            "JAMURIA",
            "KANKSA",
            "PANDABESWAR",
            "RANIGANJ",
            "SALANPUR",
        ],
        "PASCHIM MEDINIPUR": [
            "CHANDRAKONA(MN)",
            "CHANDRAKONA-1",
            "CHANDRAKONA-2",
            "DANTAN-1",
            "DANTAN-2",
            "DASPUR-1",
            "DASPUR-2",
            "DEBRA",
            "GARHBETA-1",
            "GARHBETA-2",
            "GARHBETA-3",
            "GHATAL",
            "GHATAL(MN)",
            "KESHIARY",
            "KESHPUR",
            "KHARAGPUR(MN)",
            "KHARAGPUR-1",
            "KHARAGPUR-2",
            "KHARAR(MN)",
            "KHIRPAI(MN)",
            "MIDNAPORE SADAR",
            "MIDNAPORE(MN)",
            "MOHANPUR",
            "NARAYANGARH",
            "PINGLA",
            "RAMJIBANPUR(MN)",
            "SABONG",
            "SALBONI",
        ],
        "PURBA BARDHAMAN": [
            "AUSGRAM-I",
            "AUSGRAM-II",
            "BHATAR",
            "BURDWAN MUNICIPALITY",
            "BURDWAN-I",
            "BURDWAN-II",
            "DAINHAT MUNICIPALITY",
            "GALSI-I",
            "GALSI-II",
            "GUSHKARA MUNICIPALITY",
            "JAMALPUR",
            "KALNA MUNICIPALITY",
            "KALNA-I",
            "KALNA-II",
            "KATWA MUNICIPALITY",
            "KATWA-I",
            "KATWA-II",
            "KETUGRAM-I",
            "KETUGRAM-II",
            "KHANDOGHOSH",
            "MEMARI MUNICIPALITY",
            "MEMARI-I",
            "MEMARI-II",
            "MONGALKOTE",
            "MONTESWAR",
            "PURBASTHALI-I",
            "PURBASTHALI-II",
            "RAINA-I",
            "RAINA-II",
        ],
        "PURBA MEDINIPUR": [
            "BHAGWANPUR -I",
            "BHAGWANPUR -II",
            "CHANDIPUR",
            "CONTAI -I",
            "CONTAI -II",
            "CONTAI -III",
            "CONTAI MUNICIPALITY",
            "EGRA -I",
            "EGRA -II",
            "EGRA MUNICIPALITY",
            "HALDIA",
            "HALDIA MUNICIPALITY",
            "KHEJURI -I",
            "KHEJURI -II",
            "MAHISADAL",
            "MOYNA",
            "NANDAKUMAR",
            "NANDIGRAM -I",
            "NANDIGRAM -II",
            "PANSKURA -I",
            "PANSKURA -II",
            "PANSKURA MUNICIPALITY",
            "PATASHPUR -I",
            "PATASHPUR -II",
            "RAMNAGAR -I",
            "RAMNAGAR -II",
            "SAHID MATANGINI",
            "SUTAHATA",
            "TAMLUK",
            "TAMLUK MUNICIPALITY",
        ],
        PURULIYA: [
            "ARSHA",
            "BAGHMUNDI",
            "BALARAMPUR",
            "BANDWAN",
            "BARABAZAR",
            "HURA",
            "JHALDA(M)",
            "JHALDA-I",
            "JHALDA-II",
            "JOYPUR",
            "KASHIPUR",
            "MANBAZAR-I",
            "MANBAZAR-II",
            "NETURIA",
            "PARA",
            "PUNCHA",
            "PURULIA(M)",
            "PURULIA-I",
            "PURULIA-II",
            "RAGHUNATHPUR(M)",
            "RAGHUNATHPUR-I",
            "RAGHUNTHPUR-II",
            "SANTURI",
        ],
        SILIGURI: [
            "KHORIBARI",
            "MATIGARA",
            "NAXALBARI",
            "PHANSIDEWA",
            "SILIGURI MUNICIPAL CORPORATION",
        ],
        "SOUTH  TWENTY FOUR PARGANA": [
            "BARUIPUR",
            "BARUIPUR MUNICIPALITY",
            "BASANTI",
            "BHANGORE - 1",
            "BHANGORE - 2",
            "BISHNUPUR - 1",
            "BISHNUPUR - 2",
            "BUDGE BUDGE - 1",
            "BUDGE BUDGE - 2",
            "BUDGE BUDGE MUNICIPALITY",
            "CANNING - 1",
            "CANNING - 2",
            "DIAMOND HARBOUR - 1",
            "DIAMOND HARBOUR - 2",
            "DIAMOND HARBOUR MUNICIPALITY",
            "FALTA",
            "GOSABA",
            "JOYNAGAR - 1",
            "JOYNAGAR - 2",
            "JOYNAGAR MAZILPUR MUNICIPALITY",
            "KAKDWIP",
            "KULPI",
            "KULTALI",
            "MAGRAHAT - 1",
            "MAGRAHAT - 2",
            "MAHESHTALA MUNICIPALITY",
            "MANDIRBAZAR",
            "MATHURAPUR - 1",
            "MATHURAPUR - 2",
            "NAMKHANA",
            "PATHARPRATIMA",
            "PUJALI MUNICIPALITY",
            "RAJPUR SONARPUR MUNICIPALITY",
            "SAGAR",
            "SONARPUR",
            "THAKURPUKUR MAHESHTALA",
        ],
        "UTTAR DINAJPUR": [
            "CHOPRA",
            "DALKHOLA MUNICIPALITY",
            "GOALPOKHER - I",
            "GOALPOKHER - II",
            "HEMTABAD",
            "ISLAMPUR",
            "ISLAMPUR MUNICIPALITY",
            "ITAHAR",
            "KALIYAGANJ",
            "KALIYAGANJ MUNICIPALITY",
            "KARANDIGHI",
            "RAIGANJ",
            "RAIGANJ MUNICIPALITY",
        ],
    },
};
